<template>
  <div>
    <nav aria-label="breadcrumb" class="content-block">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#/simpeg-dashboard">Dashboard</a>
        </li>
        <li class="breadcrumb-item">
          <a href="#/gaji-periode">Daftar Periode Penggajian</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">Daftar Gaji</li>
      </ol>
    </nav>

    <LogPopupTemplate ref="logPopup" />
    <div class="content-block">
      <div class="row" style="padding: 10px">
        <DxButton
          v-if="gajiPeriodeData"
          :text="buttonStatus('text')"
          :type="buttonStatus('type')"
          width="auto"
          height="18px"
          style="float: left"
          styling-mode="filled"
        />
        <div style="width: 20px"></div>
        <DxButton
          v-if="gajiPeriodeData"
          icon="eyeopen"
          text="Lihat Rumus Gaji"
          type="default"
          width="auto"
          styling-mode="outlined"
          @click="lihatRumusAll"
        />
        <div style="width: 20px"></div>
        <DxButton
          v-if="gajiPeriodeData"
          icon="download"
          text="Download File Excel"
          type="default"
          width="auto"
          styling-mode="outlined"
          @click="downloadFileExcel"
        />
        <div style="width: 20px"></div>
        <DxButton
          v-if="gajiPeriodeData"
          icon="print"
          text="Print Gaji"
          type="default"
          width="auto"
          styling-mode="outlined"
          @click="print"
        />
        <div style="width: 20px"></div>
        <DxButton
          v-if="gajiPeriodeData"
          icon="clock"
          text="Log Perubahan Data"
          type="default"
          width="auto"
          styling-mode="outlined"
          @click="this.$refs.logPopup.showAll(null, gajiPeriodeId, true)"
        />
      </div>
      <div class="row">
        <h5>
          Daftar Gaji Periode {{ periodeTitle }}
          <span v-if="gajiPeriodeData">
            <DxButton
              v-if="buttonCan('gaji-approve')"
              icon="check"
              @click="approveAllGajiAlert()"
              text="approve semua gaji"
              type="success"
              style="float: right"
              styling-mode="filled"
            ></DxButton>
            <DxButton
              v-if="buttonCan('gaji-approve')"
              icon="refresh"
              @click="requestRevisionAlert()"
              text="Request Revisi Gaji"
              type="danger"
              style="float: right"
              styling-mode="filled"
            ></DxButton>
            <DxButton
              v-if="buttonCan('gaji-create')"
              icon="refresh"
              @click="refreshAllGajiConfirm()"
              text="Hitung ulang seluruh gaji"
              type="danger"
              style="float: right"
              styling-mode="filled"
            ></DxButton>
            <!-- request approval cuma user gaji-create -->
            <DxButton
              v-if="buttonCan('gaji-create')"
              icon="check"
              @click="requestApprovalAlert()"
              text="Request approval"
              type="default"
              style="float: right"
              styling-mode="filled"
            ></DxButton>
          </span>
        </h5>
      </div>
    </div>

    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <DxButton
          hint="Refresh Notifikasi"
          icon="refresh"
          @click="refreshNotif()"
          type="default"
          style="float: right"
          styling-mode="outlined"
        ></DxButton>
        <div class="row row-cols-1 row-cols-md-5 g-4">
          <div class="col">
            <div
              class="card h-100"
              :style="{
                'background-color':
                  'rgba(119, 199, 231, ' + opacityJmlPegawai + ')',
                opacity: opacityJmlPegawai,
              }"
            >
              <div
                class="dashboard-card"
                style="color: black"
                @click="handleClickNotif('')"
              >
                <div class="card-body">
                  <h4
                    class="card-title"
                    style="font-weight: bold; color: aliceblue"
                  >
                    <div v-if="notif">
                      {{ notif["jmlPegawai"] }}
                    </div>
                  </h4>
                  <p
                    class="card-text"
                    style="font-weight: bold; font-size: 16px"
                  >
                    Jumlah Pegawai
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col">
            <div
              class="card h-100"
              :style="{
                'background-color':
                  'rgba(119, 199, 231, ' + opacityJmlPegawai + ')',
                opacity: opacityJmlPegawai,
              }"
            >
              <div
                class="dashboard-card"
                style="color: black"
                @click="handleClickNotif('')"
              >
                <div class="card-body">
                  <h4
                    class="card-title"
                    style="font-weight: bold; color: aliceblue"
                  >
                    <div v-if="notif">
                      {{ notif["jmlDewas"] }}
                    </div>
                  </h4>
                  <p
                    class="card-text"
                    style="font-weight: bold; font-size: 16px"
                  >
                    Jumlah Dewan Pengawas
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col">
            <div
              class="card h-100"
              :style="{
                'background-color':
                  'rgba(119, 199, 231, ' + opacityJmlPegawai + ')',
                opacity: opacityJmlPegawai,
              }"
            >
              <div
                class="dashboard-card"
                style="color: black"
                @click="handleClickNotif('')"
              >
                <div class="card-body">
                  <h4
                    class="card-title"
                    style="font-weight: bold; color: aliceblue"
                  >
                    <div v-if="notif">
                      {{ notif["jmlDewasSekre"] }}
                    </div>
                  </h4>
                  <p
                    class="card-text"
                    style="font-weight: bold; font-size: 16px"
                  >
                    Jumlah Sekretariat Dewan Pengawas
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col">
            <div
              class="card h-100"
              :style="{
                'background-color':
                  'rgba(148, 215, 199, ' + opacityApproved + ')',
                opacity: opacityApproved,
              }"
            >
              <div
                class="dashboard-card"
                style="color: black"
                @click="handleClickNotif('approved')"
              >
                <div class="card-body">
                  <h4
                    class="card-title"
                    style="font-weight: bold; color: aliceblue"
                  >
                    <div v-if="notif">
                      {{ notif["approved"] }}
                    </div>
                  </h4>
                  <p
                    class="card-text"
                    style="font-weight: bold; font-size: 16px"
                  >
                    Gaji Approved
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col">
            <div
              class="card h-100"
              :style="{
                'background-color': 'rgba(243, 158, 108, ' + opacitySalah + ')',
                opacity: opacitySalah,
              }"
            >
              <div
                class="dashboard-card"
                style="color: black"
                @click="handleClickNotif('salah')"
              >
                <div class="card-body">
                  <h4
                    class="card-title"
                    style="font-weight: bold; color: aliceblue"
                  >
                    <div v-if="notif">
                      {{ notif["salah"] }}
                    </div>
                  </h4>
                  <p
                    class="card-text"
                    style="font-weight: bold; font-size: 16px"
                  >
                    Gaji Salah
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <!-- <div>
          <p>
            <strong>DOUBLE CLICK</strong> pada baris tabel untuk menandai gaji
            adalah <strong>SALAH</strong> (hanya dapat dilakukan oleh user
            Pejabat)
          </p>
        </div> -->
        <DxTabPanel
          id="tabpanel"
          :data-source="tabSource"
          v-model:selected-index="tabPanelIndex"
          :loop="loop"
          :animation-enabled="animationEnabled"
          :swipe-enabled="swipeEnabled"
          item-title-template="title"
          @titleClick="tabTitleClick"
        >
          <template #title="{ data: item }">
            <span class="tab-panel-title">{{ item.text }}</span>
          </template>

          <template #tDireksi>
            <DxDataGrid
              ref="gridRefDireksi"
              id="gridTDireksi"
              :data-source="gajiListStore.dataSourceGajiDireksiList"
              :allow-column-reordering="true"
              :show-borders="true"
              key-expr="id"
              :show-column-lines="false"
              :column-auto-width="true"
              :column-hiding-enabled="false"
              @option-changed="onPageChanged($event, 'gridRefDireksi')"
              @exporting="onExporting"
              @editor-preparing="oneditorpreparing"
              :focused-row-enabled="true"
              @row-updating="onRowUpdating($event, 'gridRefDireksi')"
              :filter-value="filterValue"
              @context-menu-preparing="
                onContextMenuPreparing($event, 'gridRefDireksi')
              "
              :filter-sync-enabled="true"
              @row-prepared="rowPreparedTetap($event)"
              :remote-operations="true"
              :scrolling="{
                mode: 'virtual',
                rowRenderingMode: 'virtual',
                columnRenderingMode: 'virtual',
                useNative: true,
              }"
              :height="gridHeight"
            >
              <!-- <DxFilterRow :visible="true" :apply-filter="currentFilter" /> -->
              <!-- <dx-pager :show-page-size-selector="true" :show-info="true" /> -->
              <DxPaging :enabled="true" :page-size="numberingPageSize" />
              <DxExport :enabled="true" />

              <DxEditing
                v-if="gajiPeriodeData"
                :allow-updating="allowUpdating()"
                :allow-deleting="false"
                :allow-adding="false"
                mode="row"
              />

              <DxHeaderFilter :visible="true" />
              <DxScrolling mode="virtual" />
              <DxFilterRow :visible="true" apply-filter="auto" />
              <DxPager
                :visible="true"
                :showPageSizeSelector="false"
                :showNavigationButtons="false"
                :show-info="true"
                :infoText="'Page {0} of {1} ({2} items)'"
              />

              <DxToolbar>
                <DxItem
                  location="after"
                  template="status-setujui-selection-template"
                />
                <DxItem location="after" template="refresh-template" />
                <DxItem name="exportButton" />
                <DxItem name="columnChooserButton" />
              </DxToolbar>
              <template #refresh-template>
                <DxButton
                  icon="refresh"
                  @click="refreshDatagrid('gridRefDireksi')"
                  text="Refresh Data"
                  type="default"
                  style="float: left"
                  width="160px"
                  styling-mode="outlined"
                ></DxButton>
              </template>
              <template #status-setujui-selection-template>
                <DxButton
                  v-if="gajiPeriodeData && buttonCan('gaji-approve')"
                  icon="check"
                  @click="onSelectRowsConfirm('gridRefDireksi')"
                  text="Approve Pilihan"
                  type="success"
                  style="float: left"
                  styling-mode="outlined"
                ></DxButton>
              </template>
              <!-- <DxSelection mode="multiple" /> -->

              <template v-if="gajiPeriodeData && buttonCan('gaji-approve')">
                <DxSelection mode="multiple" :deferred="true" />
              </template>

              <DxColumnFixing :enabled="true" />

              <DxColumn
                class="noteditable"
                caption="#"
                data-field="row_number"
                :allow-filtering="false"
                :allow-sorting="false"
                :allow-exporting="false"
                :fixed="true"
                fixed-position="left"
                data-type="number"
              />

              <DxColumn
                class="noteditable"
                caption="ID GAJI"
                data-field="id"
                :allow-filtering="false"
                :allow-sorting="false"
                :allow-exporting="false"
                :fixed="true"
                fixed-position="left"
                data-type="number"
                :visible="false"
              />

              <DxColumn
                class="noteditable"
                data-field="status_gaji"
                caption="Status Gaji"
                cell-template="statusTemplate"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
                :allowHeaderFiltering="false"
              >
              </DxColumn>
              <DxColumn
                :visible="false"
                class="noteditable"
                data-type="boolean"
                data-field="tandai_salah"
                caption="Tandai Salah HALO"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
              />
              <template #headerTemplate>
                <div
                  class="small-button-container"
                  style="display: inline-flex; align-items: center"
                >
                  <DxButton
                    :icon="isExpanded ? 'chevrondown' : 'chevronnext'"
                    @click="toggleHeaderExpand"
                  />
                  <span style="margin-left: 8px">Pekerjaan</span>
                </div>
              </template>
              <template #headerGajiTemplate>
                <div
                  class="small-button-container"
                  style="display: inline-flex; align-items: center"
                >
                  <DxButton
                    :icon="isExpandedGaji ? 'chevrondown' : 'chevronnext'"
                    @click="toggleHeaderGajiExpand"
                  />
                  <span style="margin-left: 8px">Gaji</span>
                </div>
              </template>

              <template #statusTemplate="{ data, rowIndex }">
                <DxButton
                  :icon="formatStatusGaji('icon', { data })"
                  :type="formatStatusGaji('type', { data })"
                  @click="approveClick({ data, rowIndex })"
                />
                <!-- @click="approveClick({ data })" -->
              </template>

              <DxColumn
                data-type="string"
                class="noteditable"
                data-field="simpeg_pegawais_nik"
                caption="NIK"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
                :allowHeaderFiltering="false"
              />

              <DxColumn
                data-type="string"
                class="noteditable"
                data-field="simpeg_pegawais_nama"
                caption="Nama pegawai"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
                :allowHeaderFiltering="false"
                :min-width="200"
              />
              <DxColumn
                :allow-filtering="false"
                class="noteditable"
                data-field="tgl_gaji"
                caption="Periode Gaji"
                data-type="date"
                :display-format="'MM/yyyy'"
                :format="'MM/yyyy'"
                :calculate-filter-expression="calculateFilterExpression"
                :filter-operations="filterOperations"
                :customize-text="commonFunction.formatIsoDateToMonthYear"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
              >
              </DxColumn>

              <DxColumn
                :allow-hiding="false"
                class="noteditable"
                data-field="golongans_nama"
                caption="Gol."
                :allowHeaderFiltering="true"
                :header-filter="{
                  dataSource: commonStore.getGolonganSource().value,
                }"
              />

              <!-- :header-filter="{
                  dataSource: commonStore.getStatusPtkpSource('gajis_').value,
                }" -->
              <DxColumn
                class="noteditable"
                data-field="ptkp"
                caption="PTKP"
                :allowHeaderFiltering="true"
                :header-filter="{ dataSource: commonStore.statusPtkpSource }"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable"
                data-field="ter"
                caption="TER PPH 21(%)"
                :allowHeaderFiltering="false"
                :allow-hiding="false"
                data-type="number"
              />

              <DxColumn
                caption="Pekerjaan"
                header-cell-template="headerTemplate"
                :allow-hiding="false"
                :allowHeaderFiltering="false"
                :min-width="150"
              >
                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="cabangs_nama"
                  caption="Cabang"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.cabangSource }"
                  :visible="isExpanded"
                />

                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="units_nama"
                  caption="Unit"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.unitSource }"
                  :visible="isExpanded"
                />
                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="jabatans_nama"
                  caption="Jabatan"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.jabatanSource }"
                  :visible="isExpanded"
                />

                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="bagians_nama"
                  caption="Bagian"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.bagianSource }"
                  :visible="isExpanded"
                />

                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="sub_bagians_nama"
                  caption="Sub Bagian"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.subBagianSource }"
                  :visible="isExpanded"
                />
                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="bidangs_nama"
                  caption="Bidang"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.bidangSource }"
                  :visible="isExpanded"
                />
                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="sub_bidangs_nama"
                  caption="Sub Bidang"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.subBidangSource }"
                  :visible="isExpanded"
                />
                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="seksis_nama"
                  caption="Seksi"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.seksiSource }"
                  :visible="isExpanded"
                />
              </DxColumn>
              <DxColumn
                caption="Gaji"
                header-cell-template="headerGajiTemplate"
                :allow-hiding="false"
                :allowHeaderFiltering="false"
                :min-width="150"
              >
                <DxColumn
                  class="noteditable-gaji"
                  :allowHeaderFiltering="false"
                  data-type="number"
                  data-field="gaji_pokok"
                  caption="Gaji Pokok"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                >
                </DxColumn>
                <DxColumn
                  :allowHeaderFiltering="false"
                  class="noteditable-gaji"
                  data-type="number"
                  data-field="tun_perusahaan"
                  caption="Tunj. Perusahaan"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  class="noteditable-gaji"
                  data-type="number"
                  data-field="tun_jabatan"
                  caption="Tunj. Jabatan"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  class="noteditable-gaji"
                  data-type="number"
                  data-field="tun_kemahalan"
                  caption="Tunj. Kemahalan"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  class="noteditable-gaji"
                  data-type="number"
                  data-field="tun_air"
                  caption="Tunj. Air"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  class="noteditable-gaji"
                  data-type="number"
                  data-field="tun_transport"
                  caption="Tunj. Transport"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  class="noteditable-gaji"
                  data-type="number"
                  data-field="tun_pangan"
                  caption="Tunj. Pangan"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  class="noteditable-gaji"
                  data-type="number"
                  data-field="tun_kesehatan"
                  caption="Tunj. Kesehatan"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                />

                <DxColumn
                  :allowHeaderFiltering="false"
                  class="noteditable-gaji"
                  data-type="number"
                  data-field="premi_jkk"
                  caption="Premi JKK"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                />

                <DxColumn
                  :allowHeaderFiltering="false"
                  class="noteditable-gaji"
                  data-type="number"
                  data-field="premi_jkm"
                  caption="Premi JKM"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                />

                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  data-field="absen_bulans_tidak_hadir"
                  caption="Jml Tdk Hadir"
                  class="noteditable"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />
                <!-- <DxColumn data-field="jml_tdk_hadir" caption="Jml Tidak Hadir" /> -->
                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  class="noteditable"
                  data-field="pot_5_persen"
                  caption="Pot. Tdk Hadir"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  class="noteditable"
                  data-field="jml_bruto"
                  caption="Jml Bruto"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  class="noteditable"
                  data-field="tun_pph"
                  caption="Tunj. PPH"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  class="noteditable"
                  data-field="pot_kesehatan"
                  caption="Pot. Kesehatan"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  class="noteditable"
                  data-field="pot_bpjs_tk_tiga_program"
                  caption="Pot. BPJS TK 3 Program"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  class="noteditable"
                  data-field="pot_bpjs_tk_empat_program"
                  caption="Pot. BPJS TK 4 Program"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  class="noteditable"
                  data-field="pot_pensiun"
                  caption="Pot. Pensiun IFG LIFE"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  class="noteditable"
                  data-field="ifg_mandiri"
                  caption="Pot. IFG Mandiri"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  class="noteditable"
                  data-field="pot_pph"
                  caption="Pot. PPH"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                />
              </DxColumn>
              <DxColumn
                :allowHeaderFiltering="false"
                data-type="number"
                class="noteditable"
                data-field="total_diterima"
                caption="Total Diterima"
                :customize-text="commonFunction.formatNumberWithDots"
                :allow-hiding="false"
                :editor-options="
                  commonFunction.editorOptionsFormatterSeparateTypingWithDots
                "
              />
              <DxColumn
                :allowHeaderFiltering="false"
                class="noteditable-ket"
                data-type="string"
                data-field="ket"
                caption="Catatan"
                :allow-hiding="false"
                :min-width="150"
              ></DxColumn>
              <DxColumn
                :allowHeaderFiltering="false"
                class="noteditable"
                data-field="edited_by_user"
                caption="Dibuat oleh"
                :allow-hiding="false"
                :header-filter="{
                  dataSource: commonStore.editedByUserSource,
                }"
                :allow-filtering="false"
              >
                <DxLookup
                  display-expr="nama"
                  value-expr="val"
                  :data-source="commonStore.editedByUserStore"
                />
              </DxColumn>

              <!-- <DxColumn
                :allow-hiding="false"
                class="noteditable"
                data-field="golongans_nama"
                caption="Gol."
                :allowHeaderFiltering="true"
                :header-filter="{
                  dataSource: commonStore.getGolonganSource().value,
                }"
              /> -->

              <DxColumn
                caption="Dibuat oleh"
                class="noteditable"
                :allowHeaderFiltering="false"
                data-field="created_at_text"
                :allowFiltering="false"
                :allow-sorting="false"
                :allow-exporting="false"
                :allow-updating="false"
              />

              <!-- <DxColumn
                :allowHeaderFiltering="false"
                data-type="number"
                class="noteditable"
                caption="Terakhir di update oleh"
                cell-template="updatedTemplate"
              >
              </DxColumn> -->
              <DxColumn
                class="noteditable"
                caption="Diubah oleh"
                :allowHeaderFiltering="false"
                data-field="updated_at_text"
                :allowFiltering="false"
                :allow-sorting="false"
                :allow-exporting="false"
                :allow-updating="false"
              />

              <DxColumn
                class="noteditable"
                caption="Disetujui oleh"
                :allowHeaderFiltering="false"
                data-field="approved_at_text"
                :allowFiltering="false"
                :allow-sorting="false"
                :allow-exporting="false"
                :allow-updating="false"
              />
              <template #updatedTemplate="{ data }">
                <div v-html="templateUpdateByUser(data)"></div>
              </template>

              <DxColumn type="buttons" :width="110">
                <DxButtonDataGrid name="edit" />
                <DxButtonDataGrid
                  hint="View Log Perubahan"
                  icon="clock"
                  :visible="true"
                  @click="this.$refs.logPopup.showBySubject($event, 'Gaji')"
                />
              </DxColumn>

              <DxSummary>
                <DxTotalItem
                  column="gaji_pokok"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_perusahaan"
                  summary-type="sum"
                  value-format="#,##0"
                />

                <DxTotalItem
                  column="tun_jabatan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_kemahalan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_air"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_transport"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_pangan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_kesehatan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="premi_jkk"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="premi_jkm"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="absen_bulans_tidak_hadir"
                  summary-type="sum"
                  value-format="#,##0"
                />

                <!-- <DxTotalItem
                  column="jml_tdk_hadir"
                  summary-type="sum"
                  value-format="#,##0"
                /> -->
                <DxTotalItem
                  column="pot_5_persen"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="jml_bruto"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_pph"
                  summary-type="sum"
                  value-format="#,##0"
                />

                <DxTotalItem
                  column="pot_kesehatan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_bpjs_tk_tiga_program"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_bpjs_tk_empat_program"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_pensiun"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="ifg_mandiri"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_pph"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="total_diterima"
                  summary-type="sum"
                  value-format="#,##0"
                />
              </DxSummary>

              <DxColumnChooser :enabled="true" :mode="mode">
                <DxPosition
                  my="right top"
                  at="right bottom"
                  of=".dx-datagrid-column-chooser-button"
                />

                <DxColumnChooserSearch
                  :enabled="true"
                  :editor-options="editorOptions"
                />
                <DxColumnChooserSelection
                  :allow-select-all="allowSelectAll"
                  :select-by-click="selectByClick"
                  :recursive="recursive"
                />
              </DxColumnChooser>
            </DxDataGrid>
          </template>
          <template #tTetap>
            <DxDataGrid
              ref="gridRefTetap"
              id="gridTetap"
              :data-source="gajiListStore.dataSourceGajiTetapList"
              :allow-column-reordering="true"
              :show-borders="true"
              key-expr="id"
              :show-column-lines="false"
              :column-auto-width="true"
              :column-hiding-enabled="false"
              @option-changed="onPageChanged($event, 'gridRefTetap')"
              @exporting="onExporting"
              @editor-preparing="oneditorpreparing"
              :focused-row-enabled="true"
              :filter-value="filterValue"
              :filter-sync-enabled="true"
              @row-updating="onRowUpdating($event, 'gridRefTetap')"
              @context-menu-preparing="
                onContextMenuPreparing($event, 'gridRefTetap')
              "
              @row-prepared="rowPreparedTetap($event)"
              :remote-operations="true"
              :scrolling="{
                mode: 'virtual',
                rowRenderingMode: 'virtual',
                columnRenderingMode: 'virtual',
                useNative: true,
              }"
              :height="gridHeight"
            >
              <DxExport :enabled="true" />
              <DxEditing
                v-if="gajiPeriodeData"
                :allow-updating="allowUpdating()"
                :allow-deleting="false"
                :allow-adding="false"
                mode="row"
              />

              <DxPaging :enabled="true" :page-size="numberingPageSize" />
              <DxHeaderFilter :visible="true" />
              <DxScrolling mode="virtual" />
              <DxFilterRow :visible="true" apply-filter="auto" />
              <DxPager
                :visible="true"
                :showPageSizeSelector="false"
                :showNavigationButtons="false"
                :show-info="true"
                :infoText="'Page {0} of {1} ({2} items)'"
              />

              <DxToolbar>
                <DxItem
                  location="after"
                  template="status-setujui-selection-template"
                />
                <DxItem location="after" template="refresh-template" />
                <DxItem name="exportButton" />
                <DxItem name="columnChooserButton" />
              </DxToolbar>
              <template #refresh-template>
                <DxButton
                  icon="refresh"
                  @click="refreshDatagrid('gridRefTetap')"
                  text="Refresh Data"
                  type="default"
                  style="float: left"
                  width="160px"
                  styling-mode="outlined"
                ></DxButton>
              </template>
              <!-- <DxSelection mode="multiple" /> -->
              <template #status-setujui-selection-template>
                <DxButton
                  v-if="gajiPeriodeData && buttonCan('gaji-approve')"
                  icon="check"
                  @click="onSelectRowsConfirm('gridRefTetap')"
                  text="Approve Pilihan"
                  type="success"
                  style="float: left"
                  styling-mode="outlined"
                ></DxButton>
              </template>
              <template v-if="gajiPeriodeData && buttonCan('gaji-approve')">
                <DxSelection mode="multiple" :deferred="true" />
              </template>
              <DxColumnFixing :enabled="true" />

              <DxColumn
                class="noteditable"
                caption="#"
                data-field="row_number"
                :allow-filtering="false"
                :allow-sorting="false"
                :allow-exporting="false"
                :fixed="true"
                fixed-position="left"
                data-type="number"
              />
              <DxColumn
                class="noteditable"
                data-field="status_gaji"
                caption="Status Gaji"
                cell-template="statusTemplate"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
                :allowHeaderFiltering="false"
              >
              </DxColumn>
              <DxColumn
                :visible="false"
                data-type="boolean"
                class="noteditable"
                data-field="tandai_salah"
                caption="Tandai Salah"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
              />

              <template #headerTemplate>
                <div
                  class="small-button-container"
                  style="display: inline-flex; align-items: center"
                >
                  <DxButton
                    :icon="isExpanded ? 'chevrondown' : 'chevronnext'"
                    @click="toggleHeaderExpand"
                  />
                  <span style="margin-left: 8px">Pekerjaan</span>
                </div>
              </template>
              <template #headerGajiTemplate>
                <div
                  class="small-button-container"
                  style="display: inline-flex; align-items: center"
                >
                  <DxButton
                    :icon="isExpandedGaji ? 'chevrondown' : 'chevronnext'"
                    @click="toggleHeaderGajiExpand"
                  />
                  <span style="margin-left: 8px">Gaji</span>
                </div>
              </template>

              <template #statusTemplate="{ data }">
                <!-- {{ formatStatusGaji(data.text) }} -->
                <DxButton
                  :icon="formatStatusGaji('icon', { data })"
                  :type="formatStatusGaji('type', { data })"
                  @click="approveClick({ data })"
                />
              </template>

              <!-- <DxColumn
                data-type="number"
                class="noteditable"
                data-field="id"
                caption="GAJIID"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
              /> -->

              <DxColumn
                data-type="string"
                class="noteditable"
                data-field="simpeg_pegawais_nik"
                caption="NIK"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
                :allowHeaderFiltering="false"
              />

              <DxColumn
                data-type="string"
                class="noteditable"
                data-field="simpeg_pegawais_nama"
                caption="Nama pegawai"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
                :allowHeaderFiltering="false"
                :min-width="200"
              />
              <DxColumn
                :allow-filtering="false"
                class="noteditable"
                data-field="tgl_gaji"
                caption="Periode Gaji"
                data-type="date"
                :display-format="'MM/yyyy'"
                :format="'MM/yyyy'"
                :calculate-filter-expression="calculateFilterExpression"
                :filter-operations="filterOperations"
                :customize-text="commonFunction.formatIsoDateToMonthYear"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
              >
              </DxColumn>

              <DxColumn
                :allow-hiding="false"
                class="noteditable"
                data-field="golongans_nama"
                caption="Gol."
                :allowHeaderFiltering="true"
                :header-filter="{
                  dataSource: commonStore.getGolonganSource().value,
                }"
              />

              <!-- <DxColumn
                class="noteditable"
                data-field="riwayatGolongan.golongan_id"
                caption="Gol."
              >
                <DxLookup
                  :data-source="golonganSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn> -->

              <DxColumn
                class="noteditable"
                data-field="ptkp"
                caption="PTKP"
                :allowHeaderFiltering="true"
                :header-filter="{ dataSource: commonStore.statusPtkpSource }"
                :allow-hiding="false"
              />

              <DxColumn
                class="noteditable"
                data-field="ter"
                caption="TER PPH 21(%)"
                :allowHeaderFiltering="false"
                :allow-hiding="false"
                data-type="number"
              />

              <DxColumn
                caption="Pekerjaan"
                header-cell-template="headerTemplate"
                :allow-hiding="false"
                :allowHeaderFiltering="false"
                :min-width="150"
              >
                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="cabangs_nama"
                  caption="Cabang"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.cabangSource }"
                  :visible="isExpanded"
                />

                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="units_nama"
                  caption="Unit"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.unitSource }"
                  :visible="isExpanded"
                />
                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="jabatans_nama"
                  caption="Jabatan"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.jabatanSource }"
                  :visible="isExpanded"
                />

                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="bagians_nama"
                  caption="Bagian"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.bagianSource }"
                  :visible="isExpanded"
                />
                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="sub_bagians_nama"
                  caption="Sub Bagian"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.subBagianSource }"
                  :visible="isExpanded"
                />
                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="bidangs_nama"
                  caption="Bidang"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.bidangSource }"
                  :visible="isExpanded"
                />
                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="sub_bidangs_nama"
                  caption="Sub Bidang"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.subBidangSource }"
                  :visible="isExpanded"
                />
                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="seksis_nama"
                  caption="Seksi"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.seksiSource }"
                  :visible="isExpanded"
                />
              </DxColumn>
              <DxColumn
                caption="Gaji"
                header-cell-template="headerGajiTemplate"
                :allow-hiding="false"
                :allowHeaderFiltering="false"
                :min-width="150"
              >
                <DxColumn
                  :allowHeaderFiltering="false"
                  class="noteditable-gaji"
                  data-type="number"
                  data-field="gaji_pokok"
                  caption="Gaji Pokok"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  class="noteditable-gaji"
                  data-type="number"
                  data-field="tun_perusahaan"
                  caption="Tunj. Perusahaan"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  class="noteditable-gaji"
                  data-type="number"
                  data-field="tun_jabatan"
                  caption="Tunj. Jabatan"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  class="noteditable-gaji"
                  data-type="number"
                  data-field="tun_kemahalan"
                  caption="Tunj. Kemahalan"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  class="noteditable-gaji"
                  data-type="number"
                  data-field="tun_air"
                  caption="Tunj. Air"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  class="noteditable-gaji"
                  data-type="number"
                  data-field="tun_transport"
                  caption="Tunj. Transport"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  class="noteditable-gaji"
                  data-type="number"
                  data-field="tun_pangan"
                  caption="Tunj. Pangan"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  class="noteditable-gaji"
                  data-type="number"
                  data-field="tun_kesehatan"
                  caption="Tunj. Kesehatan"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  class="noteditable-gaji"
                  data-type="number"
                  data-field="premi_jkk"
                  caption="Premi JKK"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                />

                <DxColumn
                  :allowHeaderFiltering="false"
                  class="noteditable-gaji"
                  data-type="number"
                  data-field="premi_jkm"
                  caption="Premi JKM"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                />

                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  data-field="absen_bulans_tidak_hadir"
                  caption="Jml Tdk Hadir"
                  class="noteditable"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />
                <!-- <DxColumn data-field="jml_tdk_hadir" caption="Jml Tidak Hadir" /> -->
                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  class="noteditable"
                  data-field="pot_5_persen"
                  caption="Pot. Tdk Hadir"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  class="noteditable"
                  data-field="jml_bruto"
                  caption="Jml Bruto"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  class="noteditable"
                  data-field="tun_pph"
                  caption="Tunj. PPH"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  class="noteditable"
                  data-field="pot_kesehatan"
                  caption="Pot. Kesehatan"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  class="noteditable"
                  data-field="pot_bpjs_tk_tiga_program"
                  caption="Pot. BPJS TK 3 Program"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  class="noteditable"
                  data-field="pot_bpjs_tk_empat_program"
                  caption="Pot. BPJS TK 4 Program"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  class="noteditable"
                  data-field="pot_pensiun"
                  caption="Pot. Pensiun IFG LIFE"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  class="noteditable"
                  data-field="ifg_mandiri"
                  caption="Pot. IFG Mandiri"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  class="noteditable"
                  data-field="pot_pph"
                  caption="Pot. PPH"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                />
              </DxColumn>
              <DxColumn
                :allowHeaderFiltering="false"
                data-type="number"
                class="noteditable"
                data-field="total_diterima"
                caption="Total Diterima"
                :customize-text="commonFunction.formatNumberWithDots"
                :allow-hiding="false"
                :editor-options="
                  commonFunction.editorOptionsFormatterSeparateTypingWithDots
                "
              />
              <DxColumn
                :allowHeaderFiltering="false"
                class="noteditable-ket"
                data-type="string"
                data-field="ket"
                caption="Catatan"
                :min-width="150"
                :allow-hiding="false"
              ></DxColumn>
              <DxColumn
                :allowHeaderFiltering="true"
                class="noteditable"
                data-field="edited_by_user"
                caption="Dibuat oleh"
                :allow-hiding="false"
                :header-filter="{
                  dataSource: commonStore.editedByUserSource,
                }"
                :allow-filtering="false"
              >
                <DxLookup
                  display-expr="nama"
                  value-expr="val"
                  :data-source="commonStore.editedByUserStore"
                />
              </DxColumn>

              <DxColumn
                caption="Dibuat oleh"
                class="noteditable"
                :allowHeaderFiltering="false"
                data-field="created_at_text"
                :allowFiltering="false"
                :allow-sorting="false"
                :allow-exporting="false"
                :allow-updating="false"
              />

              <!-- <DxColumn
                :allowHeaderFiltering="false"
                data-type="number"
                class="noteditable"
                caption="Terakhir di update oleh"
                cell-template="updatedTemplate"
              >
              </DxColumn> -->
              <DxColumn
                class="noteditable"
                caption="Diubah oleh"
                :allowHeaderFiltering="false"
                data-field="updated_at_text"
                :allowFiltering="false"
                :allow-sorting="false"
                :allow-exporting="false"
                :allow-updating="false"
              />
              <DxColumn
                class="noteditable"
                caption="Disetujui oleh"
                :allowHeaderFiltering="false"
                data-field="approved_at_text"
                :allowFiltering="false"
                :allow-sorting="false"
                :allow-exporting="false"
                :allow-updating="false"
              />
              <template #updatedTemplate="{ data }">
                <div v-html="templateUpdateByUser(data)"></div>
              </template>
              <DxColumn type="buttons" :width="110">
                <DxButtonDataGrid name="edit" />
                <DxButtonDataGrid
                  hint="View Log Perubahan"
                  icon="clock"
                  :visible="true"
                  @click="this.$refs.logPopup.showBySubject($event, 'Gaji')"
                />
              </DxColumn>

              <DxSummary>
                <DxTotalItem
                  column="gaji_pokok"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_perusahaan"
                  summary-type="sum"
                  value-format="#,##0"
                />

                <DxTotalItem
                  column="tun_jabatan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_kemahalan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_air"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_transport"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_pangan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_kesehatan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="premi_jkk"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="premi_jkm"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="absen_bulans_tidak_hadir"
                  summary-type="sum"
                  value-format="#,##0"
                />

                <!-- <DxTotalItem
                  column="jml_tdk_hadir"
                  summary-type="sum"
                  value-format="#,##0"
                /> -->
                <DxTotalItem
                  column="pot_5_persen"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="jml_bruto"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_pph"
                  summary-type="sum"
                  value-format="#,##0"
                />

                <DxTotalItem
                  column="pot_kesehatan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_bpjs_tk_tiga_program"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_bpjs_tk_empat_program"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_pensiun"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="ifg_mandiri"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_pph"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="total_diterima"
                  summary-type="sum"
                  value-format="#,##0"
                />
              </DxSummary>

              <DxColumnChooser :enabled="true" :mode="mode">
                <DxPosition
                  my="right top"
                  at="right bottom"
                  of=".dx-datagrid-column-chooser-button"
                />

                <DxColumnChooserSearch
                  :enabled="true"
                  :editor-options="editorOptions"
                />
                <DxColumnChooserSelection
                  :allow-select-all="allowSelectAll"
                  :select-by-click="selectByClick"
                  :recursive="recursive"
                />
              </DxColumnChooser>
            </DxDataGrid>
          </template>

          <template #tCapeg>
            <DxDataGrid
              ref="gridRefCapeg"
              id="gridTetap"
              :data-source="gajiListStore.dataSourceGajiCapegList"
              :allow-column-reordering="true"
              :show-borders="true"
              key-expr="id"
              :show-column-lines="false"
              :column-auto-width="true"
              :column-hiding-enabled="false"
              @option-changed="onPageChanged($event, 'gridRefCapeg')"
              @exporting="onExporting"
              @editor-preparing="oneditorpreparing"
              :focused-row-enabled="true"
              :filter-value="filterValue"
              :filter-sync-enabled="true"
              @row-updating="onRowUpdating($event, 'gridRefCapeg')"
              @context-menu-preparing="
                onContextMenuPreparing($event, 'gridRefCapeg')
              "
              @row-prepared="rowPreparedTetap($event)"
              :remote-operations="true"
              :scrolling="{
                mode: 'virtual',
                rowRenderingMode: 'virtual',
                columnRenderingMode: 'virtual',
                useNative: true,
              }"
              :height="gridHeight"
            >
              <DxExport :enabled="true" />
              <DxEditing
                v-if="gajiPeriodeData"
                :allow-updating="allowUpdating()"
                :allow-deleting="false"
                :allow-adding="false"
                mode="row"
              />

              <DxPaging :enabled="true" :page-size="numberingPageSize" />
              <DxHeaderFilter :visible="true" />
              <DxScrolling mode="virtual" />
              <DxFilterRow :visible="true" apply-filter="auto" />
              <DxPager
                :visible="true"
                :showPageSizeSelector="false"
                :showNavigationButtons="false"
                :show-info="true"
                :infoText="'Page {0} of {1} ({2} items)'"
              />

              <DxToolbar>
                <DxItem
                  location="after"
                  template="status-setujui-selection-template"
                />
                <DxItem location="after" template="refresh-template" />
                <DxItem name="exportButton" />
                <DxItem name="columnChooserButton" />
              </DxToolbar>
              <template #refresh-template>
                <DxButton
                  icon="refresh"
                  @click="refreshDatagrid('gridRefCapeg')"
                  text="Refresh Data"
                  type="default"
                  style="float: left"
                  width="160px"
                  styling-mode="outlined"
                ></DxButton>
              </template>
              <!-- <DxSelection mode="multiple" /> -->
              <template v-if="gajiPeriodeData && buttonCan('gaji-approve')">
                <DxSelection mode="multiple" :deferred="true" />
              </template>
              <template #status-setujui-selection-template>
                <DxButton
                  v-if="gajiPeriodeData && buttonCan('gaji-approve')"
                  icon="check"
                  @click="onSelectRowsConfirm('gridRefCapeg')"
                  text="Approve Pilihan"
                  type="success"
                  style="float: left"
                  styling-mode="outlined"
                ></DxButton>
              </template>
              <DxColumnFixing :enabled="true" />

              <DxColumn
                class="noteditable"
                caption="#"
                data-field="row_number"
                :allow-filtering="false"
                :allow-sorting="false"
                :allow-exporting="false"
                :fixed="true"
                fixed-position="left"
                data-type="number"
              />
              <DxColumn
                class="noteditable"
                data-field="status_gaji"
                caption="Status Gaji"
                cell-template="statusTemplate"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
                :allowHeaderFiltering="false"
              >
              </DxColumn>
              <DxColumn
                :visible="false"
                data-type="boolean"
                class="noteditable"
                data-field="tandai_salah"
                caption="Tandai Salah"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
              />

              <template #statusTemplate="{ data }">
                <!-- {{ formatStatusGaji(data.text) }} -->
                <DxButton
                  :icon="formatStatusGaji('icon', { data })"
                  :type="formatStatusGaji('type', { data })"
                  @click="approveClick({ data })"
                />
              </template>

              <template #headerTemplate>
                <div
                  class="small-button-container"
                  style="display: inline-flex; align-items: center"
                >
                  <DxButton
                    :icon="isExpanded ? 'chevrondown' : 'chevronnext'"
                    @click="toggleHeaderExpand"
                  />
                  <span style="margin-left: 8px">Pekerjaan</span>
                </div>
              </template>
              <template #headerGajiTemplate>
                <div
                  class="small-button-container"
                  style="display: inline-flex; align-items: center"
                >
                  <DxButton
                    :icon="isExpandedGaji ? 'chevrondown' : 'chevronnext'"
                    @click="toggleHeaderGajiExpand"
                  />
                  <span style="margin-left: 8px">Gaji</span>
                </div>
              </template>

              <DxColumn
                data-type="string"
                class="noteditable"
                data-field="simpeg_pegawais_nik"
                caption="NIK"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
                :allowHeaderFiltering="false"
              />

              <DxColumn
                data-type="string"
                class="noteditable"
                data-field="simpeg_pegawais_nama"
                caption="Nama pegawai"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
                :allowHeaderFiltering="false"
                :min-width="200"
              />

              <DxColumn
                :allow-filtering="false"
                class="noteditable"
                data-field="tgl_gaji"
                caption="Periode Gaji"
                data-type="date"
                :display-format="'MM/yyyy'"
                :format="'MM/yyyy'"
                :calculate-filter-expression="calculateFilterExpression"
                :filter-operations="filterOperations"
                :customize-text="commonFunction.formatIsoDateToMonthYear"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
              >
              </DxColumn>

              <DxColumn
                :allow-hiding="false"
                class="noteditable"
                data-field="golongans_nama"
                caption="Gol."
                :allowHeaderFiltering="true"
                :header-filter="{
                  dataSource: commonStore.getGolonganSource().value,
                }"
              />

              <DxColumn
                class="noteditable"
                data-field="ptkp"
                caption="PTKP"
                :allowHeaderFiltering="true"
                :header-filter="{ dataSource: commonStore.statusPtkpSource }"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable"
                data-field="ter"
                caption="TER PPH 21(%)"
                :allowHeaderFiltering="false"
                :allow-hiding="false"
                data-type="number"
              />
              <DxColumn
                caption="Pekerjaan"
                header-cell-template="headerTemplate"
                :allow-hiding="false"
                :allowHeaderFiltering="false"
                :min-width="150"
              >
                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="cabangs_nama"
                  caption="Cabang"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.cabangSource }"
                  :visible="isExpanded"
                />

                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="units_nama"
                  caption="Unit"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.unitSource }"
                  :visible="isExpanded"
                />

                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="jabatans_nama"
                  caption="Jabatan"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.jabatanSource }"
                  :visible="isExpanded"
                />

                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="bagians_nama"
                  caption="Bagian"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.bagianSource }"
                  :visible="isExpanded"
                />
                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="sub_bagians_nama"
                  caption="Sub Bagian"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.subBagianSource }"
                  :visible="isExpanded"
                />
                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="bidangs_nama"
                  caption="Bidang"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.bidangSource }"
                  :visible="isExpanded"
                />
                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="sub_bidangs_nama"
                  caption="Sub Bidang"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.subBidangSource }"
                  :visible="isExpanded"
                />
                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="seksis_nama"
                  caption="Seksi"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.seksiSource }"
                  :visible="isExpanded"
                />
              </DxColumn>

              <DxColumn
                caption="Gaji"
                header-cell-template="headerGajiTemplate"
                :allow-hiding="false"
                :allowHeaderFiltering="false"
                :min-width="150"
              >
                <DxColumn
                  :allowHeaderFiltering="false"
                  class="noteditable-gaji"
                  data-type="number"
                  data-field="gaji_pokok"
                  caption="Gaji Pokok"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  class="noteditable-gaji"
                  data-type="number"
                  data-field="tun_perusahaan"
                  caption="Tunj. Perusahaan"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  class="noteditable-gaji"
                  data-type="number"
                  data-field="tun_jabatan"
                  caption="Tunj. Jabatan"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  class="noteditable-gaji"
                  data-type="number"
                  data-field="tun_kemahalan"
                  caption="Tunj. Kemahalan"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  class="noteditable-gaji"
                  data-type="number"
                  data-field="tun_air"
                  caption="Tunj. Air"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  class="noteditable-gaji"
                  data-type="number"
                  data-field="tun_transport"
                  caption="Tunj. Transport"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  class="noteditable-gaji"
                  data-type="number"
                  data-field="tun_pangan"
                  caption="Tunj. Pangan"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  class="noteditable-gaji"
                  data-type="number"
                  data-field="tun_kesehatan"
                  caption="Tunj. Kesehatan"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  class="noteditable-gaji"
                  data-type="number"
                  data-field="premi_jkk"
                  caption="Premi JKK"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  class="noteditable-gaji"
                  data-type="number"
                  data-field="premi_jkm"
                  caption="Premi JKM"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                />

                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  data-field="absen_bulans_tidak_hadir"
                  caption="Jml Tdk Hadir"
                  class="noteditable"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                />
                <!-- <DxColumn data-field="jml_tdk_hadir" caption="Jml Tidak Hadir" /> -->
                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  class="noteditable"
                  data-field="pot_5_persen"
                  caption="Pot. Tdk Hadir"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  class="noteditable"
                  data-field="jml_bruto"
                  caption="Jml Bruto"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  class="noteditable"
                  data-field="tun_pph"
                  caption="Tunj. PPH"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  class="noteditable"
                  data-field="pot_kesehatan"
                  caption="Pot. Kesehatan"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  class="noteditable"
                  data-field="pot_bpjs_tk_tiga_program"
                  caption="Pot. BPJS TK 3 Program"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  class="noteditable"
                  data-field="pot_bpjs_tk_empat_program"
                  caption="Pot. BPJS TK 4 Program"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  class="noteditable"
                  data-field="pot_pensiun"
                  caption="Pot. Pensiun IFG LIFE"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  class="noteditable"
                  data-field="ifg_mandiri"
                  caption="Pot. IFG Mandiri"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  class="noteditable"
                  data-field="pot_pph"
                  caption="Pot. PPH"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                />
              </DxColumn>

              <DxColumn
                :allowHeaderFiltering="false"
                data-type="number"
                class="noteditable"
                data-field="total_diterima"
                caption="Total Diterima"
                :customize-text="commonFunction.formatNumberWithDots"
                :allow-hiding="false"
                :editor-options="
                  commonFunction.editorOptionsFormatterSeparateTypingWithDots
                "
              />
              <DxColumn
                :allowHeaderFiltering="false"
                class="noteditable-ket"
                data-type="string"
                data-field="ket"
                caption="Catatan"
                :min-width="150"
                :allow-hiding="false"
              ></DxColumn>
              <DxColumn
                :allowHeaderFiltering="true"
                class="noteditable"
                data-field="edited_by_user"
                caption="Dibuat oleh"
                :allow-hiding="false"
                :header-filter="{
                  dataSource: commonStore.editedByUserSource,
                }"
                :allow-filtering="false"
              >
                <DxLookup
                  display-expr="nama"
                  value-expr="val"
                  :data-source="commonStore.editedByUserStore"
                />
              </DxColumn>
              <DxColumn
                caption="Dibuat oleh"
                class="noteditable"
                :allowHeaderFiltering="false"
                data-field="created_at_text"
                :allowFiltering="false"
                :allow-sorting="false"
                :allow-exporting="false"
                :allow-updating="false"
              />
              <!-- <DxColumn
                :allowHeaderFiltering="false"
                data-type="number"
                class="noteditable"
                caption="Terakhir di update oleh"
                cell-template="updatedTemplate"
              >
              </DxColumn> -->
              <DxColumn
                class="noteditable"
                caption="Diubah oleh"
                :allowHeaderFiltering="false"
                data-field="updated_at_text"
                :allowFiltering="false"
                :allow-sorting="false"
                :allow-exporting="false"
                :allow-updating="false"
              />
              <DxColumn
                class="noteditable"
                caption="Disetujui oleh"
                :allowHeaderFiltering="false"
                data-field="approved_at_text"
                :allowFiltering="false"
                :allow-sorting="false"
                :allow-exporting="false"
                :allow-updating="false"
              />

              <template #updatedTemplate="{ data }">
                <div v-html="templateUpdateByUser(data)"></div>
              </template>
              <DxColumn type="buttons" :width="110">
                <DxButtonDataGrid name="edit" />
                <DxButtonDataGrid
                  hint="View Log Perubahan"
                  icon="clock"
                  :visible="true"
                  @click="this.$refs.logPopup.showBySubject($event, 'Gaji')"
                />
              </DxColumn>

              <DxSummary>
                <DxTotalItem
                  column="gaji_pokok"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_perusahaan"
                  summary-type="sum"
                  value-format="#,##0"
                />

                <DxTotalItem
                  column="tun_jabatan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_kemahalan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_air"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_transport"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_pangan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_kesehatan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="premi_jkk"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="premi_jkm"
                  summary-type="sum"
                  value-format="#,##0"
                />

                <DxTotalItem
                  column="absen_bulans_tidak_hadir"
                  summary-type="sum"
                  value-format="#,##0"
                />

                <!-- <DxTotalItem
                  column="jml_tdk_hadir"
                  summary-type="sum"
                  value-format="#,##0"
                /> -->
                <DxTotalItem
                  column="pot_5_persen"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="jml_bruto"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_pph"
                  summary-type="sum"
                  value-format="#,##0"
                />

                <DxTotalItem
                  column="pot_kesehatan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_bpjs_tk_tiga_program"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_bpjs_tk_empat_program"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_pensiun"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="ifg_mandiri"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_pph"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="total_diterima"
                  summary-type="sum"
                  value-format="#,##0"
                />
              </DxSummary>

              <DxColumnChooser :enabled="true" :mode="mode">
                <DxPosition
                  my="right top"
                  at="right bottom"
                  of=".dx-datagrid-column-chooser-button"
                />

                <DxColumnChooserSearch
                  :enabled="true"
                  :editor-options="editorOptions"
                />
                <DxColumnChooserSelection
                  :allow-select-all="allowSelectAll"
                  :select-by-click="selectByClick"
                  :recursive="recursive"
                />
              </DxColumnChooser>
            </DxDataGrid>
          </template>

          <template #tHonor>
            <!-- 
            :focused-row-index="0" -->
            <DxDataGrid
              ref="gridRefHonor"
              id="gridHonor"
              :data-source="gajiListStore.dataSourceGajiHonorList"
              :allow-column-reordering="true"
              :show-borders="true"
              key-expr="id"
              :show-column-lines="false"
              :column-auto-width="true"
              :column-hiding-enabled="false"
              :focused-row-enabled="true"
              @option-changed="onPageChanged($event, 'gridRefHonor')"
              @exporting="onExporting"
              @editor-preparing="oneditorpreparing"
              @row-updating="onRowUpdating($event, 'gridRefHonor')"
              :filter-value="filterValue"
              :filter-sync-enabled="true"
              @context-menu-preparing="
                onContextMenuPreparing($event, 'gridRefHonor')
              "
              @row-prepared="rowPreparedTetap($event)"
              :remote-operations="true"
              :scrolling="{
                mode: 'virtual',
                rowRenderingMode: 'virtual',
                columnRenderingMode: 'virtual',
                useNative: true,
              }"
              :height="gridHeight"
            >
              <DxExport :enabled="true" />
              <DxEditing
                v-if="gajiPeriodeData"
                :allow-updating="allowUpdating()"
                :allow-deleting="false"
                :allow-adding="false"
                mode="row"
              />
              <DxPaging :enabled="true" :page-size="numberingPageSize" />

              <DxHeaderFilter :visible="true" />
              <DxScrolling mode="virtual" />
              <DxFilterRow :visible="true" apply-filter="auto" />
              <DxPager
                :visible="true"
                :showPageSizeSelector="false"
                :showNavigationButtons="false"
                :show-info="true"
                :infoText="'Page {0} of {1} ({2} items)'"
              />

              <DxToolbar>
                <DxItem
                  location="after"
                  template="status-setujui-selection-template"
                />
                <DxItem location="after" template="refresh-template" />
                <DxItem name="exportButton" />
                <DxItem name="columnChooserButton" />
              </DxToolbar>
              <template #refresh-template>
                <DxButton
                  icon="refresh"
                  @click="refreshDatagrid('gridRefHonor')"
                  text="Refresh Data"
                  type="default"
                  style="float: left"
                  width="160px"
                  styling-mode="outlined"
                ></DxButton>
              </template>
              <!-- <DxSelection mode="multiple" /> -->
              <template v-if="gajiPeriodeData && buttonCan('gaji-approve')">
                <DxSelection mode="multiple" :deferred="true" />
              </template>
              <template #status-setujui-selection-template>
                <DxButton
                  v-if="gajiPeriodeData && buttonCan('gaji-approve')"
                  icon="check"
                  @click="onSelectRowsConfirm('gridRefHonor')"
                  text="Approve Pilihan"
                  type="success"
                  style="float: left"
                  styling-mode="outlined"
                ></DxButton>
              </template>
              <DxColumnFixing :enabled="true" />

              <DxColumn
                class="noteditable"
                caption="#"
                data-field="row_number"
                :allow-filtering="false"
                :allow-sorting="false"
                :allow-exporting="false"
                :fixed="true"
                fixed-position="left"
                data-type="number"
              />

              <DxColumn
                class="noteditable"
                caption="PEGAWAI_ID"
                data-field="pegawai_id"
                :allow-filtering="false"
                :allow-sorting="false"
                :allow-exporting="false"
                :fixed="true"
                fixed-position="left"
                data-type="number"
                :visible="false"
              />

              <DxColumn
                class="noteditable"
                data-field="status_gaji"
                caption="Status Gaji"
                cell-template="statusTemplate"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
                :allowHeaderFiltering="false"
              >
              </DxColumn>
              <DxColumn
                :visible="false"
                data-type="boolean"
                class="noteditable"
                data-field="tandai_salah"
                caption="Tandai Salah"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
              />
              <template #headerTemplate>
                <div
                  class="small-button-container"
                  style="display: inline-flex; align-items: center"
                >
                  <DxButton
                    :icon="isExpanded ? 'chevrondown' : 'chevronnext'"
                    @click="toggleHeaderExpand"
                  />
                  <span style="margin-left: 8px">Pekerjaan</span>
                </div>
              </template>
              <template #headerGajiTemplate>
                <div
                  class="small-button-container"
                  style="display: inline-flex; align-items: center"
                >
                  <DxButton
                    :icon="isExpandedGaji ? 'chevrondown' : 'chevronnext'"
                    @click="toggleHeaderGajiExpand"
                  />
                  <span style="margin-left: 8px">Gaji</span>
                </div>
              </template>
              <template #statusTemplate="{ data }">
                <!-- {{ formatStatusGaji(data.text) }} -->
                <DxButton
                  :icon="formatStatusGaji('icon', { data })"
                  :type="formatStatusGaji('type', { data })"
                  @click="approveClick({ data })"
                />
              </template>

              <DxColumn
                data-type="string"
                class="noteditable"
                data-field="simpeg_pegawais_nama"
                caption="Nama pegawai"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
                :allowHeaderFiltering="false"
                :min-width="200"
              />
              <DxColumn
                :allow-filtering="false"
                class="noteditable"
                data-field="tgl_gaji"
                caption="Periode Gaji"
                data-type="date"
                :display-format="'MM/yyyy'"
                :format="'MM/yyyy'"
                :calculate-filter-expression="calculateFilterExpression"
                :filter-operations="filterOperations"
                :customize-text="commonFunction.formatIsoDateToMonthYear"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
              >
              </DxColumn>

              <DxColumn
                :allow-hiding="false"
                class="noteditable"
                data-field="golongans_nama"
                caption="Gol."
                :allowHeaderFiltering="true"
                :header-filter="{
                  dataSource: commonStore.getGolonganSource().value,
                }"
              />
              <DxColumn
                caption="Pekerjaan"
                header-cell-template="headerTemplate"
                :allow-hiding="false"
                :allowHeaderFiltering="false"
                :min-width="150"
              >
                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="cabangs_nama"
                  caption="Cabang"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.cabangSource }"
                  :visible="isExpanded"
                />
                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="units_nama"
                  caption="Unit"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.unitSource }"
                  :visible="isExpanded"
                />
                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="jabatans_nama"
                  caption="Jabatan"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.jabatanSource }"
                  :visible="isExpanded"
                />

                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="bagians_nama"
                  caption="Bagian"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.bagianSource }"
                  :visible="isExpanded"
                />
                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="sub_bagians_nama"
                  caption="Sub Bagian"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.subBagianSource }"
                  :visible="isExpanded"
                />
                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="bidangs_nama"
                  caption="Bidang"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.bidangSource }"
                  :visible="isExpanded"
                />

                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="sub_bidangs_nama"
                  caption="Sub Bidang"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.subBidangSource }"
                  :visible="isExpanded"
                />
                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="seksis_nama"
                  caption="Seksi"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.seksiSource }"
                  :visible="isExpanded"
                />
              </DxColumn>

              <DxColumn
                class="noteditable"
                data-field="simpeg_pegawais_tgl_mulai_bekerja"
                caption="TMT Kontrak"
                data-type="date"
                :display-format="'dd/MM/yyyy'"
                :format="'dd/MM/yyyy'"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable"
                data-type="number"
                data-field="masa_kerja"
                caption="Masa Kerja"
                :customize-text="commonFunction.appendTahun"
                :allow-hiding="false"
              />
              <DxColumn
                caption="Gaji"
                header-cell-template="headerGajiTemplate"
                :allow-hiding="false"
                :allowHeaderFiltering="false"
                :min-width="150"
              >
                <DxColumn
                  :allowHeaderFiltering="false"
                  class="noteditable-gaji"
                  data-type="number"
                  data-field="honor_umk_jml"
                  caption="Honor (UMK)"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                />

                <DxColumn
                  :allowHeaderFiltering="false"
                  class="noteditable-gaji"
                  data-type="number"
                  data-field="kenaikan_masa_kerja"
                  caption="Kenaikan Masa Kerja"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  class="noteditable-gaji"
                  data-type="number"
                  data-field="tun_kesehatan"
                  caption="Tunj. Kesehatan"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  class="noteditable-gaji"
                  data-type="number"
                  data-field="premi_jkk"
                  caption="Premi JKK"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                />

                <DxColumn
                  :allowHeaderFiltering="false"
                  class="noteditable-gaji"
                  data-type="number"
                  data-field="premi_jkm"
                  caption="Premi JKM"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                />

                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  data-field="absen_bulans_tidak_hadir"
                  caption="Jml Tdk Hadir"
                  class="noteditable"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                />

                <!-- <DxColumn data-field="jml_tdk_hadir" caption="Jml Tidak Hadir" /> -->
                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  class="noteditable"
                  data-field="pot_5_persen"
                  caption="Pot. Tdk Hadir"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  class="noteditable"
                  data-field="jml_bruto"
                  caption="Jml Bruto"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  class="noteditable"
                  data-field="pot_kesehatan"
                  caption="Pot. Kesehatan"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  class="noteditable"
                  data-field="pot_bpjs_tk_dua_persen"
                  caption="Pot. BPJS TK 2%"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  class="noteditable"
                  data-field="ifg_mandiri"
                  caption="Pot. IFG Mandiri"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                />
              </DxColumn>

              <DxColumn
                :allowHeaderFiltering="false"
                data-type="number"
                class="noteditable"
                data-field="total_diterima"
                caption="Total Diterima"
                :customize-text="commonFunction.formatNumberWithDots"
                :allow-hiding="false"
                :editor-options="
                  commonFunction.editorOptionsFormatterSeparateTypingWithDots
                "
              />
              <DxColumn
                :allowHeaderFiltering="false"
                data-type="string"
                data-field="ket"
                caption="Catatan"
                :allow-hiding="false"
                :min-width="150"
                class="noteditable-ket"
              ></DxColumn>
              <DxColumn
                :allowHeaderFiltering="true"
                class="noteditable"
                data-field="edited_by_user"
                caption="Dibuat oleh"
                :allow-hiding="false"
                :header-filter="{
                  dataSource: commonStore.editedByUserSource,
                }"
                :allow-filtering="false"
              >
                <DxLookup
                  display-expr="nama"
                  value-expr="val"
                  :data-source="commonStore.editedByUserStore"
                />
              </DxColumn>

              <DxColumn
                caption="Dibuat oleh"
                class="noteditable"
                :allowHeaderFiltering="false"
                data-field="created_at_text"
                :allowFiltering="false"
                :allow-sorting="false"
                :allow-exporting="false"
                :allow-updating="false"
              />
              <!-- <DxColumn
                :allowHeaderFiltering="false"
                data-type="number"
                class="noteditable"
                caption="Terakhir di update oleh"
                cell-template="updatedTemplate"
              >
              </DxColumn> -->
              <DxColumn
                class="noteditable"
                caption="Diubah oleh"
                :allowHeaderFiltering="false"
                data-field="updated_at_text"
                :allowFiltering="false"
                :allow-sorting="false"
                :allow-exporting="false"
                :allow-updating="false"
              />
              <DxColumn
                class="noteditable"
                caption="Disetujui oleh"
                :allowHeaderFiltering="false"
                data-field="approved_at_text"
                :allowFiltering="false"
                :allow-sorting="false"
                :allow-exporting="false"
                :allow-updating="false"
              />

              <template #updatedTemplate="{ data }">
                <div v-html="templateUpdateByUser(data)"></div>
              </template>
              <!-- <DxColumn
                data-type="string"
                data-field="ket"
                caption="Catatan"
                :allow-hiding="false"
                class="noteditable-ket"
              ></DxColumn> -->

              <DxColumn type="buttons" :width="110">
                <DxButtonDataGrid name="edit" />
                <DxButtonDataGrid
                  hint="View Log Perubahan"
                  icon="clock"
                  :visible="true"
                  @click="this.$refs.logPopup.showBySubject($event, 'Gaji')"
                />
              </DxColumn>
              <DxSummary>
                <DxTotalItem
                  column="honor_umk_jml"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="kenaikan_masa_kerja"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_kesehatan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="premi_jkk"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="premi_jkm"
                  summary-type="sum"
                  value-format="#,##0"
                />

                <DxTotalItem
                  column="absen_bulans_tidak_hadir"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_5_persen"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="jml_bruto"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_kesehatan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_bpjs_tk_dua_persen"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="ifg_mandiri"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="total_diterima"
                  summary-type="sum"
                  value-format="#,##0"
                />
              </DxSummary>

              <DxColumnChooser :enabled="true" :mode="mode">
                <DxPosition
                  my="right top"
                  at="right bottom"
                  of=".dx-datagrid-column-chooser-button"
                />

                <DxColumnChooserSearch
                  :enabled="true"
                  :editor-options="editorOptions"
                />
                <DxColumnChooserSelection
                  :allow-select-all="allowSelectAll"
                  :select-by-click="selectByClick"
                  :recursive="recursive"
                />
              </DxColumnChooser>
            </DxDataGrid>
          </template>
          <template #tKontrak>
            <DxDataGrid
              ref="gridRefKontrak"
              :data-source="gajiListStore.dataSourceGajiKontrakList"
              :allow-column-reordering="true"
              :show-borders="true"
              key-expr="id"
              :show-column-lines="false"
              :column-auto-width="true"
              :column-hiding-enabled="false"
              @option-changed="onPageChanged($event, 'gridRefKontrak')"
              @exporting="onExporting"
              @editor-preparing="oneditorpreparing"
              :focused-row-enabled="true"
              @row-updating="onRowUpdating($event, 'gridRefKontrak')"
              :filter-value="filterValue"
              :filter-sync-enabled="true"
              @context-menu-preparing="
                onContextMenuPreparing($event, 'gridRefKontrak')
              "
              @row-prepared="rowPreparedTetap($event)"
              :remote-operations="true"
              :scrolling="{
                mode: 'virtual',
                rowRenderingMode: 'virtual',
                columnRenderingMode: 'virtual',
                useNative: true,
              }"
              :height="gridHeight"
            >
              <DxExport :enabled="true" />
              <DxEditing
                v-if="gajiPeriodeData"
                :allow-updating="allowUpdating()"
                :allow-deleting="false"
                :allow-adding="false"
                mode="row"
              />

              <DxPaging :enabled="true" :page-size="numberingPageSize" />
              <DxExport :enabled="true" />

              <DxHeaderFilter :visible="true" />
              <DxScrolling mode="virtual" />
              <DxFilterRow :visible="true" apply-filter="auto" />
              <DxPager
                :visible="true"
                :showPageSizeSelector="false"
                :showNavigationButtons="false"
                :show-info="true"
                :infoText="'Page {0} of {1} ({2} items)'"
              />

              <DxToolbar>
                <DxItem
                  location="after"
                  template="status-setujui-selection-template"
                />
                <DxItem location="after" template="refresh-template" />
                <DxItem name="exportButton" />
                <DxItem name="columnChooserButton" />
              </DxToolbar>
              <template #refresh-template>
                <DxButton
                  icon="refresh"
                  @click="refreshDatagrid('gridRefKontrak')"
                  text="Refresh Data"
                  type="default"
                  style="float: left"
                  width="160px"
                  styling-mode="outlined"
                ></DxButton>
              </template>
              <!-- <DxSelection mode="multiple" /> -->
              <template v-if="gajiPeriodeData && buttonCan('gaji-approve')">
                <DxSelection mode="multiple" :deferred="true" />
              </template>
              <template #status-setujui-selection-template>
                <DxButton
                  v-if="gajiPeriodeData && buttonCan('gaji-approve')"
                  icon="check"
                  @click="onSelectRowsConfirm('gridRefKontrak')"
                  text="Approve Pilihan"
                  type="success"
                  style="float: left"
                  styling-mode="outlined"
                ></DxButton>
              </template>
              <DxColumnFixing :enabled="true" />

              <DxColumn
                class="noteditable"
                caption="#"
                data-field="row_number"
                :allow-filtering="false"
                :allow-sorting="false"
                :allow-exporting="false"
                :fixed="true"
                fixed-position="left"
                data-type="number"
              />
              <DxColumn
                class="noteditable"
                data-field="status_gaji"
                caption="Status Gaji"
                cell-template="statusTemplate"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
                :allowHeaderFiltering="false"
              >
              </DxColumn>
              <DxColumn
                :visible="false"
                data-type="boolean"
                class="noteditable"
                data-field="tandai_salah"
                caption="Tandai Salah"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
              />
              <template #headerTemplate>
                <div
                  class="small-button-container"
                  style="display: inline-flex; align-items: center"
                >
                  <DxButton
                    :icon="isExpanded ? 'chevrondown' : 'chevronnext'"
                    @click="toggleHeaderExpand"
                  />
                  <span style="margin-left: 8px">Pekerjaan</span>
                </div>
              </template>
              <template #headerGajiTemplate>
                <div
                  class="small-button-container"
                  style="display: inline-flex; align-items: center"
                >
                  <DxButton
                    :icon="isExpandedGaji ? 'chevrondown' : 'chevronnext'"
                    @click="toggleHeaderGajiExpand"
                  />
                  <span style="margin-left: 8px">Gaji</span>
                </div>
              </template>
              <template #statusTemplate="{ data }">
                <!-- {{ formatStatusGaji(data.text) }} -->
                <DxButton
                  :icon="formatStatusGaji('icon', { data })"
                  :type="formatStatusGaji('type', { data })"
                  @click="approveClick({ data })"
                />
              </template>

              <DxColumn
                data-type="string"
                class="noteditable"
                data-field="simpeg_pegawais_nama"
                caption="Nama pegawai"
                :fixed="true"
                fixed-position="left"
                :allowHeaderFiltering="false"
                :allow-hiding="false"
                :min-width="200"
              />

              <DxColumn
                :allow-filtering="false"
                class="noteditable"
                data-field="tgl_gaji"
                caption="Periode Gaji"
                data-type="date"
                :display-format="'MM/yyyy'"
                :format="'MM/yyyy'"
                :calculate-filter-expression="calculateFilterExpression"
                :filter-operations="filterOperations"
                :customize-text="commonFunction.formatIsoDateToMonthYear"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
              >
              </DxColumn>
              <DxColumn
                :allow-hiding="false"
                class="noteditable"
                data-field="golongans_nama"
                caption="Gol."
                :allowHeaderFiltering="true"
                :header-filter="{
                  dataSource: commonStore.getGolonganSource().value,
                }"
              />
              <DxColumn
                caption="Pekerjaan"
                header-cell-template="headerTemplate"
                :allow-hiding="false"
                :allowHeaderFiltering="false"
                :min-width="150"
              >
                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="cabangs_nama"
                  caption="Cabang"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.cabangSource }"
                  :visible="isExpanded"
                />
                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="units_nama"
                  caption="Unit"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.unitSource }"
                  :visible="isExpanded"
                />
                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="jabatans_nama"
                  caption="Jabatan"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.jabatanSource }"
                  :visible="isExpanded"
                />

                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="bagians_nama"
                  caption="Bagian"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.bagianSource }"
                  :visible="isExpanded"
                />
                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="sub_bagians_nama"
                  caption="Sub Bagian"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.subBagianSource }"
                  :visible="isExpanded"
                />

                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="bidangs_nama"
                  caption="Bidang"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.bidangSource }"
                  :visible="isExpanded"
                />

                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="sub_bidangs_nama"
                  caption="Sub Bidang"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.subBidangSource }"
                  :visible="isExpanded"
                />
                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="seksis_nama"
                  caption="Seksi"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.seksiSource }"
                  :visible="isExpanded"
                />
              </DxColumn>

              <DxColumn
                class="noteditable"
                data-field="simpeg_pegawais_tgl_mulai_bekerja"
                caption="TMT Kontrak"
                data-type="date"
                :display-format="'dd/MM/yyyy'"
                :format="'dd/MM/yyyy'"
                :allow-hiding="false"
              />

              <!-- <DxColumn
                class="noteditable"
                data-field="pegawai.tgl_mulai_bekerja"
                caption="Masa Kerja"
                :calculate-cell-value="calculateCellMK"
                data-type="string"
              ></DxColumn> -->
              <DxColumn
                :allowHeaderFiltering="false"
                class="noteditable"
                data-type="number"
                data-field="masa_kerja"
                caption="Masa Kerja"
                :customize-text="commonFunction.appendTahun"
                :allow-hiding="false"
              />
              <DxColumn
                caption="Gaji"
                header-cell-template="headerGajiTemplate"
                :allow-hiding="false"
                :allowHeaderFiltering="false"
                :min-width="150"
              >
                <DxColumn
                  :allowHeaderFiltering="false"
                  class="noteditable-gaji"
                  data-type="number"
                  data-field="honor_umk_jml"
                  caption="Honor (UMK)"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  class="noteditable-gaji"
                  data-type="number"
                  data-field="kenaikan_masa_kerja"
                  caption="Kenaikan Masa Kerja"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  class="noteditable-gaji"
                  data-type="number"
                  data-field="tun_kesehatan"
                  caption="Tunj. Kesehatan"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  class="noteditable-gaji"
                  data-type="number"
                  data-field="premi_jkk"
                  caption="Premi JKK"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                />

                <DxColumn
                  :allowHeaderFiltering="false"
                  class="noteditable-gaji"
                  data-type="number"
                  data-field="premi_jkm"
                  caption="Premi JKM"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                />

                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  data-field="absen_bulans_tidak_hadir"
                  caption="Jml Tdk Hadir"
                  class="noteditable"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />
                <!-- <DxColumn data-field="jml_tdk_hadir" caption="Jml Tidak Hadir" /> -->
                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  class="noteditable"
                  data-field="pot_5_persen"
                  caption="Pot. Tdk Hadir"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  class="noteditable"
                  data-field="tun_bpjs_tk_satu_sembilanbelas_persen"
                  caption="Tunj. BPJS TK 1.19%"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                />

                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  class="noteditable"
                  data-field="jml_bruto"
                  caption="Jml Bruto"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  class="noteditable"
                  data-field="pot_kesehatan"
                  caption="Pot. Kesehatan"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  class="noteditable"
                  data-field="pot_bpjs_tk_satu_sembilanbelas_persen"
                  caption="Pot. BPJS TK 1.19%"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  class="noteditable"
                  data-field="ifg_mandiri"
                  caption="Pot. IFG Mandiri"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                />
              </DxColumn>

              <DxColumn
                :allowHeaderFiltering="false"
                data-type="number"
                class="noteditable"
                data-field="total_diterima"
                caption="Total Diterima"
                :customize-text="commonFunction.formatNumberWithDots"
                :allow-hiding="false"
                :editor-options="
                  commonFunction.editorOptionsFormatterSeparateTypingWithDots
                "
              />
              <DxColumn
                :allowHeaderFiltering="false"
                class="noteditable-ket"
                data-type="string"
                data-field="ket"
                :min-width="150"
                caption="Catatan"
                :allow-hiding="false"
              ></DxColumn>
              <DxColumn
                :allowHeaderFiltering="true"
                class="noteditable"
                data-field="edited_by_user"
                caption="Dibuat oleh"
                :allow-hiding="false"
                :header-filter="{
                  dataSource: commonStore.editedByUserSource,
                }"
                :allow-filtering="false"
              >
                <DxLookup
                  display-expr="nama"
                  value-expr="val"
                  :data-source="commonStore.editedByUserStore"
                />
              </DxColumn>

              <DxColumn
                caption="Dibuat oleh"
                class="noteditable"
                :allowHeaderFiltering="false"
                data-field="created_at_text"
                :allowFiltering="false"
                :allow-sorting="false"
                :allow-exporting="false"
                :allow-updating="false"
              />
              <!-- <DxColumn
                :allowHeaderFiltering="false"
                data-type="number"
                class="noteditable"
                caption="Terakhir di update oleh"
                cell-template="updatedTemplate"
              >
              </DxColumn> -->
              <DxColumn
                class="noteditable"
                caption="Diubah oleh"
                :allowHeaderFiltering="false"
                data-field="updated_at_text"
                :allowFiltering="false"
                :allow-sorting="false"
                :allow-exporting="false"
                :allow-updating="false"
              />
              <DxColumn
                class="noteditable"
                caption="Disetujui oleh"
                :allowHeaderFiltering="false"
                data-field="approved_at_text"
                :allowFiltering="false"
                :allow-sorting="false"
                :allow-exporting="false"
                :allow-updating="false"
              />

              <template #updatedTemplate="{ data }">
                <div v-html="templateUpdateByUser(data)"></div>
              </template>
              <!-- <DxColumn
                class="noteditable-ket"
                data-type="string"
                data-field="ket"
                caption="Catatan"
                :allow-hiding="false"
              ></DxColumn> -->
              <DxColumn type="buttons" :width="110">
                <DxButtonDataGrid name="edit" />
                <DxButtonDataGrid
                  hint="View Log Perubahan"
                  icon="clock"
                  :visible="true"
                  @click="this.$refs.logPopup.showBySubject($event, 'Gaji')"
                />
              </DxColumn>
              <DxSummary>
                <DxTotalItem
                  column="honor_umk_jml"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="kenaikan_masa_kerja"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_kesehatan"
                  summary-type="sum"
                  value-format="#,##0"
                />

                <DxTotalItem
                  column="premi_jkk"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="premi_jkm"
                  summary-type="sum"
                  value-format="#,##0"
                />

                <DxTotalItem
                  column="absen_bulans_tidak_hadir"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_5_persen"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_bpjs_tk_satu_sembilanbelas_persen"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="jml_bruto"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_kesehatan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_bpjs_tk_satu_sembilanbelas_persen"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="ifg_mandiri"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="total_diterima"
                  summary-type="sum"
                  value-format="#,##0"
                />
              </DxSummary>

              <DxColumnChooser :enabled="true" :mode="mode">
                <DxPosition
                  my="right top"
                  at="right bottom"
                  of=".dx-datagrid-column-chooser-button"
                />

                <DxColumnChooserSearch
                  :enabled="true"
                  :editor-options="editorOptions"
                />
                <DxColumnChooserSelection
                  :allow-select-all="allowSelectAll"
                  :select-by-click="selectByClick"
                  :recursive="recursive"
                />
              </DxColumnChooser>
            </DxDataGrid>
          </template>

          <template #tDewas>
            <DxDataGrid
              ref="gridRefDewas"
              :data-source="dewasGajiListStore.dataSourceDewasGajiDewasList"
              :allow-column-reordering="true"
              :show-borders="true"
              key-expr="id"
              :show-column-lines="false"
              :column-auto-width="true"
              :column-hiding-enabled="false"
              @option-changed="onPageChanged($event, 'gridRefDewas')"
              @exporting="onExporting"
              @editor-preparing="oneditorpreparing"
              :focused-row-enabled="true"
              @row-updating="onRowUpdating($event, 'gridRefDewas')"
              :filter-value="filterValue"
              :filter-sync-enabled="true"
              @context-menu-preparing="
                onContextMenuPreparing($event, 'gridRefDewas')
              "
              @row-prepared="rowPreparedTetap($event)"
              :remote-operations="true"
              :scrolling="{
                mode: 'virtual',
                rowRenderingMode: 'virtual',
                columnRenderingMode: 'virtual',
                useNative: true,
              }"
              :height="gridHeight"
            >
              <DxExport :enabled="true" />
              <DxEditing
                v-if="gajiPeriodeData"
                :allow-updating="allowUpdating()"
                :allow-deleting="false"
                :allow-adding="false"
                mode="row"
              />

              <DxPaging :enabled="true" :page-size="numberingPageSize" />
              <DxExport :enabled="true" />

              <DxHeaderFilter :visible="true" />
              <DxScrolling mode="virtual" />
              <DxFilterRow :visible="true" apply-filter="auto" />
              <DxPager
                :visible="true"
                :showPageSizeSelector="false"
                :showNavigationButtons="false"
                :show-info="true"
                :infoText="'Page {0} of {1} ({2} items)'"
              />

              <DxToolbar>
                <DxItem
                  location="after"
                  template="status-setujui-selection-template"
                />
                <DxItem location="after" template="refresh-template" />
                <DxItem name="exportButton" />
                <DxItem name="columnChooserButton" />
              </DxToolbar>
              <template #refresh-template>
                <DxButton
                  icon="refresh"
                  @click="refreshDatagrid('gridRefDewas')"
                  text="Refresh Data"
                  type="default"
                  style="float: left"
                  width="160px"
                  styling-mode="outlined"
                ></DxButton>
              </template>
              <!-- <DxSelection mode="multiple" /> -->
              <template v-if="gajiPeriodeData && buttonCan('gaji-approve')">
                <DxSelection mode="multiple" :deferred="true" />
              </template>
              <template #status-setujui-selection-template>
                <DxButton
                  v-if="gajiPeriodeData && buttonCan('gaji-approve')"
                  icon="check"
                  @click="onSelectRowsConfirm('gridRefDewas')"
                  text="Approve Pilihan"
                  type="success"
                  style="float: left"
                  styling-mode="outlined"
                ></DxButton>
              </template>
              <DxColumnFixing :enabled="true" />

              <DxColumn
                class="noteditable"
                caption="#"
                data-field="row_number"
                :allow-filtering="false"
                :allow-sorting="false"
                :allow-exporting="false"
                :fixed="true"
                fixed-position="left"
                data-type="number"
              />
              <DxColumn
                class="noteditable"
                data-field="status_gaji"
                caption="Status Gaji"
                cell-template="statusTemplate"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
                :allowHeaderFiltering="false"
              >
              </DxColumn>
              <DxColumn
                :visible="false"
                data-type="boolean"
                class="noteditable"
                data-field="tandai_salah"
                caption="Tandai Salah"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
              />

              <template #statusTemplate="{ data }">
                <!-- {{ formatStatusGaji(data.text) }} -->
                <DxButton
                  :icon="formatStatusGaji('icon', { data })"
                  :type="formatStatusGaji('type', { data })"
                  @click="approveClick({ data }, 'gridRefDewas')"
                />
              </template>

              <DxColumn
                data-type="string"
                class="noteditable"
                data-field="dewas_nama"
                caption="Nama"
                :fixed="true"
                fixed-position="left"
                :allowHeaderFiltering="false"
                :allow-hiding="false"
                :min-width="200"
              />

              <DxColumn
                :allow-filtering="false"
                class="noteditable"
                data-field="tgl_gaji"
                caption="Periode Gaji"
                data-type="date"
                :display-format="'MM/yyyy'"
                :format="'MM/yyyy'"
                :calculate-filter-expression="calculateFilterExpression"
                :filter-operations="filterOperations"
                :customize-text="commonFunction.formatIsoDateToMonthYear"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
              >
              </DxColumn>

              <DxColumn
                class="noteditable"
                data-field="dewas_pphs_ptkp"
                caption="PTKP"
                :allowHeaderFiltering="true"
                :header-filter="{ dataSource: commonStore.statusPtkpSource }"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable"
                data-field="dewas_pphs_ter"
                caption="TER PPH 21(%)"
                :allowHeaderFiltering="false"
                :allow-hiding="false"
                data-type="number"
              />

              <DxColumn
                class="noteditable"
                :allow-hiding="false"
                data-field="jabatans_nama"
                caption="Jabatan"
                :allowHeaderFiltering="true"
                :header-filter="{ dataSource: commonStore.jabatanDewasSource }"
              />

              <DxColumn
                :allowHeaderFiltering="false"
                class="noteditable-gaji"
                data-type="number"
                data-field="uang_jasa"
                caption="Uang Jasa"
                :customize-text="commonFunction.formatNumberWithDots"
                :allow-hiding="false"
                :editor-options="
                  commonFunction.editorOptionsFormatterSeparateTypingWithDots
                "
              />

              <DxColumn
                :allowHeaderFiltering="false"
                data-type="number"
                class="noteditable"
                data-field="pot_pph"
                caption="Pot. PPH"
                :customize-text="commonFunction.formatNumberWithDots"
                :allow-hiding="false"
                :editor-options="
                  commonFunction.editorOptionsFormatterSeparateTypingWithDots
                "
              />

              <DxColumn
                :allowHeaderFiltering="false"
                data-type="number"
                class="noteditable"
                data-field="total_diterima"
                caption="Total Diterima"
                :customize-text="commonFunction.formatNumberWithDots"
                :allow-hiding="false"
                :editor-options="
                  commonFunction.editorOptionsFormatterSeparateTypingWithDots
                "
              />
              <DxColumn
                :allowHeaderFiltering="false"
                class="noteditable-ket"
                data-type="string"
                data-field="ket"
                :min-width="150"
                caption="Catatan"
                :allow-hiding="false"
              ></DxColumn>
              <DxColumn
                :allowHeaderFiltering="true"
                class="noteditable"
                data-field="edited_by_user"
                caption="Dibuat oleh"
                :allow-hiding="false"
                :header-filter="{
                  dataSource: commonStore.editedByUserSource,
                }"
                :allow-filtering="false"
              >
                <DxLookup
                  display-expr="nama"
                  value-expr="val"
                  :data-source="commonStore.editedByUserStore"
                />
              </DxColumn>

              <DxColumn
                caption="Dibuat oleh"
                class="noteditable"
                :allowHeaderFiltering="false"
                data-field="created_at_text"
                :allowFiltering="false"
                :allow-sorting="false"
                :allow-exporting="false"
                :allow-updating="false"
              />

              <DxColumn
                class="noteditable"
                caption="Diubah oleh"
                :allowHeaderFiltering="false"
                data-field="updated_at_text"
                :allowFiltering="false"
                :allow-sorting="false"
                :allow-exporting="false"
                :allow-updating="false"
              />
              <DxColumn
                class="noteditable"
                caption="Disetujui oleh"
                :allowHeaderFiltering="false"
                data-field="approved_at_text"
                :allowFiltering="false"
                :allow-sorting="false"
                :allow-exporting="false"
                :allow-updating="false"
              />

              <template #updatedTemplate="{ data }">
                <div v-html="templateUpdateByUser(data)"></div>
              </template>
              <DxColumn type="buttons" :width="110">
                <DxButtonDataGrid name="edit" />
                <DxButtonDataGrid
                  hint="View Log Perubahan"
                  icon="clock"
                  :visible="true"
                  @click="
                    this.$refs.logPopup.showBySubject($event, 'DewasGaji')
                  "
                />
              </DxColumn>

              <DxSummary>
                <DxTotalItem
                  column="uang_jasa"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_pph"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="total_diterima"
                  summary-type="sum"
                  value-format="#,##0"
                />
              </DxSummary>

              <DxColumnChooser :enabled="true" :mode="mode">
                <DxPosition
                  my="right top"
                  at="right bottom"
                  of=".dx-datagrid-column-chooser-button"
                />

                <DxColumnChooserSearch
                  :enabled="true"
                  :editor-options="editorOptions"
                />
                <DxColumnChooserSelection
                  :allow-select-all="allowSelectAll"
                  :select-by-click="selectByClick"
                  :recursive="recursive"
                />
              </DxColumnChooser>
            </DxDataGrid>
          </template>

          <template #tDewasSekre>
            <DxDataGrid
              ref="gridRefDewasSekre"
              :data-source="dewasGajiListStore.dataSourceDewasGajiSekreList"
              :allow-column-reordering="true"
              :show-borders="true"
              key-expr="id"
              :show-column-lines="false"
              :column-auto-width="true"
              :column-hiding-enabled="false"
              @option-changed="onPageChanged($event, 'gridRefDewasSekre')"
              @exporting="onExporting"
              @editor-preparing="oneditorpreparing"
              :focused-row-enabled="true"
              @row-updating="onRowUpdating($event, 'gridRefDewasSekre')"
              :filter-value="filterValue"
              :filter-sync-enabled="true"
              @context-menu-preparing="
                onContextMenuPreparing($event, 'gridRefDewasSekre')
              "
              @row-prepared="rowPreparedTetap($event)"
              :remote-operations="true"
              :scrolling="{
                mode: 'virtual',
                rowRenderingMode: 'virtual',
                columnRenderingMode: 'virtual',
                useNative: true,
              }"
              :height="gridHeight"
            >
              <DxExport :enabled="true" />
              <DxEditing
                v-if="gajiPeriodeData"
                :allow-updating="allowUpdating()"
                :allow-deleting="false"
                :allow-adding="false"
                mode="row"
              />

              <DxPaging :enabled="true" :page-size="numberingPageSize" />
              <DxExport :enabled="true" />

              <DxHeaderFilter :visible="true" />
              <DxScrolling mode="virtual" />
              <DxFilterRow :visible="true" apply-filter="auto" />
              <DxPager
                :visible="true"
                :showPageSizeSelector="false"
                :showNavigationButtons="false"
                :show-info="true"
                :infoText="'Page {0} of {1} ({2} items)'"
              />

              <DxToolbar>
                <DxItem
                  location="after"
                  template="status-setujui-selection-template"
                />
                <DxItem location="after" template="refresh-template" />
                <DxItem name="exportButton" />
                <DxItem name="columnChooserButton" />
              </DxToolbar>
              <template #refresh-template>
                <DxButton
                  icon="refresh"
                  @click="refreshDatagrid('gridRefDewasSekre')"
                  text="Refresh Data"
                  type="default"
                  style="float: left"
                  width="160px"
                  styling-mode="outlined"
                ></DxButton>
              </template>
              <!-- <DxSelection mode="multiple" /> -->
              <template v-if="gajiPeriodeData && buttonCan('gaji-approve')">
                <DxSelection mode="multiple" :deferred="true" />
              </template>
              <template #status-setujui-selection-template>
                <DxButton
                  v-if="gajiPeriodeData && buttonCan('gaji-approve')"
                  icon="check"
                  @click="onSelectRowsConfirm('gridRefDewasSekre')"
                  text="Approve Pilihan"
                  type="success"
                  style="float: left"
                  styling-mode="outlined"
                ></DxButton>
              </template>
              <DxColumnFixing :enabled="true" />

              <DxColumn
                class="noteditable"
                caption="#"
                data-field="row_number"
                :allow-filtering="false"
                :allow-sorting="false"
                :allow-exporting="false"
                :fixed="true"
                fixed-position="left"
                data-type="number"
              />
              <DxColumn
                class="noteditable"
                data-field="status_gaji"
                caption="Status Gaji"
                cell-template="statusTemplate"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
                :allowHeaderFiltering="false"
              >
              </DxColumn>
              <DxColumn
                :visible="false"
                data-type="boolean"
                class="noteditable"
                data-field="tandai_salah"
                caption="Tandai Salah"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
              />

              <template #statusTemplate="{ data }">
                <!-- {{ formatStatusGaji(data.text) }} -->
                <DxButton
                  :icon="formatStatusGaji('icon', { data })"
                  :type="formatStatusGaji('type', { data })"
                  @click="approveClick({ data }, 'gridRefDewasSekre')"
                />
              </template>

              <DxColumn
                data-type="string"
                class="noteditable"
                data-field="dewas_nama"
                caption="Nama"
                :fixed="true"
                fixed-position="left"
                :allowHeaderFiltering="false"
                :allow-hiding="false"
                :min-width="200"
              />

              <DxColumn
                :allow-filtering="false"
                class="noteditable"
                data-field="tgl_gaji"
                caption="Periode Gaji"
                data-type="date"
                :display-format="'MM/yyyy'"
                :format="'MM/yyyy'"
                :calculate-filter-expression="calculateFilterExpression"
                :filter-operations="filterOperations"
                :customize-text="commonFunction.formatIsoDateToMonthYear"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
              >
              </DxColumn>
              <DxColumn
                class="noteditable"
                data-field="dewas_pphs_ptkp"
                caption="PTKP"
                :allowHeaderFiltering="true"
                :header-filter="{ dataSource: commonStore.statusPtkpSource }"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable"
                data-field="dewas_pphs_ter"
                caption="TER PPH 21(%)"
                :allowHeaderFiltering="false"
                :allow-hiding="false"
                data-type="number"
              />
              <DxColumn
                class="noteditable"
                :allow-hiding="false"
                data-field="jabatans_nama"
                caption="Jabatan"
                :allowHeaderFiltering="true"
                :header-filter="{ dataSource: commonStore.jabatanDewasSource }"
              />

              <DxColumn
                :allowHeaderFiltering="false"
                class="noteditable-gaji"
                data-type="number"
                data-field="honor"
                caption="Honor"
                :customize-text="commonFunction.formatNumberWithDots"
                :allow-hiding="false"
                :editor-options="
                  commonFunction.editorOptionsFormatterSeparateTypingWithDots
                "
              />

              <DxColumn
                :allowHeaderFiltering="false"
                data-type="number"
                class="noteditable"
                data-field="pot_pph"
                caption="Pot. PPH"
                :customize-text="commonFunction.formatNumberWithDots"
                :allow-hiding="false"
                :editor-options="
                  commonFunction.editorOptionsFormatterSeparateTypingWithDots
                "
              />

              <DxColumn
                :allowHeaderFiltering="false"
                data-type="number"
                class="noteditable"
                data-field="total_diterima"
                caption="Total Diterima"
                :customize-text="commonFunction.formatNumberWithDots"
                :allow-hiding="false"
                :editor-options="
                  commonFunction.editorOptionsFormatterSeparateTypingWithDots
                "
              />
              <DxColumn
                :allowHeaderFiltering="false"
                class="noteditable-ket"
                data-type="string"
                data-field="ket"
                :min-width="150"
                caption="Catatan"
                :allow-hiding="false"
              ></DxColumn>
              <DxColumn
                :allowHeaderFiltering="true"
                class="noteditable"
                data-field="edited_by_user"
                caption="Dibuat oleh"
                :allow-hiding="false"
                :header-filter="{
                  dataSource: commonStore.editedByUserSource,
                }"
                :allow-filtering="false"
              >
                <DxLookup
                  display-expr="nama"
                  value-expr="val"
                  :data-source="commonStore.editedByUserStore"
                />
              </DxColumn>

              <DxColumn
                caption="Dibuat oleh"
                class="noteditable"
                :allowHeaderFiltering="false"
                data-field="created_at_text"
                :allowFiltering="false"
                :allow-sorting="false"
                :allow-exporting="false"
                :allow-updating="false"
              />

              <DxColumn
                class="noteditable"
                caption="Diubah oleh"
                :allowHeaderFiltering="false"
                data-field="updated_at_text"
                :allowFiltering="false"
                :allow-sorting="false"
                :allow-exporting="false"
                :allow-updating="false"
              />
              <DxColumn
                class="noteditable"
                caption="Disetujui oleh"
                :allowHeaderFiltering="false"
                data-field="approved_at_text"
                :allowFiltering="false"
                :allow-sorting="false"
                :allow-exporting="false"
                :allow-updating="false"
              />

              <template #updatedTemplate="{ data }">
                <div v-html="templateUpdateByUser(data)"></div>
              </template>

              <DxColumn type="buttons" :width="110">
                <DxButtonDataGrid name="edit" />
                <DxButtonDataGrid
                  hint="View Log Perubahan"
                  icon="clock"
                  :visible="true"
                  @click="
                    this.$refs.logPopup.showBySubject($event, 'DewasGaji')
                  "
                />
              </DxColumn>
              <DxSummary>
                <DxTotalItem
                  column="honor"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_pph"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="total_diterima"
                  summary-type="sum"
                  value-format="#,##0"
                />
              </DxSummary>

              <DxColumnChooser :enabled="true" :mode="mode">
                <DxPosition
                  my="right top"
                  at="right bottom"
                  of=".dx-datagrid-column-chooser-button"
                />

                <DxColumnChooserSearch
                  :enabled="true"
                  :editor-options="editorOptions"
                />
                <DxColumnChooserSelection
                  :allow-select-all="allowSelectAll"
                  :select-by-click="selectByClick"
                  :recursive="recursive"
                />
              </DxColumnChooser>
            </DxDataGrid>
          </template>
        </DxTabPanel>
      </div>
      <DxPopup
        :height="900"
        :show-title="true"
        :title="popupRumusTitle"
        :drag-enabled="false"
        :hide-on-outside-click="true"
        v-model:visible="popupRumusVisible"
      >
        <template #content>
          <div
            v-if="
              popupRumusAllVisible &&
              gajiSkemaKomponenStore &&
              gajiSkemaKomponenStore.length > 0 &&
              gajiPokokSkemaDetailStore &&
              gajiPokokSkemaDetailStore.length > 0
            "
          >
            <DxTabPanel
              id="tabpanel"
              :data-source="tabLihatRumusSource"
              :loop="loop"
              :animation-enabled="animationEnabled"
              :swipe-enabled="swipeEnabled"
              item-title-template="title"
              @titleClick="tabTitleLihatRumusClick"
            >
              <!-- <template #title="{ data: item }">
                <span class="tab-panel-title">{{ item.text }}</span>
              </template> -->

              <template #title="{ data: item }">
                <span class="tab-panel-title">{{ item.text }}</span>
              </template>

              <template #tLihatRumusGapok>
                <GajiPokokTableTemplate
                  :gajiPokokId="gajiPeriodeData.gaji_pokok_skema_id"
                  :gajiPokokSkemaDetailStore="
                    commonFunction.filteredGajiPokokSkemaDetailStore(
                      gajiPokokSkemaDetailStore,
                      gajiPeriodeData.gaji_pokok_skema_id,
                    )
                  "
                />
              </template>
              <template #tLihatRumusDirut>
                <RumusListTemplate
                  :gajiSkemaId="gajiPeriodeData.gaji_skema_dirut_id"
                  :gajiSkemaKomponenStore="
                    commonFunction.filteredGajiSkemaKomponenStore(
                      gajiSkemaKomponenStore,
                      gajiPeriodeData.gaji_skema_dirut_id,
                    )
                  "
                />
              </template>
              <template #tLihatRumusDirum>
                <RumusListTemplate
                  :gajiSkemaId="gajiPeriodeData.gaji_skema_dirum_id"
                  :gajiSkemaKomponenStore="
                    commonFunction.filteredGajiSkemaKomponenStore(
                      gajiSkemaKomponenStore,
                      gajiPeriodeData.gaji_skema_dirum_id,
                    )
                  "
                />
              </template>
              <template #tLihatRumusDirtek>
                <RumusListTemplate
                  :gajiSkemaId="gajiPeriodeData.gaji_skema_dirtek_id"
                  :gajiSkemaKomponenStore="
                    commonFunction.filteredGajiSkemaKomponenStore(
                      gajiSkemaKomponenStore,
                      gajiPeriodeData.gaji_skema_dirtek_id,
                    )
                  "
                />
              </template>
              <template #tLihatRumusTetap>
                <RumusListTemplate
                  :gajiSkemaId="gajiPeriodeData.gaji_skema_tetap_id"
                  :gajiSkemaKomponenStore="
                    commonFunction.filteredGajiSkemaKomponenStore(
                      gajiSkemaKomponenStore,
                      gajiPeriodeData.gaji_skema_tetap_id,
                    )
                  "
                />
              </template>
              <template #tLihatRumusCapeg>
                <RumusListTemplate
                  :gajiSkemaId="gajiPeriodeData.gaji_skema_capeg_id"
                  :gajiSkemaKomponenStore="
                    commonFunction.filteredGajiSkemaKomponenStore(
                      gajiSkemaKomponenStore,
                      gajiPeriodeData.gaji_skema_capeg_id,
                    )
                  "
                />
              </template>
              <template #tLihatRumusHonor>
                <RumusListTemplate
                  :gajiSkemaId="gajiPeriodeData.gaji_skema_honor_id"
                  :gajiSkemaKomponenStore="
                    commonFunction.filteredGajiSkemaKomponenStore(
                      gajiSkemaKomponenStore,
                      gajiPeriodeData.gaji_skema_honor_id,
                    )
                  "
                />
              </template>
              <template #tLihatRumusKontrak>
                <RumusListTemplate
                  :gajiSkemaId="gajiPeriodeData.gaji_skema_kontrak_id"
                  :gajiSkemaKomponenStore="
                    commonFunction.filteredGajiSkemaKomponenStore(
                      gajiSkemaKomponenStore,
                      gajiPeriodeData.gaji_skema_kontrak_id,
                    )
                  "
                />
              </template>
              <template #tLihatRumusDewas>
                <RumusListTemplate
                  :gajiSkemaId="gajiPeriodeData.gaji_skema_dewas_id"
                  :gajiSkemaKomponenStore="
                    commonFunction.filteredGajiSkemaKomponenStore(
                      gajiSkemaKomponenStore,
                      gajiPeriodeData.gaji_skema_dewas_id,
                    )
                  "
                />
              </template>
            </DxTabPanel>
          </div>

          <div
            v-else-if="
              !popupGapokVisible &&
              !popupRumusAllVisible &&
              gajiSkemaKomponenStore &&
              gajiSkemaKomponenStore.length > 0
            "
          >
            <RumusListTemplate
              :gajiSkemaId="popupGajiSkemaId"
              :gajiSkemaKomponenStore="
                commonFunction.filteredGajiSkemaKomponenStore(
                  gajiSkemaKomponenStore,
                  popupGajiSkemaId,
                )
              "
            />
          </div>
          <div
            v-else-if="
              popupGapokVisible &&
              gajiPokokSkemaDetailStore &&
              gajiPokokSkemaDetailStore.length > 0
            "
          >
            <GajiPokokTableTemplate
              :gajiPokokId="popupGapokId"
              :gajiPokokSkemaDetailStore="
                commonFunction.filteredGajiPokokSkemaDetailStore(
                  gajiPokokSkemaDetailStore,
                  popupGapokId,
                )
              "
            />
          </div>
          <div v-else class="p-4 text-center text-muted">
            <div
              class="spinner-border"
              style="width: 3rem; height: 3rem"
              role="status"
            ></div>
          </div>
        </template>
      </DxPopup>

      <dx-popup
        :visible="popupLoadingVisible"
        title="Loading..."
        :drag-enabled="false"
        :hide-on-outside-click="false"
        width="300"
        :height="130"
      >
        <div class="d-flex justify-content-center">
          <div
            class="spinner-border"
            style="width: 3rem; height: 3rem"
            role="status"
          ></div>
        </div>
      </dx-popup>
      <DxPopup
        v-if="gajiPeriodeData"
        :visible="popupRefreshAllGajiVisible"
        title="Konfirmasi Setting Penggajian"
        :drag-enabled="false"
        :hide-on-outside-click="false"
        :height="650"
      >
        <div class="dx-fieldset">
          <div class="dx-field">
            <div class="dx-field-label">Periode Penggajian</div>
            <div class="dx-field-value">
              <DxDateBox
                :disabled="true"
                :show-clear-button="true"
                :use-mask-behavior="true"
                :input-attr="{ 'aria-label': 'Date' }"
                type="date"
                displayFormat="monthAndYear"
                :calendar-options="calendarMonthYear"
                :styling-mode="stylingMode"
                :label-mode="labelMode"
                width="100%"
                v-model="gajiPeriodeData.tgl"
              >
                <DxValidator>
                  <DxRequiredRule />
                </DxValidator>
              </DxDateBox>
            </div>
          </div>

          <div class="dx-field">
            <div class="dx-field-label">Skema Gaji Pokok</div>
            <div class="dx-field-value">
              <!-- :dataSource="commonStore.gajiPokokSkemaStore" -->
              <!-- -->
              <DxSelectBox
                @opened="loadGajiPokokSkema"
                :dataSource="gajiPokokSkemaStore"
                valueExpr="id"
                displayExpr="nama"
                :searchEnabled="true"
                searchExpr="nama"
                search-mode="startswith"
                :styling-mode="stylingMode"
                :label-mode="labelMode"
                width="100%"
                v-model="gajiPeriodeData.gaji_pokok_skema_id"
                item-template="customItemGapok"
              >
                <template #customItemGapok="{ data: itemData }">
                  <div class="custom-item">
                    <img
                      alt="Lihat Gapok"
                      src="./eye-solid.png"
                      class="clickable-image"
                      title="Lihat Gapok"
                      @click="lihatGapok(itemData)"
                    />
                    <div class="product-name">
                      {{ itemData.nama }}
                    </div>
                  </div>
                </template>
                <DxValidator>
                  <DxRequiredRule />
                </DxValidator>
              </DxSelectBox>
            </div>
          </div>
        </div>
        <div class="dx-fieldset">
          <div class="dx-fieldset-header">
            Skema penggajian untuk masing-masing status pegawai
          </div>

          <div class="dx-field">
            <div class="dx-field-label">Skema Gaji Direktur Utama</div>
            <div class="dx-field-value">
              <!-- :dataSource="commonStore.gajiSkemaDirutStore" -->
              <!-- -->
              <DxSelectBox
                @opened="loadGajiSkemaDirut"
                :dataSource="gajiSkemaDirutStore"
                valueExpr="id"
                displayExpr="nama"
                :searchEnabled="true"
                searchExpr="nama"
                search-mode="startswith"
                :styling-mode="stylingMode"
                :label-mode="labelMode"
                width="100%"
                v-model="gajiPeriodeData.gaji_skema_dirut_id"
                item-template="customItem"
              >
                <template #customItem="{ data: itemData }">
                  <div class="custom-item">
                    <img
                      alt="Lihat Rumus"
                      src="./eye-solid.png"
                      class="clickable-image"
                      title="Lihat rumus"
                      @click="lihatRumus(itemData)"
                    />
                    <div class="product-name">
                      {{ itemData.nama }}
                    </div>
                  </div>
                </template>
                <DxValidator>
                  <DxRequiredRule />
                </DxValidator>
              </DxSelectBox>
            </div>
          </div>

          <div class="dx-field">
            <div class="dx-field-label">Skema Gaji Direktur Umum</div>
            <div class="dx-field-value">
              <!-- :dataSource="commonStore.gajiSkemaDirumStore" -->
              <!-- -->
              <DxSelectBox
                @opened="loadGajiSkemaDirum"
                :dataSource="gajiSkemaDirumStore"
                valueExpr="id"
                displayExpr="nama"
                :searchEnabled="true"
                searchExpr="nama"
                search-mode="startswith"
                :styling-mode="stylingMode"
                :label-mode="labelMode"
                width="100%"
                v-model="gajiPeriodeData.gaji_skema_dirum_id"
                item-template="customItem"
              >
                <template #customItem="{ data: itemData }">
                  <div class="custom-item">
                    <img
                      alt="Lihat Rumus"
                      src="./eye-solid.png"
                      class="clickable-image"
                      title="Lihat rumus"
                      @click="lihatRumus(itemData)"
                    />
                    <div class="product-name">
                      {{ itemData.nama }}
                    </div>
                  </div>
                </template>
                <DxValidator>
                  <DxRequiredRule />
                </DxValidator>
              </DxSelectBox>
            </div>
          </div>

          <div class="dx-field">
            <div class="dx-field-label">Skema Gaji Direktur Teknik</div>
            <div class="dx-field-value">
              <!-- :dataSource="commonStore.gajiSkemaDirtekStore" -->
              <!-- -->
              <DxSelectBox
                @opened="loadGajiSkemaDirtek"
                :dataSource="gajiSkemaDirtekStore"
                valueExpr="id"
                displayExpr="nama"
                :searchEnabled="true"
                searchExpr="nama"
                search-mode="startswith"
                :styling-mode="stylingMode"
                :label-mode="labelMode"
                width="100%"
                v-model="gajiPeriodeData.gaji_skema_dirtek_id"
                item-template="customItem"
              >
                <template #customItem="{ data: itemData }">
                  <div class="custom-item">
                    <img
                      alt="Lihat Rumus"
                      src="./eye-solid.png"
                      class="clickable-image"
                      title="Lihat rumus"
                      @click="lihatRumus(itemData)"
                    />
                    <div class="product-name">
                      {{ itemData.nama }}
                    </div>
                  </div>
                </template>
                <DxValidator>
                  <DxRequiredRule />
                </DxValidator>
              </DxSelectBox>
            </div>
          </div>

          <div class="dx-field">
            <div class="dx-field-label">Skema Dewan Pengawas</div>
            <div class="dx-field-value">
              <!-- :dataSource="commonStore.gajiSkemaDewasStore" -->
              <!-- -->
              <DxSelectBox
                @opened="loadGajiSkemaDewas"
                :dataSource="gajiSkemaDewasStore"
                valueExpr="id"
                displayExpr="nama"
                :searchEnabled="true"
                searchExpr="nama"
                search-mode="startswith"
                :styling-mode="stylingMode"
                :label-mode="labelMode"
                width="100%"
                v-model="gajiPeriodeData.gaji_skema_dewas_id"
                item-template="customItem"
              >
                <template #customItem="{ data: itemData }">
                  <div class="custom-item">
                    <img
                      alt="Lihat Rumus"
                      src="./eye-solid.png"
                      class="clickable-image"
                      title="Lihat rumus"
                      @click="lihatRumus(itemData)"
                    />
                    <div class="product-name">
                      {{ itemData.nama }}
                    </div>
                  </div>
                </template>
                <DxValidator>
                  <DxRequiredRule />
                </DxValidator>
              </DxSelectBox>
            </div>
          </div>

          <div class="dx-field">
            <div class="dx-field-label">Skema Gaji Pegawai Tetap</div>
            <div class="dx-field-value">
              <!-- :dataSource="commonStore.gajiSkemaTetapStore" -->
              <!-- -->
              <DxSelectBox
                @opened="loadGajiSkemaTetap"
                :dataSource="gajiSkemaTetapStore"
                valueExpr="id"
                displayExpr="nama"
                :searchEnabled="true"
                searchExpr="nama"
                search-mode="startswith"
                :styling-mode="stylingMode"
                :label-mode="labelMode"
                width="100%"
                v-model="gajiPeriodeData.gaji_skema_tetap_id"
                item-template="customItem"
              >
                <template #customItem="{ data: itemData }">
                  <div class="custom-item">
                    <img
                      alt="Lihat Rumus"
                      src="./eye-solid.png"
                      class="clickable-image"
                      title="Lihat rumus"
                      @click="lihatRumus(itemData)"
                    />
                    <div class="product-name">
                      {{ itemData.nama }}
                    </div>
                  </div>
                </template>
                <DxValidator>
                  <DxRequiredRule />
                </DxValidator>
              </DxSelectBox>
            </div>
          </div>

          <div class="dx-field">
            <div class="dx-field-label">Skema Gaji Pegawai Capeg</div>
            <div class="dx-field-value">
              <!-- :dataSource="commonStore.gajiSkemaCapegStore" -->
              <!-- -->
              <DxSelectBox
                @opened="loadGajiSkemaCapeg"
                :dataSource="gajiSkemaCapegStore"
                valueExpr="id"
                displayExpr="nama"
                :searchEnabled="true"
                searchExpr="nama"
                search-mode="startswith"
                :styling-mode="stylingMode"
                :label-mode="labelMode"
                width="100%"
                v-model="gajiPeriodeData.gaji_skema_capeg_id"
                item-template="customItem"
              >
                <template #customItem="{ data: itemData }">
                  <div class="custom-item">
                    <img
                      alt="Lihat Rumus"
                      src="./eye-solid.png"
                      class="clickable-image"
                      title="Lihat rumus"
                      @click="lihatRumus(itemData)"
                    />
                    <div class="product-name">
                      {{ itemData.nama }}
                    </div>
                  </div>
                </template>
                <DxValidator>
                  <DxRequiredRule />
                </DxValidator>
              </DxSelectBox>
            </div>
          </div>

          <div class="dx-field">
            <div class="dx-field-label">Skema Gaji Pekerja Honor</div>
            <div class="dx-field-value">
              <!-- :dataSource="commonStore.gajiSkemaHonorStore" -->
              <!--  -->
              <DxSelectBox
                @opened="loadGajiSkemaHonor"
                :dataSource="gajiSkemaHonorStore"
                valueExpr="id"
                displayExpr="nama"
                :searchEnabled="true"
                searchExpr="nama"
                search-mode="startswith"
                :styling-mode="stylingMode"
                :label-mode="labelMode"
                width="100%"
                v-model="gajiPeriodeData.gaji_skema_honor_id"
                item-template="customItem"
              >
                <template #customItem="{ data: itemData }">
                  <div class="custom-item">
                    <img
                      alt="Lihat Rumus"
                      src="./eye-solid.png"
                      class="clickable-image"
                      title="Lihat rumus"
                      @click="lihatRumus(itemData)"
                    />
                    <div class="product-name">
                      {{ itemData.nama }}
                    </div>
                  </div>
                </template>
                <DxValidator>
                  <DxRequiredRule />
                </DxValidator>
              </DxSelectBox>
            </div>
          </div>

          <div class="dx-field">
            <div class="dx-field-label">Skema Gaji Pekerja Kontrak</div>
            <div class="dx-field-value">
              <!-- :dataSource="commonStore.gajiSkemaKontrakStore" -->
              <!---->
              <DxSelectBox
                @opened="loadGajiSkemaKontrak"
                :dataSource="gajiSkemaKontrakStore"
                valueExpr="id"
                displayExpr="nama"
                :searchEnabled="true"
                searchExpr="nama"
                search-mode="startswith"
                :styling-mode="stylingMode"
                :label-mode="labelMode"
                width="100%"
                v-model="gajiPeriodeData.gaji_skema_kontrak_id"
                item-template="customItem"
              >
                <template #customItem="{ data: itemData }">
                  <div class="custom-item">
                    <img
                      alt="Lihat Rumus"
                      src="./eye-solid.png"
                      class="clickable-image"
                      title="Lihat rumus"
                      @click="lihatRumus(itemData)"
                    />
                    <div class="product-name">
                      {{ itemData.nama }}
                    </div>
                  </div>
                </template>
                <DxValidator>
                  <DxRequiredRule />
                </DxValidator>
              </DxSelectBox>
            </div>
          </div>
        </div>

        <DxToolbarItem
          widget="dxButton"
          toolbar="bottom"
          location="before"
          :options="cancelButtonOptions"
        />

        <DxToolbarItem
          widget="dxButton"
          toolbar="bottom"
          location="after"
          :options="confirmButtonRefreshAllGajiOptions"
        />
      </DxPopup>

      <DxPopup
        :visible="popupWarningVisible"
        :title="popupWarningTitle"
        :drag-enabled="false"
        :hide-on-outside-click="false"
        width="400"
        :height="200"
      >
        <div>
          <p>
            <strong>{{ popupWarningContent }}</strong>
          </p>
        </div>
        <DxToolbarItem
          widget="dxButton"
          toolbar="bottom"
          location="before"
          :options="cancelButtonOptions"
        />

        <DxToolbarItem
          widget="dxButton"
          toolbar="bottom"
          location="after"
          :options="confirmButtonOptionsWarning"
        />
      </DxPopup>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.class-tandai-salah {
  background-color: rgba(243, 158, 108);
  /* Other styles as needed */
}
.class-tandai-salah td {
  background-color: rgba(
    243,
    158,
    108,
    0.5
  ); /* Ensures cells also have the background */
}

.custom-item {
  display: flex;
  align-items: center; /* Align image and text vertically */
}

.clickable-image {
  // height: 2em; /* Matches the font size of the text */
  height: 24px;
  width: auto; /* Maintain aspect ratio */
  margin-right: 1em; /* Space between the image and text */
  cursor: pointer; /* Show pointer cursor for clickable image */
}
.clickable-image:hover {
  transform: scale(1.1); /* Slightly enlarge the image on hover */
}

.custom-text {
  // font-size: 2em; /* Ensure text size matches the image size */
  // line-height: 2em; /* Align text vertically with the image */
  line-height: 24px;
}
</style>

<script>
import LogPopupTemplate from "./LogPopupTemplate.vue";
import { useGajiSettingStore } from "@/stores/views/gaji-setting-store";
import { useGajiListStore } from "@/stores/views/gaji-list-store";
import { useDewasGajiListStore } from "@/stores/views/dewas-gaji-list-store";
import GajiPokokTableTemplate from "./GajiPokokTableTemplate.vue";
import RumusListTemplate from "./RumusListTemplate.vue";
import { useCommonStore } from "@/stores/utility/common-store2";
import angkaTerbilang from "@develoka/angka-terbilang-js";
import * as XLSX from "xlsx";
import { DxValidator, DxRequiredRule } from "devextreme-vue/validator";
import DxSelectBox from "devextreme-vue/select-box";
import { DxPopup, DxToolbarItem } from "devextreme-vue/popup";
import router from "@/router";
import { useRoute } from "vue-router";
import can from "@/haspermission";
import DxTabPanel from "devextreme-vue/tab-panel";
import DxButton from "devextreme-vue/button";
import { confirm } from "devextreme/ui/dialog";
import {
  DxDataGrid,
  DxColumn,
  DxEditing,
  DxPaging,
  DxFilterRow,
  DxPager,
  DxColumnFixing,
  DxSelection,
  DxExport,
  DxToolbar,
  DxItem,
  DxSummary,
  DxTotalItem,
  DxColumnChooser,
  DxColumnChooserSearch,
  DxColumnChooserSelection,
  DxPosition,
  DxHeaderFilter,
  DxScrolling,
  DxLookup,
  DxButton as DxButtonDataGrid,
} from "devextreme-vue/data-grid";
import DxDateBox from "devextreme-vue/date-box";
// import { toHandlerKey } from "vue";
import { exportDataGrid } from "devextreme/excel_exporter";
import { Workbook } from "exceljs";
import saveAs from "file-saver";
import { DateTime } from "luxon";
import _ from "lodash";
import notify from "devextreme/ui/notify";
import axios from "axios";
import auth from "@/auth";
import api from "@/api";
import { API_BASE_URL } from "@/global-constants";

import * as commonFunction from "@/utils/common-function.js";

const tabSource = [
  {
    id: 1,
    text: "Direksi",
    template: "tDireksi",
  },
  {
    id: 2,
    text: "Pegawai Tetap",
    template: "tTetap",
  },
  {
    id: 3,
    text: "Calon Pegawai",
    template: "tCapeg",
  },
  {
    id: 4,
    text: "Pekerja Honor",
    template: "tHonor",
  },
  {
    id: 5,
    text: "Pekerja Kontrak",
    template: "tKontrak",
  },
  {
    id: 6,
    text: "Dewan Pengawas",
    template: "tDewas",
  },
  {
    id: 7,
    text: "Sekretariat Dewan Pengawas",
    template: "tDewasSekre",
  },
];

const tabLihatRumusSource = [
  {
    id: 1,
    text: "Skema Gaji Pokok",
    template: "tLihatRumusGapok",
  },
  {
    id: 2,
    text: "Skema Gaji Direktur Utama",
    template: "tLihatRumusDirut",
  },
  {
    id: 3,
    text: "Skema Gaji Direktur Umum",
    template: "tLihatRumusDirum",
  },
  {
    id: 4,
    text: "Skema Gaji Direktur Teknik",
    template: "tLihatRumusDirtek",
  },

  {
    id: 5,
    text: "Skema Gaji Pegawai Tetap",
    template: "tLihatRumusTetap",
  },
  {
    id: 6,
    text: "Skema Gaji Capeg",
    template: "tLihatRumusCapeg",
  },
  {
    id: 7,
    text: "Skema Gaji Pekerja Honor",
    template: "tLihatRumusHonor",
  },
  {
    id: 8,
    text: "Skema Gaji Pekerja Kontrak",
    template: "tLihatRumusKontrak",
  },
  {
    id: 9,
    text: "Skema Dewan Pengawas",
    template: "tLihatRumusDewas",
  },
];

export default {
  components: {
    // confirm,
    LogPopupTemplate,
    GajiPokokTableTemplate,
    RumusListTemplate,
    DxTabPanel,
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxPaging,
    DxFilterRow,
    DxPager,
    DxColumnFixing,
    DxSelection,
    DxExport,
    DxToolbar,
    DxItem,
    DxSummary,
    DxTotalItem,
    DxButton,
    DxColumnChooser,
    DxColumnChooserSearch,
    DxColumnChooserSelection,
    DxPosition,
    DxPopup,
    DxToolbarItem,
    DxSelectBox,
    DxDateBox,
    DxValidator,
    DxRequiredRule,
    DxHeaderFilter,
    DxScrolling,
    DxLookup,
    DxButtonDataGrid,

    // confirm,
  },
  setup() {
    const route = useRoute();
    useGajiListStore().setGajiPeriodeId(route.query.id);
    useDewasGajiListStore().setGajiPeriodeId(route.query.id);
    const gajiListStore = useGajiListStore();
    const dewasGajiListStore = useDewasGajiListStore();
    const commonStore = useCommonStore();
    const masaKerjaRange = Array.from({ length: 34 }, (_, i) => i);
    const gajiSettingStore = useGajiSettingStore();
    return {
      gajiSettingStore,
      gajiListStore,
      dewasGajiListStore,
      commonFunction,
      masaKerjaRange,
      commonStore,
    };
  },

  data() {
    return {
      logPopupRef: null,
      isLoadingKomponen: false,
      gajiPokokSkemaStore: null,
      gajiSkemaDirutStore: null,
      gajiSkemaDirumStore: null,
      gajiSkemaDirtekStore: null,
      gajiSkemaDewasStore: null,
      gajiSkemaTetapStore: null,
      gajiSkemaCapegStore: null,
      gajiSkemaHonorStore: null,
      gajiSkemaKontrakStore: null,
      gajiSkemaKomponenStore: null,
      gajiPokokSkemaDetailStore: null,

      isExpanded: true,
      isExpandedGaji: true,
      filterDefaultDireksi: ["pegawai_status_id", "=", 1],
      tabLihatRumusSource,
      popupRumusTitle: null,
      popupGapokId: null,
      popupGajiSkemaId: null,
      popupGapokVisible: null,
      popupRumusVisible: null,
      popupRumusAllVisible: null,
      rumusSource: null,
      statusGajiSource: [
        { val: true, nama: "Approved" },
        { val: false, nama: "Belum Approved" },
      ],
      stylingMode: "outlined",
      //outlined, filled, underlined
      labelMode: "floating",
      pejabatDirum: null,
      pejabatDirut: null,
      pejabatKabagUmum: null,
      pejabatKasubagPersonalia: null,
      pejabat: null,
      rowClickData: null,
      rowClickRef: null,
      pegawaiIdClick: null,

      calendarMonthYear: {
        maxZoomLevel: "year",
        minZoomLevel: "century",
      },

      popupWarningVisible: false,
      popupWarningContent: null,
      popupWarningTitle: null,
      opacitySalah: 1, // Initial opacity value
      opacityApproved: 1, // Initial opacity value
      opacityJmlPegawai: 1, // Initial opacity value
      notif: [],
      gajiPeriodeId: this.$route.query.id,
      gajiPeriodeData: null,
      periodeTitle: null,
      mode: "select",
      searchEnabled: true,
      allowSelectAll: true,
      selectByClick: true,
      recursive: true,
      editorOptions: { placeholder: "Search column" },

      router: router,
      statusButtonIcon: null,
      statusButtonType: null,
      numberingPageSize: 100,
      numberingPageNumber: 0,
      tabPanelIndex: 0,
      loop: false,
      animationEnabled: true,
      swipeEnabled: false,
      tabSource: tabSource,
      popupRefreshAllGajiVisible: false,
      popupLoadingVisible: false,
      editedSource: [
        { val: true, nama: "Diedit user" },
        { val: false, nama: "Dibuat sistem" },
      ],
      statusPtkpSource: [
        { nama: "" },
        { nama: "TK" },
        { nama: "K0" },
        { nama: "K1" },
        { nama: "K2" },
        { nama: "K3" },
      ],

      filterValue: [],

      currentFilter: [
        {
          key: "auto",
          name: "Immediately",
        },
      ],
      calculateFilterMK: function (
        filterValue,
        selectedFilterOperation,
        target,
      ) {
        if (selectedFilterOperation === "contains" && target == "filterRow") {
          const currentDate = DateTime.now();
          const mkDate = currentDate.minus({ years: filterValue });
          var filterExpression = [
            "year(" +
              this.dataField +
              ") ge " +
              mkDate.year +
              " and " +
              "year(" +
              this.dataField +
              ") le " +
              currentDate.year,
          ];

          return filterExpression;
        }
      },
      filterOperations: ["=", "<>", ">", "<", "between"],
      calculateFilterExpression: function (
        filterValue,
        selectedFilterOperation,
        target,
      ) {
        let column = this;
        if (selectedFilterOperation === "=" && target == "filterRow") {
          let bulan = filterValue.getMonth() + 1;
          var filterExpression = [
            "month(" +
              column.dataField +
              ") eq " +
              bulan.toString() +
              " and " +
              "year(" +
              column.dataField +
              ") eq " +
              filterValue.getFullYear().toString(),
          ];
          return filterExpression;
        }
        if (selectedFilterOperation === "<>" && target == "filterRow") {
          //notequal
          let bulan = filterValue.getMonth() + 1;
          var filterExpression2 = [
            "month(" +
              column.dataField +
              ") ne " +
              bulan.toString() +
              " and " +
              "year(" +
              column.dataField +
              ") ne " +
              filterValue.getFullYear().toString(),
          ];
          return filterExpression2;
        }
        if (selectedFilterOperation === "<" && target == "filterRow") {
          //less than
          let bulan = filterValue.getMonth() + 1;
          var filterExpression3 = [
            "year(" +
              column.dataField +
              ") lt " +
              filterValue.getFullYear().toString() +
              " or (year(" +
              column.dataField +
              ") eq " +
              filterValue.getFullYear().toString() +
              " and month(" +
              column.dataField +
              ") lt " +
              bulan +
              ")",
          ];
          return filterExpression3;
        }
        if (selectedFilterOperation === ">" && target == "filterRow") {
          //greater than
          let bulan = filterValue.getMonth() + 1;
          var filterExpression4 = [
            "year(" +
              column.dataField +
              ") gt " +
              filterValue.getFullYear().toString() +
              " or (year(" +
              column.dataField +
              ") eq " +
              filterValue.getFullYear().toString() +
              " and month(" +
              column.dataField +
              ") gt " +
              bulan +
              ")",
          ];
          return filterExpression4;
        }

        if (selectedFilterOperation === "between" && target == "filterRow") {
          // (year(Date) eq 2022 and month(Date) ge 5) or (year(Date) eq 2023 and month(Date) le 6)
          let bulan1 = filterValue[0].getMonth() + 1;
          let bulan2 = filterValue[1].getMonth() + 1;

          var filterExpression5 = [
            "month(" +
              column.dataField +
              ") ge " +
              bulan1 +
              " and year(" +
              column.dataField +
              ") ge " +
              filterValue[0].getFullYear() +
              " and " +
              "month(" +
              column.dataField +
              ") le " +
              bulan2 +
              " and year(" +
              column.dataField +
              ") le " +
              filterValue[1].getFullYear(),
          ];
          return filterExpression5;
        }

        // Invokes the default filtering behavior
        return column.defaultCalculateFilterExpression(arguments);
      },

      cancelButtonOptions: {
        text: "Close",
        type: "danger",
        onClick: () => {
          this.popupWarningVisible = false;
          this.popupRefreshAllGajiVisible = false;
        },
      },
      // popupWarningClicked: null,
      popupWarningStatusId: null,
      confirmButtonRefreshAllGajiOptions: {
        text: "Hitung Ulang Seluruh Gaji",
        onClick: () => {
          // this.popupRefreshAllGajiVisible = false; sementara disable
          this.refreshAllGaji();
        },
      },
      confirmButtonOptionsWarning: {
        text: "Confirm",
        onClick: async () => {
          this.popupWarningVisible = false;
          if (this.popupWarningStatusId === "refreshAllGajiConfirm") {
            // await this.loadSettingGaji();
            this.popupRefreshAllGajiVisible = true;
            return;
          }
          if (this.popupWarningStatusId === "refreshGajiPerPegawaiConfirm") {
            this.refreshGajiPerPegawai();
            return;
          }

          if (this.popupWarningStatusId === "refreshGajiPerDewasConfirm") {
            this.refreshGajiPerPegawai("dewas");

            return;
          }

          if (this.popupWarningStatusId === 3) {
            const updatedData = {
              status_gaji: true,
              tandai_salah: false,
              gaji_periode_id: this.gajiPeriodeId,
              approved_by_user_id: auth.getUser().id,
              // approved_at: DateTime.now().toFormat("yyyy-MM-dd HH:mm:ss.SSS"),
              approved_at: DateTime.now().toFormat("yyyy-MM-dd HH:mm:ss"),
            };
            this.sinkronAllGaji(updatedData);
          }
          this.updateStatusGajiPeriode(this.popupWarningStatusId);
          // if (typeof this[this.popupWarningClicked] === "function")
          //   this[this.popupWarningClicked]();
        },
      },
    };
  },
  computed: {
    gridHeight() {
      // Calculate grid height based on your requirements
      return "80vh"; // Set the height to fill the viewport vertically
    },
  },

  async created() {
    await this.commonStore.preloadStores();
  },

  async mounted() {
    //await this.fetchDataPejabatPembuatGaji();
    this.pejabat = await this.commonFunction.getPejabatPengesahan(
      this.$route.query.tgl,
    );

    console.log("Pejabat Pengesahan:", this.pejabat);

    this.notif = await this.fetchDataNotif();
    this.gajiPeriodeData = await this.fetchDataPeriode();

    this.periodeTitle = this.formatMonthTitle(this.$route.query.tgl);

    document.title = "Daftar Gaji Periode " + this.periodeTitle;
  },
  watch: {
    popupRumusVisible: {
      async handler(visible) {
        if (
          visible &&
          (!this.gajiSkemaKomponenStore ||
            this.gajiSkemaKomponenStore.length === 0)
        ) {
          this.isLoadingKomponen = true;
          this.gajiSkemaKomponenStore =
            await this.gajiSettingStore.getGajiSkemaKomponen();
          this.isLoadingKomponen = false;
        }

        if (
          visible &&
          (!this.gajiPokokSkemaDetailStore ||
            this.gajiPokokSkemaDetailStore.length === 0)
        ) {
          this.isLoadingKomponen = true;
          this.gajiPokokSkemaDetailStore =
            await this.gajiSettingStore.getGajiPokokSkemaDetail();
          this.isLoadingKomponen = false;
        }
      },
      immediate: false,
    },
  },

  methods: {
    async loadSettingGaji() {
      if (
        !this.gajiPokokSkemaStore &&
        !this.gajiSkemaStore &&
        !this.gajiPokokSkemaStore &&
        !this.gajiPokokSkemaDetailStore &&
        !this.tunAirStore &&
        !this.tunPanganStore &&
        !this.tunJabatanStore &&
        !this.tunJabatanDetailStore &&
        !this.tunPanganDetailStore
      ) {
        this.popupLoadingVisible = true;
        const [
          gajiSkema,
          gajiPokokSkema,
          gajiPokokSkemaDetail,
          tunAir,
          tunPangan,
          tunJabatan,
          tunJabatanDetail,
          tunPanganDetail,
          gajiSkemaKomponen,
        ] = await Promise.all([
          this.gajiSettingStore.getGajiSkema(),
          this.gajiSettingStore.getGajiPokokSkema(),
          this.gajiSettingStore.getGajiPokokSkemaDetail(),
          this.gajiSettingStore.getTunAir(),
          this.gajiSettingStore.getTunPangan(),
          this.gajiSettingStore.getTunJabatan(),
          this.gajiSettingStore.getTunJabatanDetail(),
          this.gajiSettingStore.getTunPanganDetail(),
          this.gajiSettingStore.getGajiSkemaKomponen(),
        ]);

        this.gajiSkemaStore = gajiSkema;
        this.gajiPokokSkemaStore = gajiPokokSkema;
        this.gajiPokokSkemaDetailStore = gajiPokokSkemaDetail;
        this.tunAirStore = tunAir;
        this.tunPanganStore = tunPangan;
        this.tunJabatanStore = tunJabatan;
        this.tunJabatanDetailStore = tunJabatanDetail;
        this.tunPanganDetailStore = tunPanganDetail;
        this.gajiSkemaKomponenStore = gajiSkemaKomponen;

        // await this.loadGajiPokokSkema();
        // await this.loadGajiSkemaDirut();
        // await this.loadGajiSkemaDirum();
        // await this.loadGajiSkemaDirtek();
        // await this.loadGajiSkemaDewas();
        // await this.loadGajiSkemaTetap();
        // await this.loadGajiSkemaCapeg();
        // await this.loadGajiSkemaHonor();
        // await this.loadGajiSkemaKontrak();
        this.popupLoadingVisible = false;
      }
    },

    async loadGajiPokokSkema() {
      if (!this.gajiPokokSkemaStore) {
        this.gajiPokokSkemaStore =
          await this.gajiSettingStore.getGajiPokokSkema();
      }
    },
    async loadGajiSkemaDirut() {
      if (!this.gajiSkemaDirutStore) {
        this.gajiSkemaDirutStore =
          await this.gajiSettingStore.getGajiSkemaDirut();
      }
    },

    async loadGajiSkemaDirtek() {
      if (!this.gajiSkemaDirtekStore) {
        this.gajiSkemaDirtekStore =
          await this.gajiSettingStore.getGajiSkemaDirtek();
      }
    },

    async loadGajiSkemaDirum() {
      if (!this.gajiSkemaDirumStore) {
        this.gajiSkemaDirumStore =
          await this.gajiSettingStore.getGajiSkemaDirum();
      }
    },

    async loadGajiSkemaDewas() {
      if (!this.gajiSkemaDewasStore) {
        this.gajiSkemaDewasStore =
          await this.gajiSettingStore.getGajiSkemaDewas();
      }
    },

    async loadGajiSkemaTetap() {
      if (!this.gajiSkemaTetapStore) {
        this.gajiSkemaTetapStore =
          await this.gajiSettingStore.getGajiSkemaTetap();
      }
    },

    async loadGajiSkemaCapeg() {
      if (!this.gajiSkemaCapegStore) {
        this.gajiSkemaCapegStore =
          await this.gajiSettingStore.getGajiSkemaCapeg();
      }
    },

    async loadGajiSkemaHonor() {
      if (!this.gajiSkemaHonorStore) {
        this.gajiSkemaHonorStore =
          await this.gajiSettingStore.getGajiSkemaHonor();
      }
    },

    async loadGajiSkemaKontrak() {
      if (!this.gajiSkemaKontrakStore) {
        this.gajiSkemaKontrakStore =
          await this.gajiSettingStore.getGajiSkemaKontrak();
      }
    },

    onSelectRowsConfirm(gridRef) {
      let result = confirm(
        "<strong>Approve gaji yang dipilih?</strong> <br> Gaji yang sudah disetujui/approve tidak dapat diubah lagi",
        "Konfirmasi Approve Gaji",
      );
      result.then((dialogResult) => {
        if (dialogResult) {
          this.onSelectRows(gridRef);
        }
      });
    },
    async onSelectRows(gridRef) {
      const dataGrid = this.$refs[gridRef].instance;
      const selectedRows = await dataGrid.getSelectedRowsData();
      if (selectedRows.length === 0) {
        notify("Tidak ada gaji yang dipilih", "error");
        return;
      }
      const filteredRows = selectedRows.filter(
        (row) => row.status_gaji === false,
      );
      const ids = filteredRows.map((row) => row.id);
      if (ids.length === 0) {
        notify("Tidak ada gaji yang dapat diapprove", "error");
        return;
      }

      this.approveGajiMass(ids, gridRef);
    },

    async approveGajiMass(ids, gridRef) {
      let data = {
        ids: ids,
        status_gaji: true,
        tandai_salah: false,
        approved_by_user_id: auth.getUser().id,
        approved_at: DateTime.now().toFormat("yyyy-MM-dd HH:mm:ss"),
        table: "gajis",
      };

      if (gridRef === "gridRefDewas" || gridRef === "gridRefDewasSekre") {
        data.table = "dewas_gajis";
      }

      const config = {
        headers: {
          Authorization: api.defaults.headers.common["Authorization"],
          "content-type": "application/json",
        },
      };
      //ambil ids gaji yang diapprove
      try {
        const response = await axios.post(
          `${API_BASE_URL}/gaji_mass_approved`,
          data,
          config,
        );
        if (response.data.status) {
          notify("Berhasil approve gaji", "success");
          this.$refs[gridRef].instance.getDataSource().reload();
          this.refreshNotif();
          // this.notif = await this.fetchDataNotif();
          return true;
        } else {
          notify("Gagal approve gaji", "error");
          return false;
        }
      } catch (error) {
        console.log("Gagal approve gaji: ", error);
        notify("Gagal approve gaji", "error");
        return false;
      }
    },

    async approveClick(e, gridRef = null) {
      if (!this.can("gaji-approve")) return 0;
      if (e.data.value) return 0; //gaji sudah diapprove
      if (!this.can("superadmin") && this.gajiPeriodeData.gaji_status_id !== 2)
        return 0;

      // closestTr.classList.remove("class-tandai-salah");
      // rowElement[0].classList.remove("class-tandai-salah");
      // rowElement[1].classList.remove("class-tandai-salah");

      if (await this.approveGaji(e.data.data.id, gridRef)) {
        e.data.data.status_gaji = true;
        setTimeout(() => {
          const closestTr = e.data.cellElement.closest("tr");
          var rowElement = e.data.component.getRowElement(e.data.rowIndex);

          if (rowElement) {
            rowElement[0].classList.remove("class-tandai-salah");
            rowElement[1].classList.remove("class-tandai-salah");
          }
          if (closestTr) {
            closestTr.classList.remove("class-tandai-salah");
          }
        }, 0); // Delay by 0ms to ensure the update occurs after the event loop.

        //ini kenapa ga bisa view row element, like i wanna cry for real
      }
    },

    rowPreparedTetap(e) {
      if (e.rowType === "data" && e.data) {
        if (e.data.tandai_salah) {
          e.rowElement.classList.add("class-tandai-salah");
        }
      }
    },

    rowPrepared(e) {
      if (e.rowType === "data" && e.data) {
        const rowElements = e.component.getRowElement(e.rowIndex);

        if (rowElements && rowElements.length === 2) {
          if (e.data.tandai_salah) {
            e.rowElement.classList.add("class-tandai-salah");
          }
        }
      }
    },

    onContextMenuPreparing(e, gridRef) {
      if (e.target == "content") {
        // e.items can be undefined
        if (e.row.isEditing) return;
        if (!e.items) e.items = [];

        // !e.row.data.tandai_salah &&
        //   this.can("gaji-approve") &&
        //   !e.row.data.status_gaji;

        if (
          e.row.data.tandai_salah &&
          this.can("gaji-approve") &&
          !e.row.data.status_gaji
        ) {
          e.items.push({
            text: "Tandai Benar",
            icon: "check",
            onItemClick: () => {
              const rowElements = e.component.getRowElement(e.rowIndex);
              rowElements[0].classList.remove("class-tandai-salah");
              rowElements[1].classList.remove("class-tandai-salah");
              e.row.data.tandai_salah = false;
              if (gridRef === "gridRefDewas" || gridRef === "gridRefDewasSekre")
                this.tandaiSalah(e.row.data.dewas_gajis_id, false, "dewasGaji");
              else this.tandaiSalah(e.row.data.gajis_id, false);
            },
          });
        }

        if (
          !e.row.data.tandai_salah &&
          this.can("gaji-approve") &&
          !e.row.data.status_gaji
        ) {
          e.items.push({
            text: "Tandai Salah",
            icon: "remove",
            onItemClick: () => {
              const rowElements = e.component.getRowElement(e.rowIndex);
              rowElements[0].classList.add("class-tandai-salah");
              rowElements[1].classList.add("class-tandai-salah");
              e.row.data.tandai_salah = true;
              // this.tandaiSalah(e.row.data.gajis_id, true);

              if (gridRef === "gridRefDewas" || gridRef === "gridRefDewasSekre")
                this.tandaiSalah(e.row.data.dewas_gajis_id, true, "dewasGaji");
              else this.tandaiSalah(e.row.data.gajis_id, true);
            },
          });
        }

        if (
          this.gajiPeriodeData &&
          this.allowUpdating() &&
          !e.row.data.status_gaji
        ) {
          e.items.push({
            text: "Edit",
            icon: "edit",
            beginGroup: true,
            onItemClick: () => {
              e.component.editRow(e.rowIndex);
            },
          });
          e.items.push({
            text: "Hitung Ulang",
            icon: "refresh",
            onItemClick: () => {
              this.refreshGajiPerPegawaiConfirm(e, gridRef);
            },
          });
        }

        if (gridRef === "gridRefDewas" || gridRef === "gridRefDewasSekre") {
          let temp = "";
          if (gridRef === "gridRefDewasSekre") temp = "Sekretariat ";
          e.items.push({
            text: "Lihat Detail " + temp + "Dewan Pengawas",
            icon: "user",
            onItemClick: () => {
              this.detailPegawai(e, "dewas-detail");
            },
          });
          e.items.push({
            text: "Log Perubahan Data",
            icon: "clock",
            onItemClick: () => {
              e.itemData = "Log Perubahan Data";
              this.$refs.logPopup.showBySubject(e.row.data.id, "DewasGaji");
            },
          });
        } else {
          e.items.push({
            text: "Lihat Detail Pegawai",
            icon: "user",
            onItemClick: () => {
              this.detailPegawai(e);
              // e.component.editRow(e.component.getRowIndexByKey(item));
            },
          });
          e.items.push({
            text: "Lihat Absensi",
            icon: "event",
            onItemClick: () => {
              this.detailAbsen(e);
              // e.component.editRow(e.component.getRowIndexByKey(item));
            },
          });
          e.items.push({
            text: "Log Perubahan Data",
            icon: "clock",
            onItemClick: () => {
              e.itemData = "Log Perubahan Data";
              this.$refs.logPopup.showBySubject(e.row.data.id, "Gaji");
            },
          });
        }
      }
    },
    toggleHeaderExpand() {
      this.isExpanded = !this.isExpanded;
    },
    toggleHeaderGajiExpand() {
      this.isExpandedGaji = !this.isExpandedGaji;
    },

    async lihatGapok(data) {
      this.popupRumusTitle = data.nama;
      this.popupGapokId = data.id;
      this.popupGapokVisible = true;
      this.popupRumusVisible = true;
      this.popupRumusAllVisible = false;
    },

    lihatRumusAll() {
      this.popupRumusTitle = "Gapok dan Rumus Penggajian";
      // this.popupGapokId = data.id;
      this.popupGapokVisible = false;
      this.popupRumusVisible = true;
      this.popupRumusAllVisible = true;
      this.popupGapokVisible = false;
    },

    async lihatRumus(data) {
      this.popupRumusTitle = data.nama;
      this.popupGajiSkemaId = data.id;
      this.popupGapokVisible = false;
      this.popupRumusAllVisible = false;
      this.popupRumusVisible = true;
    },

    print() {
      this.formatMonthTitle(this.$route.query.tgl);
      // this.$router.push({
      //   name: "testing-playground",
      //   query: { tgl: this.$route.query.tgl },
      // });

      const url = this.$router.resolve({
        name: "gaji-print",
        query: { tgl: this.$route.query.tgl },
      }).href;
      window.open(url, "_blank");
    },
    async fetchDataPejabatPembuatGaji() {
      const config = {
        headers: {
          Authorization: api.defaults.headers.common["Authorization"],
          "content-type": "application/json",
        },
      };

      const data = {
        tgl_gaji: null,
      };

      const response = await axios.post(
        `${API_BASE_URL}/pejabat_gaji`,
        data,
        config,
      );

      this.pejabatDirum = response.data.dirum
        ? response.data.dirum.simpeg_pegawai.nama
        : null;
      this.pejabatDirut = response.data.dirut
        ? response.data.dirut.simpeg_pegawai.nama
        : null;
      this.pejabatKabagUmum = response.data.kabagUmum
        ? response.data.kabagUmum.simpeg_pegawai.nama
        : null;
      this.pejabatKasubagPersonalia = response.data.kasubagPersonalia
        ? response.data.kasubagPersonalia.simpeg_pegawai.nama
        : null;
    },

    prepare_data_excel(data, cari, cariValue, unitId = null, orderBy = null) {
      var temp = null;
      if (unitId === null) {
        temp = _.filter(data, (item) => {
          return _.get(item, cari) === cariValue;
        });
      } else if (unitId === 0) {
        temp = _.filter(data, (item) => {
          return (
            _.get(item, cari) === cariValue &&
            _.get(item, "riwayat_pekerjaan.unit_id") === null
          );
        });
      } else {
        temp = _.filter(data, (item) => {
          return (
            _.get(item, cari) === cariValue &&
            _.get(item, "riwayat_pekerjaan.unit_id") === unitId
          );
        });
      }

      // return _.orderBy(
      //   temp,
      //   [(item) => _.get(item, "riwayat_pekerjaan.jabatan_id")],
      //   ["asc"]
      // );
      if (orderBy === "honorKontrak") {
        return _.orderBy(
          temp,
          [
            (item) => _.get(item, "pegawai.tgl_mulai_bekerja"),
            (item) => _.get(item, "pegawai.nama"),
          ],
          ["asc", "asc"],
        );
      } else if (orderBy !== null)
        return _.orderBy(temp, [(item) => _.get(item, orderBy)], ["asc"]);
      else
        return _.orderBy(
          temp,
          [
            (item) => _.get(item, "riwayat_pekerjaan.jabatan_id"),
            (item) => _.get(item, "pegawai.nik"),
          ],
          ["asc", "asc"],
        );
    },
    prepare_data_bagians(bagianId) {
      var tempBagian = _.filter(this.commonStore.bagianStore, (item) => {
        return _.get(item, "id") === bagianId;
      });
      tempBagian = _.map(tempBagian, (item) => {
        return {
          ...item,
          nama: `Bagian ${item.nama}`,
        };
      });

      var tempSubBagian = _.filter(this.commonStore.subBagianStore, (item) => {
        return _.get(item, "sub_bagians_bagian_id") === bagianId;
      });
      tempSubBagian = _.map(tempSubBagian, (item) => {
        return {
          ...item,
          nama: `Sub Bag ${item.nama}`,
        };
      });
      tempSubBagian = _.orderBy(tempSubBagian, ["order"], ["asc"]);

      return _.concat(tempBagian, tempSubBagian);
    },

    prepare_data_seksi(cabangData, cabangId, unitId = null) {
      //cabangData sudah difilter berdasarkan cabang n unit
      const seksiIds = _.uniq(_.map(cabangData, "riwayat_pekerjaan.seksi_id"));
      var tempSeksi = _.filter(this.commonStore.seksiStore, (obj) =>
        seksiIds.includes(obj.id),
      );
      var tempCabang = null;
      if (unitId === null)
        tempCabang = _.filter(this.commonStore.cabangStore, (item) => {
          return _.get(item, "id") === cabangId;
        });
      else {
        tempCabang = _.filter(this.commonStore.unitStore, (item) => {
          return _.get(item, "id") === unitId;
        });
      }

      tempSeksi = _.orderBy(tempSeksi, ["order"], ["asc"]);

      return _.concat(tempCabang, tempSeksi);
    },

    prepare_data_bidangs(bidangId) {
      var tempBidang = _.filter(this.commonStore.bidangStore, (item) => {
        return _.get(item, "id") === bidangId;
      });
      tempBidang = _.map(tempBidang, (item) => {
        return {
          ...item,
          nama: `Bidang ${item.nama}`,
        };
      });

      var tempSubBidang = _.filter(this.commonStore.subBidangStore, (item) => {
        return _.get(item, "sub_bidangs_bidang_id") === bidangId;
      });
      tempSubBidang = _.map(tempSubBidang, (item) => {
        return {
          ...item,
          nama: `Sub Bidang ${item.nama}`,
        };
      });
      tempSubBidang = _.orderBy(tempSubBidang, ["order"], ["asc"]);

      return _.concat(tempBidang, tempSubBidang);
    },

    prepare_data_pemimpin(data) {
      var temp = _.filter(data, (item) => {
        const jabatanId = _.get(item, "riwayat_pekerjaan.jabatan_id");
        return (
          _.inRange(jabatanId, 4, 7) ||
          _.get(item, "riwayat_pekerjaan.jabatan_id") === 9
        ); // 7 is exclusive, so it checks for values between 4 and 6
      }); //9 = kaunit
      return temp;
    },

    prepare_data_staf(data) {
      // var temp = _.filter(data, (item) => {
      //   const jabatanId = _.get(item, "riwayat_pekerjaan.jabatan_id");
      //   return (
      //     !_.inRange(jabatanId, 4, 7) &&
      //     !_.get(item, "riwayat_pekerjaan.jabatan_id") === 9
      //   ); // 7 is exclusive, so it checks for values between 4 and 6
      // });
      var temp = _.filter(data, (item) => {
        const jabatanId = _.get(item, "riwayat_pekerjaan.jabatan_id");
        return !([4, 5, 6].includes(jabatanId) || jabatanId === 9);
      });

      return temp;
    },

    async downloadFileExcel() {
      this.popupLoadingVisible = true;
      const dataTetapCapeg = await this.fetchGaji(
        "gajis",
        this.gajiPeriodeId,
        2,
        3,
      );
      const dataDewas = await this.fetchGaji("dewas_gajis", this.gajiPeriodeId);

      const dataHonor = await this.fetchGaji("gajis", this.gajiPeriodeId, 4);
      const dataKontrak = await this.fetchGaji("gajis", this.gajiPeriodeId, 5);
      this.popupLoadingVisible = false;
      const dataBagianUmum = this.prepare_data_excel(
        dataTetapCapeg,
        "riwayat_pekerjaan.bagian_id",
        1,
      );

      const dataDireksi = await this.fetchGaji("gajis", this.gajiPeriodeId, 1);
      const dataBagianSPI = this.prepare_data_excel(
        dataTetapCapeg,
        "riwayat_pekerjaan.bidang_id",
        1,
      );

      const dataBagianLitbang = this.prepare_data_excel(
        dataTetapCapeg,
        "riwayat_pekerjaan.bidang_id",
        2,
      );

      const dataBagianKeuangan = this.prepare_data_excel(
        dataTetapCapeg,
        "riwayat_pekerjaan.bagian_id",
        2,
      );
      const dataBagianPelayanan = this.prepare_data_excel(
        dataTetapCapeg,
        "riwayat_pekerjaan.bagian_id",
        3,
      );
      const dataBagianPerencana = this.prepare_data_excel(
        dataTetapCapeg,
        "riwayat_pekerjaan.bagian_id",
        4,
      );
      const dataBagianProduksi = this.prepare_data_excel(
        dataTetapCapeg,
        "riwayat_pekerjaan.bagian_id",
        5,
      );
      const dataBagianDistribusi = this.prepare_data_excel(
        dataTetapCapeg,
        "riwayat_pekerjaan.bagian_id",
        6,
      );

      const workbook = XLSX.utils.book_new();
      const sheetName = "ADMINISTRASI";
      XLSX.utils.book_append_sheet(workbook, {}, sheetName);
      const sheetNameHonor = "TENAGA HONOR";
      const sheetNameKontrak = "TENAGA KONTRAK";
      const sheetNameDewas = "DEWAN PENGAWAS";
      const sheetNameDewasSekre = "SEKRETARIAT DEWAN PENGAWAS";
      XLSX.utils.book_append_sheet(workbook, {}, sheetNameHonor);
      XLSX.utils.book_append_sheet(workbook, {}, sheetNameKontrak);

      var row = 3;
      var numbering = 0;

      //KONTRAK - PUSAT
      const dataKontrakPusat = this.prepare_data_excel(
        dataKontrak,
        "riwayat_pekerjaan.cabang_id",
        1,
        null,
        // "riwayat_pekerjaan.tgl_mulai_bekerja"
        "honorKontrak",
      );

      row = this.wbAddHeaderHonor(
        workbook,
        sheetNameKontrak,
        row,
        "GAJI/UPAH PEKERJA KONTRAK KANTOR PUSAT",
        "UNTUK BULAN  : " + this.periodeTitle.toUpperCase(),
        "pusat",
      ); //status pegawai/bulan/cabang
      row = this.wbAddHeaderKomponenKontrak(workbook, sheetNameKontrak, row); //nama, no, golongan

      row = this.wbAddContentKontrak(
        workbook,
        sheetNameKontrak,
        row,
        numbering,
        dataKontrakPusat,
      );
      row = this.wbAddContentKontrakFooter(
        workbook,
        sheetNameKontrak,
        row,
        dataKontrakPusat,
      );
      numbering = numbering + dataKontrakPusat.length;
      //END KONTRAK PUSAT

      //KONTRAK - KUBUTAMBAHAN
      const dataKontrakKubutambahan = this.prepare_data_excel(
        dataKontrak,
        "riwayat_pekerjaan.cabang_id",
        6,
        null,
        // "riwayat_pekerjaan.tgl_mulai_bekerja"
        "honorKontrak",
      );
      if (dataKontrakKubutambahan.length > 0) {
        row = this.wbAddHeaderHonor(
          workbook,
          sheetNameKontrak,
          row,
          "GAJI/UPAH PEKERJA KONTRAK KANTOR CABANG KUBUTAMBAHAN",
          "UNTUK BULAN  : " + this.periodeTitle.toUpperCase(),
        ); //status pegawai/bulan/cabang
        row = this.wbAddHeaderKomponenKontrak(workbook, sheetNameKontrak, row); //nama, no, golongan

        row = this.wbAddContentKontrak(
          workbook,
          sheetNameKontrak,
          row,
          numbering,
          dataKontrakKubutambahan,
        );
        row = this.wbAddContentKontrakFooter(
          workbook,
          sheetNameKontrak,
          row,
          dataKontrakKubutambahan,
        );
      }
      numbering = numbering + dataKontrakKubutambahan.length;
      //END OF KONTRAK KUBUTAMBAHAN

      //KONTRAK - LOVINA
      const dataKontrakLovina = this.prepare_data_excel(
        dataKontrak,
        "riwayat_pekerjaan.cabang_id",
        5,
        null,
        // "riwayat_pekerjaan.tgl_mulai_bekerja"
        "honorKontrak",
      );

      if (dataKontrakLovina.length > 0) {
        row = this.wbAddHeaderHonor(
          workbook,
          sheetNameKontrak,
          row,
          "GAJI/UPAH PEKERJA KONTRAK KANTOR CABANG LOVINA",
          "UNTUK BULAN  : " + this.periodeTitle.toUpperCase(),
        ); //status pegawai/bulan/cabang
        row = this.wbAddHeaderKomponenKontrak(workbook, sheetNameKontrak, row); //nama, no, golongan

        row = this.wbAddContentKontrak(
          workbook,
          sheetNameKontrak,
          row,
          numbering,
          dataKontrakLovina,
        );
        row = this.wbAddContentKontrakFooter(
          workbook,
          sheetNameKontrak,
          row,
          dataKontrakLovina,
        );
      }
      numbering = numbering + dataKontrakLovina.length;
      //END OF KONTRAK LOVINA

      //KONTRAK - SERIRIT
      const dataKontrakSeririt = this.prepare_data_excel(
        dataKontrak,
        "riwayat_pekerjaan.cabang_id",
        4,
        null,
        // "riwayat_pekerjaan.tgl_mulai_bekerja"
        "honorKontrak",
      );

      if (dataKontrakSeririt.length > 0) {
        row = this.wbAddHeaderHonor(
          workbook,
          sheetNameKontrak,
          row,
          "GAJI/UPAH PEKERJA KONTRAK KANTOR CABANG SERIRIT",
          "UNTUK BULAN  : " + this.periodeTitle.toUpperCase(),
        ); //status pegawai/bulan/cabang
        row = this.wbAddHeaderKomponenKontrak(workbook, sheetNameKontrak, row); //nama, no, golongan

        row = this.wbAddContentKontrak(
          workbook,
          sheetNameKontrak,
          row,
          numbering,
          dataKontrakSeririt,
        );
        row = this.wbAddContentKontrakFooter(
          workbook,
          sheetNameKontrak,
          row,
          dataKontrakSeririt,
        );
      }
      numbering = numbering + dataKontrakSeririt.length;
      //END OF KONTRAK SERIRIT

      //KONTRAK - GEROKGAK
      const dataKontrakGerokgak = this.prepare_data_excel(
        dataKontrak,
        "riwayat_pekerjaan.cabang_id",
        2,
        null,
        // "riwayat_pekerjaan.tgl_mulai_bekerja"
        "honorKontrak",
      );

      if (dataKontrakGerokgak.length > 0) {
        row = this.wbAddHeaderHonor(
          workbook,
          sheetNameKontrak,
          row,
          "GAJI/UPAH PEKERJA KONTRAK KANTOR CABANG GEROKGAK",
          "UNTUK BULAN  : " + this.periodeTitle.toUpperCase(),
        ); //status pegawai/bulan/cabang
        row = this.wbAddHeaderKomponenKontrak(workbook, sheetNameKontrak, row); //nama, no, golongan

        row = this.wbAddContentKontrak(
          workbook,
          sheetNameKontrak,
          row,
          numbering,
          dataKontrakGerokgak,
        );
        row = this.wbAddContentKontrakFooter(
          workbook,
          sheetNameKontrak,
          row,
          dataKontrakGerokgak,
        );
      }
      numbering = numbering + dataKontrakGerokgak.length;
      //END OF KONTRAK GEROKGAK

      //KONTRAK - BUSUNGBIU
      const dataKontrakBusungbiu = this.prepare_data_excel(
        dataKontrak,
        "riwayat_pekerjaan.cabang_id",
        3,
        null,
        // "riwayat_pekerjaan.tgl_mulai_bekerja"
        "honorKontrak",
      );

      if (dataKontrakBusungbiu.length > 0) {
        row = this.wbAddHeaderHonor(
          workbook,
          sheetNameKontrak,
          row,
          "GAJI/UPAH PEKERJA KONTRAK KANTOR CABANG BUSUNGBIU",
          "UNTUK BULAN  : " + this.periodeTitle.toUpperCase(),
        ); //status pegawai/bulan/cabang
        row = this.wbAddHeaderKomponenKontrak(workbook, sheetNameKontrak, row); //nama, no, golongan

        row = this.wbAddContentKontrak(
          workbook,
          sheetNameKontrak,
          row,
          numbering,
          dataKontrakBusungbiu,
        );
        row = this.wbAddContentKontrakFooter(
          workbook,
          sheetNameKontrak,
          row,
          dataKontrakBusungbiu,
        );
      }
      numbering = numbering + dataKontrakBusungbiu.length;
      //END OF KONTRAK BUSUNGBIU
      row = this.wbAddContentKontrakFooterTerbilang(
        workbook,
        sheetNameKontrak,
        row,
        dataKontrak,
      );

      // XLSX.writeFile(workbook, "testing export gaji.xlsx");
      // return;

      //=========================================================================================================

      //HONOR - PUSAT
      row = 3;
      numbering = 0;
      const dataHonorPusat = this.prepare_data_excel(
        dataHonor,
        "riwayat_pekerjaan.cabang_id",
        1,
        null,
        // "riwayat_pekerjaan.tgl_mulai_bekerja"
        "honorKontrak",
      );

      row = this.wbAddHeaderHonor(
        workbook,
        sheetNameHonor,
        row,
        "GAJI/UPAH PEKERJA KONTRAK KANTOR PUSAT",
        "UNTUK BULAN  : " + this.periodeTitle.toUpperCase(),
        "pusat",
      ); //status pegawai/bulan/cabang
      row = this.wbAddHeaderKomponenHonor(workbook, sheetNameHonor, row); //nama, no, golongan

      row = this.wbAddContentHonor(
        workbook,
        sheetNameHonor,
        row,
        numbering,
        dataHonorPusat,
      );
      row = this.wbAddContentHonorFooter(
        workbook,
        sheetNameHonor,
        row,
        dataHonorPusat,
      );
      numbering = numbering + dataHonorPusat.length;
      //END OF HONOR PUSAT

      //HONOR - KUBUTAMBAHAN
      const dataHonorKubutambahan = this.prepare_data_excel(
        dataHonor,
        "riwayat_pekerjaan.cabang_id",
        6,
        null,
        // "riwayat_pekerjaan.tgl_mulai_bekerja"
        "honorKontrak",
      );
      if (dataHonorKubutambahan.length > 0) {
        row = this.wbAddHeaderHonor(
          workbook,
          sheetNameHonor,
          row,
          "GAJI/UPAH PEKERJA KONTRAK KANTOR CABANG KUBUTAMBAHAN",
          "UNTUK BULAN  : " + this.periodeTitle.toUpperCase(),
        ); //status pegawai/bulan/cabang
        row = this.wbAddHeaderKomponenHonor(workbook, sheetNameHonor, row); //nama, no, golongan

        row = this.wbAddContentHonor(
          workbook,
          sheetNameHonor,
          row,
          numbering,
          dataHonorKubutambahan,
        );
        row = this.wbAddContentHonorFooter(
          workbook,
          sheetNameHonor,
          row,
          dataHonorKubutambahan,
        );
      }
      numbering = numbering + dataHonorKubutambahan.length;
      //END OF HONOR KUBUTAMBAHAN

      //HONOR - LOVINA
      const dataHonorLovina = this.prepare_data_excel(
        dataHonor,
        "riwayat_pekerjaan.cabang_id",
        5,
        null,
        // "riwayat_pekerjaan.tgl_mulai_bekerja"
        "honorKontrak",
      );
      if (dataHonorLovina.length > 0) {
        row = this.wbAddHeaderHonor(
          workbook,
          sheetNameHonor,
          row,
          "GAJI/UPAH PEKERJA KONTRAK KANTOR CABANG LOVINA",
          "UNTUK BULAN  : " + this.periodeTitle.toUpperCase(),
        ); //status pegawai/bulan/cabang
        row = this.wbAddHeaderKomponenHonor(workbook, sheetNameHonor, row); //nama, no, golongan

        row = this.wbAddContentHonor(
          workbook,
          sheetNameHonor,
          row,
          numbering,
          dataHonorLovina,
        );
        row = this.wbAddContentHonorFooter(
          workbook,
          sheetNameHonor,
          row,
          dataHonorLovina,
        );
      }
      numbering = numbering + dataHonorLovina.length;
      //END OF HONOR LOVINA

      //HONOR - SERIRIT
      const dataHonorSeririt = this.prepare_data_excel(
        dataHonor,
        "riwayat_pekerjaan.cabang_id",
        4,
        null,
        // "riwayat_pekerjaan.tgl_mulai_bekerja"
        "honorKontrak",
      );
      if (dataHonorSeririt.length > 0) {
        row = this.wbAddHeaderHonor(
          workbook,
          sheetNameHonor,
          row,
          "GAJI/UPAH PEKERJA KONTRAK KANTOR CABANG SERIRIT",
          "UNTUK BULAN  : " + this.periodeTitle.toUpperCase(),
        ); //status pegawai/bulan/cabang
        row = this.wbAddHeaderKomponenHonor(workbook, sheetNameHonor, row); //nama, no, golongan

        row = this.wbAddContentHonor(
          workbook,
          sheetNameHonor,
          row,
          numbering,
          dataHonorSeririt,
        );
        row = this.wbAddContentHonorFooter(
          workbook,
          sheetNameHonor,
          row,
          dataHonorSeririt,
        );
      }
      numbering = numbering + dataHonorSeririt.length;
      //END OF HONOR SERIRIT

      //HONOR - GEROKGAK
      const dataHonorGerokgak = this.prepare_data_excel(
        dataHonor,
        "riwayat_pekerjaan.cabang_id",
        2,
        null,
        // "riwayat_pekerjaan.tgl_mulai_bekerja"
        "honorKontrak",
      );
      if (dataHonorGerokgak.length > 0) {
        row = this.wbAddHeaderHonor(
          workbook,
          sheetNameHonor,
          row,
          "GAJI/UPAH PEKERJA KONTRAK KANTOR CABANG GEROKGAK",
          "UNTUK BULAN  : " + this.periodeTitle.toUpperCase(),
        ); //status pegawai/bulan/cabang
        row = this.wbAddHeaderKomponenHonor(workbook, sheetNameHonor, row); //nama, no, golongan

        row = this.wbAddContentHonor(
          workbook,
          sheetNameHonor,
          row,
          numbering,
          dataHonorGerokgak,
        );
        row = this.wbAddContentHonorFooter(
          workbook,
          sheetNameHonor,
          row,
          dataHonorGerokgak,
        );
      }
      numbering = numbering + dataHonorGerokgak.length;
      //END OF HONOR GEROKGAK

      //HONOR - BUSUNGBIU
      const dataHonorBusungbiu = this.prepare_data_excel(
        dataHonor,
        "riwayat_pekerjaan.cabang_id",
        3,
        null,
        // "riwayat_pekerjaan.tgl_mulai_bekerja"
        "honorKontrak",
      );
      if (dataHonorBusungbiu.length > 0) {
        row = this.wbAddHeaderHonor(
          workbook,
          sheetNameHonor,
          row,
          "GAJI/UPAH PEKERJA KONTRAK KANTOR CABANG BUSUNGBIU",
          "UNTUK BULAN  : " + this.periodeTitle.toUpperCase(),
        ); //status pegawai/bulan/cabang
        row = this.wbAddHeaderKomponenHonor(workbook, sheetNameHonor, row); //nama, no, golongan

        row = this.wbAddContentHonor(
          workbook,
          sheetNameHonor,
          row,
          numbering,
          dataHonorBusungbiu,
        );
        row = this.wbAddContentHonorFooter(
          workbook,
          sheetNameHonor,
          row,
          dataHonorBusungbiu,
        );
      }
      numbering = numbering + dataHonorBusungbiu.length;
      //END OF HONOR BUSUNGBIU

      row = this.wbAddContentHonorFooterTerbilang(
        workbook,
        sheetNameHonor,
        row,
        dataHonor,
      );
      // XLSX.writeFile(workbook, "testing export gaji.xlsx");
      // return;
      //========================================================================================================
      /////MULAI SHEET ADMINISTRASI PEGAWAI TETAP PUSAT DAN CABANG
      row = 3;
      row = this.wbAddHeaderTetap(
        workbook,
        sheetName,
        row,
        "DAFTAR PEMBAYARAN GAJI DIREKSI",
        "UNTUK BULAN  : " + this.periodeTitle.toUpperCase(),
      ); //status pegawai/bulan/cabang
      //direksi
      row = this.wbAddHeaderKomponenDireksi(workbook, sheetName, row); //nama, no, golongan
      row = this.wbAddContentTetap(workbook, sheetName, row, dataDireksi); //isi data
      row = row + 10;

      //TETAP - SPI
      row = this.wbAddHeaderTetap(
        workbook,
        sheetName,
        row,
        "DAFTAR PEMBAYARAN GAJI SATUAN PENGAWAS INTERN",
        "UNTUK BULAN  : " + this.periodeTitle.toUpperCase(),
      );
      row = this.wbAddHeaderKomponen(workbook, sheetName, row); //nama, no, golongan
      var bagianTitle = this.prepare_data_bidangs(1);

      var bagianPemimpin = this.prepare_data_pemimpin(dataBagianSPI);
      var bagianStaf = this.prepare_data_staf(dataBagianSPI);

      row = this.wbAddContentTetapPerBagian(
        workbook,
        sheetName,
        row,
        bagianTitle,
        bagianPemimpin,
        bagianStaf,
        "riwayat_pekerjaan.sub_bidang_id",
      ); //isi data

      row = this.wbAddContentTetapFooter(
        workbook,
        sheetName,
        row,
        dataBagianSPI,
      );
      row = row + 15;
      //END TETAP SPI

      //TETAP - UMUM
      row = this.wbAddHeaderTetap(
        workbook,
        sheetName,
        row,
        "DAFTAR PEMBAYARAN GAJI BAGIAN UMUM",
        "UNTUK BULAN  : " + this.periodeTitle.toUpperCase(),
      );
      row = this.wbAddHeaderKomponen(workbook, sheetName, row); //nama, no, golongan
      bagianTitle = this.prepare_data_bagians(1);
      bagianPemimpin = this.prepare_data_pemimpin(dataBagianUmum);
      bagianStaf = this.prepare_data_staf(dataBagianUmum);
      row = this.wbAddContentTetapPerBagian(
        workbook,
        sheetName,
        row,
        bagianTitle,
        bagianPemimpin,
        bagianStaf,
        "riwayat_pekerjaan.sub_bagian_id",
      ); //isi data
      row = this.wbAddContentTetapFooter(
        workbook,
        sheetName,
        row,
        dataBagianUmum,
      );
      row = row + 15;
      //END TETAP UMUM

      //TETAP - KEUANGAN
      row = this.wbAddHeaderTetap(
        workbook,
        sheetName,
        row,
        "DAFTAR PEMBAYARAN GAJI BAGIAN KEUANGAN",
        "UNTUK BULAN  : " + this.periodeTitle.toUpperCase(),
      );
      row = this.wbAddHeaderKomponen(workbook, sheetName, row); //nama, no, golongan
      bagianTitle = this.prepare_data_bagians(2);
      bagianPemimpin = this.prepare_data_pemimpin(dataBagianKeuangan);
      bagianStaf = this.prepare_data_staf(dataBagianKeuangan);
      row = this.wbAddContentTetapPerBagian(
        workbook,
        sheetName,
        row,
        bagianTitle,
        bagianPemimpin,
        bagianStaf,
        "riwayat_pekerjaan.sub_bagian_id",
      ); //isi data
      row = this.wbAddContentTetapFooter(
        workbook,
        sheetName,
        row,
        dataBagianKeuangan,
      );
      row = row + 15;
      //END TETAP KEUANGAN

      //TETAP - PELAYANAN
      row = this.wbAddHeaderTetap(
        workbook,
        sheetName,
        row,
        "DAFTAR PEMBAYARAN GAJI BAGIAN PELAYANAN",
        "UNTUK BULAN  : " + this.periodeTitle.toUpperCase(),
      );
      row = this.wbAddHeaderKomponen(workbook, sheetName, row); //nama, no, golongan
      bagianTitle = this.prepare_data_bagians(3);
      bagianPemimpin = this.prepare_data_pemimpin(dataBagianPelayanan);
      bagianStaf = this.prepare_data_staf(dataBagianPelayanan);
      row = this.wbAddContentTetapPerBagian(
        workbook,
        sheetName,
        row,
        bagianTitle,
        bagianPemimpin,
        bagianStaf,
        "riwayat_pekerjaan.sub_bagian_id",
      ); //isi data
      row = this.wbAddContentTetapFooter(
        workbook,
        sheetName,
        row,
        dataBagianPelayanan,
      );
      row = row + 15;
      //END TETAP PELAYANAN

      //TETAP - PERANCANA TEKNIK
      row = this.wbAddHeaderTetap(
        workbook,
        sheetName,
        row,
        "DAFTAR PEMBAYARAN GAJI BAGIAN PERANCANA TEKNIK",
        "UNTUK BULAN  : " + this.periodeTitle.toUpperCase(),
      );
      row = this.wbAddHeaderKomponen(workbook, sheetName, row); //nama, no, golongan
      bagianTitle = this.prepare_data_bagians(4);
      bagianPemimpin = this.prepare_data_pemimpin(dataBagianPerencana);
      bagianStaf = this.prepare_data_staf(dataBagianPerencana);
      row = this.wbAddContentTetapPerBagian(
        workbook,
        sheetName,
        row,
        bagianTitle,
        bagianPemimpin,
        bagianStaf,
        "riwayat_pekerjaan.sub_bagian_id",
      ); //isi data
      row = this.wbAddContentTetapFooter(
        workbook,
        sheetName,
        row,
        dataBagianPerencana,
      );
      row = row + 15;
      //END TETAP PERANCANA TEKNIK

      //TETAP - PPRODUKSI
      row = this.wbAddHeaderTetap(
        workbook,
        sheetName,
        row,
        "DAFTAR PEMBAYARAN GAJI BAGIAN PRODUKSI",
        "UNTUK BULAN  : " + this.periodeTitle.toUpperCase(),
      );
      row = this.wbAddHeaderKomponen(workbook, sheetName, row); //nama, no, golongan
      bagianTitle = this.prepare_data_bagians(5);
      bagianPemimpin = this.prepare_data_pemimpin(dataBagianProduksi);
      bagianStaf = this.prepare_data_staf(dataBagianProduksi);
      row = this.wbAddContentTetapPerBagian(
        workbook,
        sheetName,
        row,
        bagianTitle,
        bagianPemimpin,
        bagianStaf,
        "riwayat_pekerjaan.sub_bagian_id",
      ); //isi data
      row = this.wbAddContentTetapFooter(
        workbook,
        sheetName,
        row,
        dataBagianProduksi,
      );
      row = row + 15;
      //END TETAP PRODUKSI

      //TETAP - DISTRIBUSI
      row = this.wbAddHeaderTetap(
        workbook,
        sheetName,
        row,
        "DAFTAR PEMBAYARAN GAJI BAGIAN DISTRIBUSI",
        "UNTUK BULAN  : " + this.periodeTitle.toUpperCase(),
      );
      row = this.wbAddHeaderKomponen(workbook, sheetName, row); //nama, no, golongan
      bagianTitle = this.prepare_data_bagians(6);
      bagianPemimpin = this.prepare_data_pemimpin(dataBagianDistribusi);
      bagianStaf = this.prepare_data_staf(dataBagianDistribusi);
      row = this.wbAddContentTetapPerBagian(
        workbook,
        sheetName,
        row,
        bagianTitle,
        bagianPemimpin,
        bagianStaf,
        "riwayat_pekerjaan.sub_bagian_id",
      ); //isi data
      row = this.wbAddContentTetapFooter(
        workbook,
        sheetName,
        row,
        dataBagianDistribusi,
      );
      row = row + 15;
      //END TETAP DISTRIBUSI

      //TETAP - LITBANG
      row = this.wbAddHeaderTetap(
        workbook,
        sheetName,
        row,
        "DAFTAR PEMBAYARAN GAJI LITBANG",
        "UNTUK BULAN  : " + this.periodeTitle.toUpperCase(),
      );
      row = this.wbAddHeaderKomponen(workbook, sheetName, row); //nama, no, golongan
      bagianTitle = this.prepare_data_bidangs(2);

      bagianPemimpin = this.prepare_data_pemimpin(dataBagianLitbang);
      bagianStaf = this.prepare_data_staf(dataBagianLitbang);
      row = this.wbAddContentTetapPerBagian(
        workbook,
        sheetName,
        row,
        bagianTitle,
        bagianPemimpin,
        bagianStaf,
        "riwayat_pekerjaan.sub_bidang_id",
      ); //isi data
      row = this.wbAddContentTetapFooter(
        workbook,
        sheetName,
        row,
        dataBagianLitbang,
      );
      row = row + 15;
      //END TETAP LITBANG

      //****CABANG KUBUTAMBAHAN  */
      const dataCabangKubutambahan = this.prepare_data_excel(
        dataTetapCapeg,
        "riwayat_pekerjaan.cabang_id",
        6,
        0,
      );

      bagianTitle = this.prepare_data_seksi(dataCabangKubutambahan, 6);
      bagianPemimpin = this.prepare_data_pemimpin(dataCabangKubutambahan); //cari id kacab
      bagianStaf = this.prepare_data_staf(dataCabangKubutambahan);

      row = this.wbAddHeaderTetap(
        workbook,
        sheetName,
        row,
        "DAFTAR PEMBAYARAN GAJI",
        "CABANG KUBUTAMBAHAN",
        "UNTUK BULAN  : " + this.periodeTitle.toUpperCase(),
      );
      row = this.wbAddHeaderKomponen(workbook, sheetName, row); //nama, no, golongan
      row = this.wbAddContentTetapPerBagian(
        workbook,
        sheetName,
        row,
        bagianTitle,
        bagianPemimpin,
        bagianStaf,
        "riwayat_pekerjaan.seksi_id",
      ); //isi data
      row = this.wbAddContentTetapFooter(
        workbook,
        sheetName,
        row,
        dataCabangKubutambahan,
      );
      row = row + 15;
      //END CABANG KUBUTAMBAHAN
      //****UNIT SAMBIRENTENG CABANG KUBUTAMBAHAN */
      const dataUnitSambirenteng = this.prepare_data_excel(
        dataTetapCapeg,
        "riwayat_pekerjaan.cabang_id",
        6,
        2,
      );
      bagianTitle = this.prepare_data_seksi(dataUnitSambirenteng, 6, 2);
      bagianPemimpin = this.prepare_data_pemimpin(dataUnitSambirenteng); //cari id kacab
      bagianStaf = this.prepare_data_staf(dataUnitSambirenteng);

      row = this.wbAddHeaderTetap(
        workbook,
        sheetName,
        row,
        "DAFTAR PEMBAYARAN GAJI",
        "CABANG KUBUTAMBAHAN UNIT SAMBIRENTENG",
        "UNTUK BULAN  : " + this.periodeTitle.toUpperCase(),
      );
      row = this.wbAddHeaderKomponen(workbook, sheetName, row); //nama, no, golongan
      row = this.wbAddContentTetapPerBagian(
        workbook,
        sheetName,
        row,
        bagianTitle,
        bagianPemimpin,
        bagianStaf,
        "riwayat_pekerjaan.seksi_id",
        "sambirenteng",
      ); //isi data
      row = this.wbAddContentTetapFooter(
        workbook,
        sheetName,
        row,
        dataUnitSambirenteng,
      );
      row = row + 15;

      //END OF SAMBIRENTENG
      //****CABANG LOVINA  */
      const dataCabangLovina = this.prepare_data_excel(
        dataTetapCapeg,
        "riwayat_pekerjaan.cabang_id",
        5,
        0,
      );
      bagianTitle = this.prepare_data_seksi(dataCabangLovina, 5);
      bagianPemimpin = this.prepare_data_pemimpin(dataCabangLovina); //cari id kacab
      bagianStaf = this.prepare_data_staf(dataCabangLovina);

      row = this.wbAddHeaderTetap(
        workbook,
        sheetName,
        row,
        "DAFTAR PEMBAYARAN GAJI",
        "CABANG LOVINA",
        "UNTUK BULAN  : " + this.periodeTitle.toUpperCase(),
      );
      row = this.wbAddHeaderKomponen(workbook, sheetName, row); //nama, no, golongan
      row = this.wbAddContentTetapPerBagian(
        workbook,
        sheetName,
        row,
        bagianTitle,
        bagianPemimpin,
        bagianStaf,
        "riwayat_pekerjaan.seksi_id",
      ); //isi data
      row = this.wbAddContentTetapFooter(
        workbook,
        sheetName,
        row,
        dataCabangLovina,
      );
      row = row + 15;
      //END CABANG LOVINA

      //****UNIT PANCASARI CABANG LOVINA */
      const dataUnitPancasari = this.prepare_data_excel(
        dataTetapCapeg,
        "riwayat_pekerjaan.cabang_id",
        5,
        1,
      );
      bagianTitle = this.prepare_data_seksi(dataUnitPancasari, 5, 1);
      bagianPemimpin = this.prepare_data_pemimpin(dataUnitPancasari); //cari id kacab
      bagianStaf = this.prepare_data_staf(dataUnitPancasari);

      row = this.wbAddHeaderTetap(
        workbook,
        sheetName,
        row,
        "DAFTAR PEMBAYARAN GAJI",
        "CABANG LOVINA UNIT PANCASARI",
        "UNTUK BULAN  : " + this.periodeTitle.toUpperCase(),
      );
      row = this.wbAddHeaderKomponen(workbook, sheetName, row); //nama, no, golongan
      row = this.wbAddContentTetapPerBagian(
        workbook,
        sheetName,
        row,
        bagianTitle,
        bagianPemimpin,
        bagianStaf,
        "riwayat_pekerjaan.seksi_id",
      ); //isi data
      row = this.wbAddContentTetapFooter(
        workbook,
        sheetName,
        row,
        dataUnitPancasari,
      );
      row = row + 15;
      //END OF PANCASARI

      //***CABANG SERIRIT */
      const dataCabangSeririt = this.prepare_data_excel(
        dataTetapCapeg,
        "riwayat_pekerjaan.cabang_id",
        4,
      );
      bagianTitle = this.prepare_data_seksi(dataCabangSeririt, 4); //seksi pada cabang //get unique from dataCabangSeririt and get seksi_nama
      bagianPemimpin = this.prepare_data_pemimpin(dataCabangSeririt); //cari id kacab
      bagianStaf = this.prepare_data_staf(dataCabangSeririt);
      row = this.wbAddHeaderTetap(
        workbook,
        sheetName,
        row,
        "DAFTAR PEMBAYARAN GAJI",
        "CABANG SERIRIT",
        "UNTUK BULAN  : " + this.periodeTitle.toUpperCase(),
      );
      row = this.wbAddHeaderKomponen(workbook, sheetName, row); //nama, no, golongan
      row = this.wbAddContentTetapPerBagian(
        workbook,
        sheetName,
        row,
        bagianTitle,
        bagianPemimpin,
        bagianStaf,
        "riwayat_pekerjaan.seksi_id",
      ); //isi data
      row = this.wbAddContentTetapFooter(
        workbook,
        sheetName,
        row,
        dataCabangSeririt,
      );
      row = row + 15;
      //***END OF CABANG SERIRIT */

      //***CABANG GEROKGAK */
      const dataCabangGerokgak = this.prepare_data_excel(
        dataTetapCapeg,
        "riwayat_pekerjaan.cabang_id",
        2,
      );
      bagianTitle = this.prepare_data_seksi(dataCabangGerokgak, 2); //seksi pada cabang //get unique from dataCabangSeririt and get seksi_nama
      bagianPemimpin = this.prepare_data_pemimpin(dataCabangGerokgak); //cari id kacab
      bagianStaf = this.prepare_data_staf(dataCabangGerokgak);
      row = this.wbAddHeaderTetap(
        workbook,
        sheetName,
        row,
        "DAFTAR PEMBAYARAN GAJI",
        "CABANG GEROKGAK",
        "UNTUK BULAN  : " + this.periodeTitle.toUpperCase(),
      );
      row = this.wbAddHeaderKomponen(workbook, sheetName, row); //nama, no, golongan
      row = this.wbAddContentTetapPerBagian(
        workbook,
        sheetName,
        row,
        bagianTitle,
        bagianPemimpin,
        bagianStaf,
        "riwayat_pekerjaan.seksi_id",
      ); //isi data
      row = this.wbAddContentTetapFooter(
        workbook,
        sheetName,
        row,
        dataCabangGerokgak,
      );
      row = row + 15;
      //***END OF CABANG GEROKGAK */
      //***CABANG BUSUNGBIU */
      const dataCabangBusungbiu = this.prepare_data_excel(
        dataTetapCapeg,
        "riwayat_pekerjaan.cabang_id",
        3,
      );
      bagianTitle = this.prepare_data_seksi(dataCabangBusungbiu, 3); //seksi pada cabang //get unique from dataCabangSeririt and get seksi_nama
      bagianPemimpin = this.prepare_data_pemimpin(dataCabangBusungbiu); //cari id kacab
      bagianStaf = this.prepare_data_staf(dataCabangBusungbiu);
      row = this.wbAddHeaderTetap(
        workbook,
        sheetName,
        row,
        "DAFTAR PEMBAYARAN GAJI",
        "CABANG BUSUNGBIU",
        "UNTUK BULAN  : " + this.periodeTitle.toUpperCase(),
      );
      row = this.wbAddHeaderKomponen(workbook, sheetName, row); //nama, no, golongan
      row = this.wbAddContentTetapPerBagian(
        workbook,
        sheetName,
        row,
        bagianTitle,
        bagianPemimpin,
        bagianStaf,
        "riwayat_pekerjaan.seksi_id",
      ); //isi data
      this.wbAddContentTetapFooter(
        workbook,
        sheetName,
        row,
        dataCabangBusungbiu,
      );

      //END OF BUSUNGBIU

      /////////////////////////MULAI SHEET DEWAS
      //========================================================================================================
      /////MULAI SHEET ADMINISTRASI PEGAWAI TETAP PUSAT DAN CABANG

      //TETAP - SPI
      row = this.wbAddHeaderTetap(
        workbook,
        sheetName,
        row,
        "DAFTAR PEMBAYARAN GAJI SATUAN PENGAWAS INTERN",
        "UNTUK BULAN  : " + this.periodeTitle.toUpperCase(),
      );
      row = this.wbAddHeaderKomponen(workbook, sheetName, row); //nama, no, golongan
      bagianTitle = this.prepare_data_bidangs(1);

      bagianPemimpin = this.prepare_data_pemimpin(dataBagianSPI);
      bagianStaf = this.prepare_data_staf(dataBagianSPI);

      row = this.wbAddContentTetapPerBagian(
        workbook,
        sheetName,
        row,
        bagianTitle,
        bagianPemimpin,
        bagianStaf,
        "riwayat_pekerjaan.sub_bidang_id",
      ); //isi data

      /////////////////////////////////////////////////////

      ////////////////////////////////DEWAS
      XLSX.utils.book_append_sheet(workbook, {}, sheetNameDewas);
      row = 3;
      row = this.wbAddHeaderDewas(
        workbook,
        sheetNameDewas,
        row,
        "UANG JASA DEWAN PENGAWAS",
        "UNTUK BULAN  : " + this.periodeTitle.toUpperCase(),
        "SESUAI KUASA PEMILIK MODAL PERUMDA AIR MINUM TIRTA HITA BULELENG",
        "NOMOR 03 / Skep / KPM / THB / VIII / 2024 Tanggal 7 Agustus 2024",
      ); //status pegawai/bulan/cabang
      //direksi
      row = this.wbAddHeaderKomponenDewas(workbook, sheetNameDewas, row); //nama, no, golongan

      let filteredData = dataDewas.filter(
        (item) => item.dewas?.is_dewas === true,
      );
      row = this.wbAddContentDewas(workbook, sheetNameDewas, row, filteredData); //isi data

      //SEKRE DEWAS
      XLSX.utils.book_append_sheet(workbook, {}, sheetNameDewasSekre);
      row = 3;
      row = this.wbAddHeaderDewas(
        workbook,
        sheetNameDewasSekre,
        row,
        "HONORARIUM SEKRETARIAT DEWAN PENGAWAS",
        "UNTUK BULAN  : " + this.periodeTitle.toUpperCase(),
        "SESUAI KEPUTUSAN DIREKSI PERUMDA AIR MINUM TIRTA HITA BULELENG",
        "NOMOR 231 TAHUN 2022 TANGGAL 15 SEPTEMBER 2022",
      ); //status pegawai/bulan/cabang
      //direksi
      row = this.wbAddHeaderKomponenDewas(
        workbook,
        sheetNameDewasSekre,
        row,
        false,
      ); //nama, no, golongan

      filteredData = dataDewas.filter((item) => item.dewas?.is_dewas === false);
      row = this.wbAddContentDewas(
        workbook,
        sheetNameDewasSekre,
        row,
        filteredData,
        false,
      ); //isi data

      XLSX.writeFile(workbook, "Gaji " + this.periodeTitle + ".xlsx");
    },

    wbAddHeaderHonor(workbook, sheetName, row, title1, title2, title3 = null) {
      const ws = workbook.Sheets[sheetName];
      if (title3 !== "pusat") row = row + 10;
      this.wbAoa(ws, title1, "A" + row);
      row += 1;
      this.wbAoa(ws, title2, "A" + row);
      // if (title3 !== null) {
      //   row += 1;
      //   this.wbAoa(ws, title3, "A" + row);
      // }

      return row + 2;
    },

    wbAddHeaderTetap(workbook, sheetName, row, title1, title2, title3 = null) {
      const ws = workbook.Sheets[sheetName];
      this.wbAoa(ws, "PERUSAHAAN UMUM DAERAH AIR MINUM", "B" + row);
      row += 1;
      this.wbAoa(ws, "TIRTA HITA BULELENG", "B" + row);
      row += 1;
      this.wbAoa(ws, title1, "A" + row);
      row += 1;
      this.wbAoa(ws, title2, "A" + row);
      if (title3 !== null) {
        row += 1;
        this.wbAoa(ws, title3, "A" + row);
      }

      return row + 2;
    },

    wbAddHeaderDewas(
      workbook,
      sheetName,
      row,
      title1,
      title2,
      title3 = null,
      title4 = null,
    ) {
      const ws = workbook.Sheets[sheetName];
      this.wbAoa(ws, "PERUSAHAAN UMUM DAERAH AIR MINUM", "B" + row);
      row += 1;
      this.wbAoa(ws, "TIRTA HITA BULELENG", "B" + row);
      row += 1;
      this.wbAoa(ws, title1, "A" + row);
      row += 1;
      this.wbAoa(ws, title2, "A" + row);
      if (title3 !== null) {
        row += 1;
        this.wbAoa(ws, title3, "A" + row);
      }
      if (title4 !== null) {
        row += 1;
        this.wbAoa(ws, title4, "A" + row);
      }

      return row + 2;
    },

    wbAddHeaderKomponenDireksi(workbook, sheetName, row) {
      const ws = workbook.Sheets[sheetName];
      this.wbAoa(ws, "NO.", "A" + row);
      this.wbAoa(ws, "NAMA", "B" + row);
      this.wbAoa(ws, "GOL", "C" + row);
      this.wbAoa(ws, "GAJI", "E" + row);
      this.wbAoa(ws, "TUNJANGAN", "F" + row);
      this.wbAoa(ws, "POT. KETIDAKHADIRAN", "O" + row);
      this.wbAoa(ws, "JUMLAH", "Q" + row);
      this.wbAoa(ws, "TUNJANGAN", "R" + row);
      this.wbAoa(ws, "JUMLAH", "S" + row);
      this.wbAoa(ws, "POTONGAN", "T" + row);
      this.wbAoa(ws, "JUMLAH", "Z" + row);
      this.wbAoa(ws, "TANDA", "AB" + row);

      row += 1;
      this.wbAoa(ws, "BRUTO", "Q" + row);

      this.wbAoa(ws, "PPH", "R" + row);
      this.wbAoa(ws, "(15+16)", "S" + row);
      this.wbAoa(ws, "YANG", "Z" + row);
      this.wbAoa(ws, "TANGAN", "AB" + row);
      row += 1;
      this.wbAoa(ws, "NIP/NIK", "B" + row);
      this.wbAoa(ws, "PERUSAHAAN", "F" + row);
      this.wbAoa(ws, "JABATAN", "G" + row);
      this.wbAoa(ws, "KEMAHALAN", "H" + row);
      this.wbAoa(ws, "AIR", "I" + row);
      this.wbAoa(ws, "TRANSPORT", "J" + row);
      this.wbAoa(ws, "PANGAN", "K" + row);
      this.wbAoa(ws, "KESEHATAN", "L" + row);
      this.wbAoa(ws, "PREMI", "M" + row);
      this.wbAoa(ws, "PREMI", "N" + row);
      this.wbAoa(ws, "HARI", "O" + row);
      this.wbAoa(ws, "JUMLAH", "P" + row);
      this.wbAoa(ws, "KESEHATAN", "T" + row);
      this.wbAoa(ws, "BPJS TK", "U" + row);
      this.wbAoa(ws, "BPJS TK", "V" + row);
      this.wbAoa(ws, "PENSIUN", "W" + row);
      this.wbAoa(ws, "IFG", "X" + row);
      this.wbAoa(ws, "PPH", "Y" + row);
      this.wbAoa(ws, "DITERIMA", "Z" + row);

      row += 1;
      this.wbAoa(ws, "JABATAN", "B" + row);
      this.wbAoa(ws, "(5) X 25%", "F" + row);
      this.wbAoa(ws, "(5) X 5%", "H" + row);
      this.wbAoa(ws, "JKK", "M" + row);
      this.wbAoa(ws, "JKM", "N" + row);
      this.wbAoa(ws, "13X5%(6+10)", "P" + row);
      this.wbAoa(ws, "3 PROGRAM", "U" + row);
      this.wbAoa(ws, "4 PROGRAM", "V" + row);
      this.wbAoa(ws, "IFG LIFE", "W" + row);
      this.wbAoa(ws, "MANDIRI", "X" + row);
      this.wbAoa(ws, "PASAL 21", "Y" + row);

      row += 1;
      this.wbAoa(ws, "(15)X2%)", "U" + row);
      this.wbAoa(ws, "(Bts maxX1% JP)", "V" + row);
      row += 1;
      this.wbAoa(ws, "+ 2% JHT", "V" + row);
      row += 1;
      this.wbAoa(ws, "(Rp.)", "F" + row);
      this.wbAoa(ws, "(Rp.)", "G" + row);
      this.wbAoa(ws, "(Rp.)", "H" + row);
      this.wbAoa(ws, "(Rp.)", "I" + row);
      this.wbAoa(ws, "(Rp.)", "J" + row);
      this.wbAoa(ws, "(Rp.)", "K" + row);
      this.wbAoa(ws, "(Rp.)", "L" + row);
      this.wbAoa(ws, "(Rp.)", "M" + row);
      this.wbAoa(ws, "(Rp.)", "N" + row);

      this.wbAoa(ws, "(Rp.)", "P" + row);
      this.wbAoa(ws, "(Rp.)", "R" + row);
      this.wbAoa(ws, "(Rp.)", "S" + row);
      this.wbAoa(ws, "(Rp.)", "T" + row);
      this.wbAoa(ws, "(Rp.)", "Q" + row);
      this.wbAoa(ws, "(Rp.)", "U" + row);
      this.wbAoa(ws, "(Rp.)", "V" + row);
      this.wbAoa(ws, "(Rp.)", "W" + row);
      this.wbAoa(ws, "(Rp.)", "X" + row);
      this.wbAoa(ws, "(Rp.)", "Y" + row);
      this.wbAoa(ws, "(Rp.)", "Z" + row);
      row += 1;

      this.wbAoa(ws, "1", "A" + row);
      this.wbAoa(ws, "2", "B" + row);
      this.wbAoa(ws, "3", "C" + row);
      this.wbAoa(ws, "4", "D" + row);
      this.wbAoa(ws, "5", "E" + row);
      this.wbAoa(ws, "6", "F" + row);
      this.wbAoa(ws, "7", "G" + row);
      this.wbAoa(ws, "8", "H" + row);
      this.wbAoa(ws, "9", "I" + row);
      this.wbAoa(ws, "10", "J" + row);
      this.wbAoa(ws, "11", "K" + row);
      this.wbAoa(ws, "12", "L" + row);
      this.wbAoa(ws, "13", "M" + row);
      this.wbAoa(ws, "14", "N" + row);
      this.wbAoa(ws, "15", "O" + row);
      this.wbAoa(ws, "16", "P" + row);
      this.wbAoa(ws, "17", "Q" + row);
      this.wbAoa(ws, "18", "R" + row);
      this.wbAoa(ws, "19", "S" + row);
      this.wbAoa(ws, "20", "T" + row);
      this.wbAoa(ws, "21", "U" + row);
      this.wbAoa(ws, "22", "V" + row);
      this.wbAoa(ws, "23", "W" + row);
      this.wbAoa(ws, "24", "X" + row);
      this.wbAoa(ws, "25", "Y" + row);
      this.wbAoa(ws, "26", "Z" + row);

      return row + 2;
    },

    wbAddHeaderKomponenDewas(workbook, sheetName, row, isDewas = true) {
      const ws = workbook.Sheets[sheetName];
      this.wbAoa(ws, "NO.", "A" + row);
      this.wbAoa(ws, "NAMA", "B" + row);
      this.wbAoa(ws, "JABATAN", "C" + row);
      this.wbAoa(ws, "BESARNYA", "D" + row);
      this.wbAoa(ws, "POT. PPH", "E" + row);
      this.wbAoa(ws, "JML YANG", "F" + row);
      this.wbAoa(ws, "TANDA", "G" + row);

      row += 1;
      if (isDewas) this.wbAoa(ws, "UANG JASA", "D" + row);
      else this.wbAoa(ws, "HONOR", "D" + row);
      this.wbAoa(ws, "PASAL 21", "E" + row);
      this.wbAoa(ws, "DITERIMA", "F" + row);
      this.wbAoa(ws, "TANGAN", "G" + row);
      row += 1;

      this.wbAoa(ws, "(Rp.)", "D" + row);
      this.wbAoa(ws, "(Rp.)", "E" + row);
      this.wbAoa(ws, "(Rp.)", "F" + row);
      row += 1;

      this.wbAoa(ws, "1", "A" + row);
      this.wbAoa(ws, "2", "B" + row);
      this.wbAoa(ws, "3", "C" + row);
      this.wbAoa(ws, "4", "D" + row);
      this.wbAoa(ws, "5", "E" + row);
      this.wbAoa(ws, "6", "F" + row);

      return row + 2;
    },

    wbAddHeaderKomponen(workbook, sheetName, row) {
      const ws = workbook.Sheets[sheetName];

      this.wbAoa(ws, "NO.", "A" + row);
      this.wbAoa(ws, "NAMA", "B" + row);
      this.wbAoa(ws, "GOL", "C" + row);
      this.wbAoa(ws, "GAJI", "E" + row);
      this.wbAoa(ws, "TUNJANGAN", "F" + row);
      this.wbAoa(ws, "POT. KETIDAKHADIRAN", "O" + row);
      this.wbAoa(ws, "JUMLAH", "Q" + row);
      this.wbAoa(ws, "TUNJANGAN", "R" + row);
      this.wbAoa(ws, "JUMLAH", "S" + row);
      this.wbAoa(ws, "POTONGAN", "T" + row);
      this.wbAoa(ws, "JUMLAH", "Z" + row);
      this.wbAoa(ws, "TANDA", "AB" + row);

      row += 1;

      this.wbAoa(ws, "BRUTO", "Q" + row);

      this.wbAoa(ws, "PPH", "R" + row);
      this.wbAoa(ws, "(15+16)", "S" + row);
      this.wbAoa(ws, "YANG", "Y" + row);
      this.wbAoa(ws, "TANGAN", "AA" + row);
      row += 1;
      this.wbAoa(ws, "NIP/NIK", "B" + row);
      this.wbAoa(ws, "PERUSAHAAN", "F" + row);
      this.wbAoa(ws, "JABATAN", "G" + row);
      this.wbAoa(ws, "KEMAHALAN", "H" + row);
      this.wbAoa(ws, "AIR", "I" + row);
      this.wbAoa(ws, "TRANSPORT", "J" + row);
      this.wbAoa(ws, "PANGAN", "K" + row);
      this.wbAoa(ws, "KESEHATAN", "L" + row);
      this.wbAoa(ws, "PREMI", "M" + row);
      this.wbAoa(ws, "PREMI", "N" + row);
      this.wbAoa(ws, "HARI", "O" + row);
      this.wbAoa(ws, "JUMLAH", "P" + row);
      this.wbAoa(ws, "KESEHATAN", "T" + row);
      this.wbAoa(ws, "BPJS TK", "U" + row);
      this.wbAoa(ws, "BPJS TK", "V" + row);
      this.wbAoa(ws, "PENSIUN", "W" + row);
      this.wbAoa(ws, "IFG", "X" + row);
      this.wbAoa(ws, "PPH", "Y" + row);
      this.wbAoa(ws, "DITERIMA", "Z" + row);

      row += 1;
      this.wbAoa(ws, "JABATAN", "B" + row);
      this.wbAoa(ws, "(5) X 25%", "F" + row);
      this.wbAoa(ws, "(5) X 5%", "H" + row);
      this.wbAoa(ws, "JKK", "M" + row);
      this.wbAoa(ws, "JKM", "N" + row);
      this.wbAoa(ws, "13X5%(6+10)", "P" + row);
      this.wbAoa(ws, "3 PROGRAM", "U" + row);
      this.wbAoa(ws, "4 PROGRAM", "V" + row);
      this.wbAoa(ws, "IFG LIFE", "W" + row);
      this.wbAoa(ws, "MANDIRI", "X" + row);
      this.wbAoa(ws, "PASAL 21", "Y" + row);

      row += 1;
      this.wbAoa(ws, "(15)X2%)", "U" + row);
      this.wbAoa(ws, "(Bts maxX3% JP)", "V" + row);

      row += 1;
      // this.wbAoa(ws, "+ 2% JHT", "V" + row);
      row += 1;
      this.wbAoa(ws, "(Rp.)", "F" + row);
      this.wbAoa(ws, "(Rp.)", "G" + row);
      this.wbAoa(ws, "(Rp.)", "H" + row);
      this.wbAoa(ws, "(Rp.)", "I" + row);
      this.wbAoa(ws, "(Rp.)", "J" + row);
      this.wbAoa(ws, "(Rp.)", "K" + row);
      this.wbAoa(ws, "(Rp.)", "L" + row);
      this.wbAoa(ws, "(Rp.)", "M" + row);
      this.wbAoa(ws, "(Rp.)", "N" + row);

      this.wbAoa(ws, "(Rp.)", "P" + row);
      this.wbAoa(ws, "(Rp.)", "R" + row);
      this.wbAoa(ws, "(Rp.)", "S" + row);
      this.wbAoa(ws, "(Rp.)", "T" + row);
      this.wbAoa(ws, "(Rp.)", "U" + row);
      this.wbAoa(ws, "(Rp.)", "V" + row);
      this.wbAoa(ws, "(Rp.)", "W" + row);
      this.wbAoa(ws, "(Rp.)", "X" + row);
      this.wbAoa(ws, "(Rp.)", "Y" + row);
      this.wbAoa(ws, "(Rp.)", "Z" + row);
      row += 1;

      this.wbAoa(ws, "1", "A" + row);
      this.wbAoa(ws, "2", "B" + row);
      this.wbAoa(ws, "3", "C" + row);
      this.wbAoa(ws, "4", "D" + row);
      this.wbAoa(ws, "5", "E" + row);
      this.wbAoa(ws, "6", "F" + row);
      this.wbAoa(ws, "7", "G" + row);
      this.wbAoa(ws, "8", "H" + row);
      this.wbAoa(ws, "9", "I" + row);
      this.wbAoa(ws, "10", "J" + row);
      this.wbAoa(ws, "11", "K" + row);
      this.wbAoa(ws, "12", "L" + row);
      this.wbAoa(ws, "13", "M" + row);
      this.wbAoa(ws, "14", "N" + row);
      this.wbAoa(ws, "15", "O" + row);
      this.wbAoa(ws, "16", "P" + row);
      this.wbAoa(ws, "17", "Q" + row);
      this.wbAoa(ws, "18", "R" + row);
      this.wbAoa(ws, "19", "S" + row);
      this.wbAoa(ws, "20", "T" + row);
      this.wbAoa(ws, "21", "U" + row);
      this.wbAoa(ws, "22", "V" + row);
      this.wbAoa(ws, "23", "W" + row);
      this.wbAoa(ws, "24", "X" + row);
      this.wbAoa(ws, "25", "Y" + row);
      this.wbAoa(ws, "26", "Z" + row);

      return row + 2;
    },

    wbAddHeaderKomponenHonor(workbook, sheetName, row) {
      const ws = workbook.Sheets[sheetName];
      this.wbAoa(ws, "MASA", "E" + row);
      this.wbAoa(ws, "TMT", "F" + row);
      this.wbAoa(ws, "UPAH", "G" + row);
      this.wbAoa(ws, "TAMB. UPAH", "H" + row);
      this.wbAoa(ws, "TUNJ.", "I" + row);
      this.wbAoa(ws, "TUNJ.", "J" + row);
      this.wbAoa(ws, "TUNJ.", "K" + row);
      ////
      this.wbAoa(ws, "JML", "L" + row);
      this.wbAoa(ws, "POT.", "M" + row);
      this.wbAoa(ws, "JUMLAH", "N" + row);
      this.wbAoa(ws, "POTONGAN", "O" + row);
      this.wbAoa(ws, "GAJI/UPAH", "R" + row);
      this.wbAoa(ws, "TANDA", "T" + row);

      row += 1;
      this.wbAoa(ws, "NO", "A" + row);
      this.wbAoa(ws, "NAMA", "B" + row);
      this.wbAoa(ws, "GOL", "C" + row);
      this.wbAoa(ws, "JABATAN", "D" + row);
      this.wbAoa(ws, "KERJA", "E" + row);
      this.wbAoa(ws, "KONTRAK", "F" + row);
      this.wbAoa(ws, "(UMK)", "G" + row);
      this.wbAoa(ws, "MASA KERJA", "H" + row);
      this.wbAoa(ws, "KESEHATAN", "I" + row);
      this.wbAoa(ws, "PREMI JKK", "J" + row);
      this.wbAoa(ws, "PREMI JKM", "K" + row);
      ////
      this.wbAoa(ws, "TIDAK", "L" + row);
      this.wbAoa(ws, "(2%x6)9", "M" + row);
      this.wbAoa(ws, "BRUTO", "N" + row);
      this.wbAoa(ws, "KESEHATAN", "O" + row);
      this.wbAoa(ws, "BPJS TK", "P" + row);
      this.wbAoa(ws, "IFG LIFE", "Q" + row);
      this.wbAoa(ws, "DITERIMA", "R" + row);
      this.wbAoa(ws, "TANGAN", "T" + row);

      row += 1;
      this.wbAoa(ws, "(MK x 3% x UMK)", "H" + row);
      ////
      this.wbAoa(ws, "MASUK", "L" + row);
      this.wbAoa(ws, "(9)x2%", "P" + row);
      this.wbAoa(ws, "MANDIRI", "Q" + row);

      row += 1;
      this.wbAoa(ws, "(Rp.)", "G" + row);
      this.wbAoa(ws, "(Rp.)", "H" + row);
      this.wbAoa(ws, "(Rp.)", "I" + row);
      this.wbAoa(ws, "(Rp.)", "J" + row);
      this.wbAoa(ws, "(Rp.)", "K" + row);
      this.wbAoa(ws, "(Rp.)", "L" + row);
      this.wbAoa(ws, "(Rp.)", "M" + row);
      this.wbAoa(ws, "(Rp.)", "N" + row);
      this.wbAoa(ws, "(Rp.)", "O" + row);
      this.wbAoa(ws, "(Rp.)", "P" + row);
      this.wbAoa(ws, "(Rp.)", "Q" + row);
      row += 1;

      this.wbAoa(ws, "1", "A" + row);
      this.wbAoa(ws, "2", "B" + row);
      this.wbAoa(ws, "3", "C" + row);
      this.wbAoa(ws, "4", "D" + row);
      this.wbAoa(ws, "5", "E" + row);
      this.wbAoa(ws, "6", "F" + row);
      this.wbAoa(ws, "7", "G" + row);
      this.wbAoa(ws, "8", "H" + row);
      this.wbAoa(ws, "9", "I" + row);
      this.wbAoa(ws, "10", "J" + row);
      this.wbAoa(ws, "11", "K" + row);
      this.wbAoa(ws, "12", "L" + row);
      this.wbAoa(ws, "13", "M" + row);
      this.wbAoa(ws, "14", "N" + row);
      this.wbAoa(ws, "15", "O" + row);
      this.wbAoa(ws, "16", "P" + row);
      this.wbAoa(ws, "17", "Q" + row);
      this.wbAoa(ws, "18", "R" + row);
      this.wbAoa(ws, "19", "T" + row);

      return row + 2;
    },

    wbAddHeaderKomponenKontrak(workbook, sheetName, row) {
      const ws = workbook.Sheets[sheetName];
      this.wbAoa(ws, "MASA", "E" + row);
      this.wbAoa(ws, "TMT", "F" + row);
      this.wbAoa(ws, "UPAH", "G" + row);
      this.wbAoa(ws, "TAMB. UPAH", "H" + row);
      this.wbAoa(ws, "TUNJ.", "I" + row);
      this.wbAoa(ws, "TUNJ.", "J" + row);
      this.wbAoa(ws, "TUNJ.", "K" + row);
      this.wbAoa(ws, "JML", "L" + row);
      this.wbAoa(ws, "POT.", "M" + row);
      this.wbAoa(ws, "JUMLAH", "N" + row);
      this.wbAoa(ws, "TUNJ.", "O" + row);
      this.wbAoa(ws, "JUMLAH", "P" + row);
      this.wbAoa(ws, "POTONGAN", "Q" + row);
      this.wbAoa(ws, "GAJI/UPAH", "T" + row);
      this.wbAoa(ws, "TANDA", "V" + row);

      row += 1;
      this.wbAoa(ws, "NO", "A" + row);
      this.wbAoa(ws, "NAMA", "B" + row);
      this.wbAoa(ws, "GOL", "C" + row);
      this.wbAoa(ws, "JABATAN", "D" + row);
      this.wbAoa(ws, "KERJA", "E" + row);
      this.wbAoa(ws, "KONTRAK", "F" + row);
      this.wbAoa(ws, "(UMK)", "G" + row);
      this.wbAoa(ws, "BERDASARKAN", "H" + row);
      this.wbAoa(ws, "KESEHATAN", "I" + row);
      this.wbAoa(ws, "PREMI JKK", "J" + row);
      this.wbAoa(ws, "PREMI JKM", "K" + row);
      this.wbAoa(ws, "TIDAK", "L" + row);
      this.wbAoa(ws, "KETIDAKHADIRAN", "M" + row);
      this.wbAoa(ws, "BPJS", "O" + row);
      this.wbAoa(ws, "BRUTO", "P" + row);
      this.wbAoa(ws, "KESEHATAN", "Q" + row);
      this.wbAoa(ws, "BPJS TK", "R" + row);
      this.wbAoa(ws, "IFG LIFE", "S" + row);
      this.wbAoa(ws, "DITERIMA", "T" + row);
      this.wbAoa(ws, "TANGAN", "V" + row);

      row += 1;
      this.wbAoa(ws, "MASA KERJA", "H" + row);
      this.wbAoa(ws, "MASUK", "L" + row);
      this.wbAoa(ws, "(2%x7)10", "M" + row);
      this.wbAoa(ws, "T. KERJA", "O" + row);
      this.wbAoa(ws, "(7+8)x1.19%", "R" + row);
      this.wbAoa(ws, "MANDIRI", "S" + row);

      row += 1;
      this.wbAoa(ws, "(7+8)x1.19%", "O" + row);
      row += 1;
      this.wbAoa(ws, "(Rp.)", "G" + row);
      this.wbAoa(ws, "(Rp.)", "H" + row);
      this.wbAoa(ws, "(Rp.)", "I" + row);
      this.wbAoa(ws, "(Rp.)", "J" + row);
      this.wbAoa(ws, "(Rp.)", "K" + row);
      this.wbAoa(ws, "(Rp.)", "L" + row);
      this.wbAoa(ws, "(Rp.)", "M" + row);
      this.wbAoa(ws, "(Rp.)", "N" + row);
      this.wbAoa(ws, "(Rp.)", "O" + row);
      this.wbAoa(ws, "(Rp.)", "P" + row);
      this.wbAoa(ws, "(Rp.)", "Q" + row);
      this.wbAoa(ws, "(Rp.)", "R" + row);
      this.wbAoa(ws, "(Rp.)", "S" + row);
      this.wbAoa(ws, "(Rp.)", "T" + row);
      row += 1;

      this.wbAoa(ws, "1", "A" + row);
      this.wbAoa(ws, "2", "B" + row);
      this.wbAoa(ws, "3", "C" + row);
      this.wbAoa(ws, "4", "D" + row);
      this.wbAoa(ws, "5", "E" + row);
      this.wbAoa(ws, "6", "F" + row);
      this.wbAoa(ws, "7", "G" + row);
      this.wbAoa(ws, "8", "H" + row);
      this.wbAoa(ws, "9", "I" + row);
      this.wbAoa(ws, "10", "J" + row);
      this.wbAoa(ws, "11", "K" + row);
      this.wbAoa(ws, "12", "L" + row);
      this.wbAoa(ws, "13", "M" + row);
      this.wbAoa(ws, "14", "N" + row);
      this.wbAoa(ws, "15", "O" + row);
      this.wbAoa(ws, "16", "P" + row);
      this.wbAoa(ws, "17", "Q" + row);
      this.wbAoa(ws, "18", "R" + row);
      this.wbAoa(ws, "19", "S" + row);
      this.wbAoa(ws, "20", "T" + row);
      this.wbAoa(ws, "21", "V" + row);

      return row + 2;
    },

    prepare_excel_golongan(golonganId) {
      if (golonganId > 4) return "B";
      if (golonganId < 5) return "A";
    },
    prepare_excel_jabatan(riwayatPekerjaan) {
      if (riwayatPekerjaan.sub_bagian_id !== null)
        return (
          "Staf Sub Bag. " +
          _.find(this.commonStore.subBagianStore, {
            id: riwayatPekerjaan.sub_bagian_id,
          }).nama
        );
      if (riwayatPekerjaan.sub_bidang_id !== null)
        return (
          "Staf Sub Bid. " +
          _.find(this.commonStore.subBidangStore, {
            id: riwayatPekerjaan.sub_bidang_id,
          }).nama
        );
      if (riwayatPekerjaan.unit_id != null) {
        return (
          "Staf Unit " +
          _.find(this.commonStore.unitStore, { id: riwayatPekerjaan.unit_id })
            .nama
        );
      }
      if (riwayatPekerjaan.seksi_id != null) {
        if (riwayatPekerjaan.seksi_id > 2) return "Staf Seksi Teknik";
        return (
          "Staf Seksi " +
          _.find(this.commonStore.seksiStore, { id: riwayatPekerjaan.seksi_id })
            .nama
        );
      }
      return (
        "Staf Cabang " +
        _.find(this.commonStore.cabangStore, { id: riwayatPekerjaan.cabang_id })
          .nama
      );
    },

    prepare_excel_tgl(tgl) {
      const dateObj = DateTime.fromISO(tgl);

      return dateObj.toFormat("dd LLL yyyy");
    },

    wbAddContentKontrak(workbook, sheetName, row, numbering, data) {
      const ws = workbook.Sheets[sheetName];
      numbering += 1;

      data.forEach((e) => {
        this.wbAoa(ws, numbering, "A" + row);
        this.wbAoa(ws, e.pegawai.nama, "B" + row);
        this.wbAoa(ws, this.prepare_excel_golongan(e.golongan_id), "C" + row); //if b1 = B, a1,2, = A
        this.wbAoa(
          ws,
          this.prepare_excel_jabatan(e.riwayat_pekerjaan),
          "D" + row,
        );
        this.wbAoa(ws, e.masa_kerja + " tahun", "E" + row);
        this.wbAoa(
          ws,
          this.prepare_excel_tgl(e.pegawai.tgl_mulai_bekerja),
          "F" + row,
        );
        this.wbAoa(ws, e.honor_umk_jml, "G" + row);
        this.wbAoa(ws, e.kenaikan_masa_kerja, "H" + row);
        this.wbAoa(ws, e.tun_kesehatan, "I" + row);
        this.wbAoa(ws, e.premi_jkk, "J" + row);
        this.wbAoa(ws, e.premi_jkm, "K" + row);
        this.wbAoa(ws, e.absen_bulan.tidak_hadir, "L" + row);
        this.wbAoa(ws, e.pot_5_persen, "M" + row);
        this.wbAoa(
          ws,
          e.honor_umk_jml +
            e.kenaikan_masa_kerja +
            e.premi_jkk +
            e.premi_jkm +
            e.tun_kesehatan -
            e.pot_5_persen,
          "N" + row,
        );
        this.wbAoa(ws, e.tun_bpjs_tk_satu_sembilanbelas_persen, "O" + row);

        this.wbAoa(ws, e.jml_bruto, "P" + row);
        this.wbAoa(ws, e.pot_kesehatan, "Q" + row);
        this.wbAoa(ws, e.pot_bpjs_tk_satu_sembilanbelas_persen, "R" + row);
        this.wbAoa(ws, e.ifg_mandiri, "S" + row);
        this.wbAoa(ws, e.total_diterima, "T" + row);
        this.wbAoa(ws, numbering, "U" + row);
        this.wbAoa(ws, "........................", "V" + row);
        row += 1;
        numbering++;
      });
      return row;
    },

    wbAddContentHonor(workbook, sheetName, row, numbering, data) {
      const ws = workbook.Sheets[sheetName];
      numbering += 1;

      data.forEach((e) => {
        this.wbAoa(ws, numbering, "A" + row);
        this.wbAoa(ws, e.pegawai.nama, "B" + row);
        this.wbAoa(ws, this.prepare_excel_golongan(e.golongan_id), "C" + row); //if b1 = B, a1,2, = A
        this.wbAoa(
          ws,
          this.prepare_excel_jabatan(e.riwayat_pekerjaan),
          "D" + row,
        );
        this.wbAoa(ws, e.masa_kerja + " tahun", "E" + row);
        this.wbAoa(
          ws,
          this.prepare_excel_tgl(e.pegawai.tgl_mulai_bekerja),
          "F" + row,
        );
        this.wbAoa(ws, e.honor_umk_jml, "G" + row);
        this.wbAoa(ws, e.kenaikan_masa_kerja, "H" + row);
        this.wbAoa(ws, e.tun_kesehatan, "I" + row);
        this.wbAoa(ws, e.premi_jkk, "J" + row);
        this.wbAoa(ws, e.premi_jkm, "K" + row);
        this.wbAoa(ws, e.absen_bulan.tidak_hadir, "L" + row);
        this.wbAoa(ws, e.pot_5_persen, "M" + row);
        this.wbAoa(ws, e.jml_bruto, "N" + row);
        this.wbAoa(ws, e.pot_kesehatan, "O" + row);
        this.wbAoa(ws, e.pot_bpjs_tk_dua_persen, "P" + row);
        this.wbAoa(ws, e.ifg_mandiri, "Q" + row);
        this.wbAoa(ws, e.total_diterima, "R" + row);
        this.wbAoa(ws, numbering, "S" + row);
        this.wbAoa(ws, "........................", "T" + row);
        row += 1;
        numbering++;
      });
      return row;
    },

    // workbook,
    //     sheetName,
    //     row,
    //     bagianTitle,
    //     bagianPemimpin,
    //     bagianStaf,
    //     "riwayat_pekerjaan.sub_bidang_id"
    // wbAddContentTetapPerBagian(workbook, sheetName, row, numbering, staf) {
    wbAddContentTetapPerBagian(
      workbook,
      sheetName,
      row,
      bagianTitle,
      bagianPemimpin,
      bagianStaf,
      filterStaf,
      from = null,
    ) {
      const ws = workbook.Sheets[sheetName];
      var numbering = 0;

      bagianTitle.forEach((b, bIndex) => {
        this.wbAoa(ws, b.nama, "B" + row);
        row += 1;
        if (bIndex === 0 && bagianPemimpin.length > 0) {
          if (from === "sambirenteng")
            //pemimpin kabag/kacab/kabid
            row = this.wbAddContentTetapStaf(
              numbering,
              workbook,
              sheetName,
              row,
              bagianPemimpin,
            );
          numbering += 1;
        } else if (bIndex > 0) {
          var staf = _.filter(bagianStaf, (item) => {
            return _.get(item, filterStaf) === b.id;
          });
          if (from === "sambirenteng")
            row = this.wbAddContentTetapStaf(
              numbering,
              workbook,
              sheetName,
              row,
              staf,
            );
          numbering = numbering + staf.length;
        }
      });
      return row;
    },

    wbAddContentTetapStaf(numbering, workbook, sheetName, row, data) {
      const ws = workbook.Sheets[sheetName];
      numbering += 1;

      data.forEach((e) => {
        this.wbAoa(ws, numbering, "A" + row);
        this.wbAoa(ws, e.pegawai.nama, "B" + row);
        this.wbAoa(ws, e.golongan.nama, "C" + row);
        this.wbAoa(ws, e.pph ? e.pph.ptkp : null, "D" + row);
        this.wbAoa(ws, e.gaji_pokok, "E" + row);
        this.wbAoa(ws, e.tun_perusahaan, "F" + row);
        this.wbAoa(ws, e.tun_jabatan, "G" + row);
        this.wbAoa(ws, e.tun_kemahalan, "H" + row);
        this.wbAoa(ws, e.tun_air, "I" + row);
        this.wbAoa(ws, e.tun_transport, "J" + row);
        this.wbAoa(ws, e.tun_pangan, "K" + row);
        this.wbAoa(ws, e.tun_kesehatan, "L" + row);
        this.wbAoa(ws, e.premi_jkk, "M" + row);
        this.wbAoa(ws, e.premi_jkm, "N" + row);
        this.wbAoa(ws, e.absen_bulan.tidak_hadir, "O" + row);
        this.wbAoa(ws, e.pot_5_persen, "P" + row);
        this.wbAoa(ws, e.jml_bruto, "Q" + row);
        this.wbAoa(ws, e.tun_pph, "R" + row);
        this.wbAoa(ws, e.jml_bruto + e.tun_pph, "S" + row);
        this.wbAoa(ws, e.pot_kesehatan, "T" + row);
        this.wbAoa(ws, e.pot_bpjs_tk_tiga_program, "U" + row);
        this.wbAoa(ws, e.pot_bpjs_tk_empat_program, "V" + row);
        this.wbAoa(ws, e.pot_pensiun, "W" + row);
        this.wbAoa(ws, e.ifg_mandiri, "X" + row);
        this.wbAoa(ws, e.pot_pph, "Y" + row);
        this.wbAoa(ws, e.total_diterima, "Z" + row);
        // this.wbAoa(ws, index + 1, "X" + row);
        this.wbAoa(ws, numbering, "AA" + row);
        this.wbAoa(ws, "........................", "AB" + row);
        row += 1;
        this.wbAoa(ws, "NIK. " + e.pegawai.nik, "B" + row);
        row += 1;
        numbering++;
      });
      return row;
    },

    wbAddContentTetapFooter(workbook, sheetName, row, data) {
      const ws = workbook.Sheets[sheetName];
      this.wbAoa(ws, "JUMLAH", "B" + row);
      const totalJml1415 =
        this.prepare_data_hitung_total(data, "jml_bruto") +
        this.prepare_data_hitung_total(data, "tun_pph");

      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "gaji_pokok"),
        "E" + row,
      );

      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "tun_kemahalan"),
        "H" + row,
      );
      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "tun_air"),
        "I" + row,
      );
      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "tun_transport"),
        "J" + row,
      );
      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "tun_pangan"),
        "K" + row,
      );
      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "tun_kesehatan"),
        "L" + row,
      );
      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "premi_jkk"),
        "M" + row,
      );
      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "premi_jkm"),
        "N" + row,
      );
      const totalTidakHadir = data.reduce(
        (total, item) => total + item.absen_bulan.tidak_hadir,
        0,
      );

      this.wbAoa(ws, totalTidakHadir, "O" + row);
      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "pot_5_persen"),
        "P" + row,
      );
      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "jml_bruto"),
        "Q" + row,
      );
      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "tun_pph"),
        "R" + row,
      );
      this.wbAoa(ws, totalJml1415, "S" + row);
      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "pot_kesehatan"),
        "T" + row,
      );

      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "pot_bpjs_tk_tiga_program"),
        "U" + row,
      );

      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "pot_bpjs_tk_empat_program"),
        "V" + row,
      );
      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "pot_pensiun"),
        "W" + row,
      );
      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "ifg_mandiri"),
        "X" + row,
      );

      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "pot_pph"),
        "Y" + row,
      );
      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "total_diterima"),
        "Z" + row,
      );

      row += 1;
      this.wbAoa(
        ws,
        "Terbilang: ==== " + this.formatNumberTerbilang(totalJml1415) + " ====",
        "A" + row,
      );
      row += 2;
      this.wbAoa(ws, "Perumda Air Minum", "B" + row);
      row += 1;
      this.wbAoa(ws, "Tirta Hita Buleleng", "B" + row);
      this.wbAoa(ws, "Singaraja, ", "U" + row);
      row += 1;
      this.wbAoa(ws, "Mengetahui:", "B" + row);
      this.wbAoa(ws, "Diperiksa", "J" + row);
      this.wbAoa(ws, "Dibuat Oleh:", "U" + row);
      row += 4;
      // this.wbAoa(ws, this.pejabatDirum, "B" + row);
      // this.wbAoa(ws, this.pejabatKabagUmum, "J" + row);
      // this.wbAoa(ws, this.pejabatKasubagPersonalia, "U" + row);

      this.wbAoa(ws, this.pejabat.dirum.nama, "B" + row);
      this.wbAoa(ws, this.pejabat.pejabatMengetahui.nama, "J" + row);
      this.wbAoa(ws, this.pejabat.pejabatMembuat.nama, "U" + row);
      row += 1;
      this.wbAoa(ws, "Direktur Umum", "B" + row);
      // this.wbAoa(ws, "Kepala Bagian Umum", "J" + row);
      // this.wbAoa(ws, "Ka. Sub Bag. Personalia", "U" + row);

      this.wbAoa(ws, this.pejabat.pejabatMengetahui.jabatan, "J" + row);
      this.wbAoa(ws, this.pejabat.pejabatMembuat.jabatan, "U" + row);

      return row;
    },

    wbAddContentHonorFooterTerbilang(workbook, sheetName, row, data) {
      const ws = workbook.Sheets[sheetName];
      this.wbAoa(ws, "TOTAL", "B" + row);

      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "honor_umk_jml"),
        "G" + row,
      );

      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "kenaikan_masa_kerja"),
        "H" + row,
      );
      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "tun_kesehatan"),
        "I" + row,
      );
      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "premi_jkk"),
        "J" + row,
      );
      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "premi_jkm"),
        "K" + row,
      );

      const totalTidakHadir = data.reduce(
        (total, item) => total + item.absen_bulan.tidak_hadir,
        0,
      );
      this.wbAoa(ws, totalTidakHadir, "L" + row);

      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "pot_5_persen"),
        "M" + row,
      );
      var totalBruto = this.prepare_data_hitung_total(data, "jml_bruto");
      this.wbAoa(ws, totalBruto, "N" + row);
      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "pot_kesehatan"),
        "O" + row,
      );
      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "pot_bpjs_tk_dua_persen"),
        "P" + row,
      );
      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "ifg_mandiri"),
        "Q" + row,
      );

      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "total_diterima"),
        "R" + row,
      );

      row += 1;
      this.wbAoa(
        ws,
        "Terbilang: ==== " + this.formatNumberTerbilang(totalBruto) + " ====",
        "A" + row,
      );
      row += 2;
      this.wbAoa(ws, "Perumda Air Minum", "B" + row);
      row += 1;
      this.wbAoa(ws, "Tirta Hita Buleleng", "B" + row);
      this.wbAoa(ws, "Singaraja, ", "P" + row);
      row += 1;
      this.wbAoa(ws, "Mengetahui:", "B" + row);
      this.wbAoa(ws, "Diperiksa", "J" + row);
      this.wbAoa(ws, "Dibuat Oleh:", "P" + row);
      row += 4;

      // this.wbAoa(ws, this.pejabatDirum, "B" + row);
      // this.wbAoa(ws, this.pejabatKabagUmum, "J" + row);
      // this.wbAoa(ws, this.pejabatKasubagPersonalia, "P" + row);
      // row += 4;
      // this.wbAoa(ws, "Direktur Umum", "B" + row);
      // this.wbAoa(ws, "Kepala Bagian Umum", "J" + row);
      // this.wbAoa(ws, "Ka. Sub Bag. Personalia", "P" + row);

      this.wbAoa(ws, this.pejabat.dirum.nama, "B" + row);
      this.wbAoa(ws, this.pejabat.pejabatMengetahui.nama, "J" + row);
      this.wbAoa(ws, this.pejabat.pejabatMembuat.nama, "P" + row);
      row += 1;
      this.wbAoa(ws, "Direktur Umum", "B" + row);
      // this.wbAoa(ws, "Kepala Bagian Umum", "J" + row);
      // this.wbAoa(ws, "Ka. Sub Bag. Personalia", "U" + row);

      this.wbAoa(ws, this.pejabat.pejabatMengetahui.jabatan, "J" + row);
      this.wbAoa(ws, this.pejabat.pejabatMembuat.jabatan, "P" + row);
      return row;
    },

    wbAddContentKontrakFooterTerbilang(workbook, sheetName, row, data) {
      const ws = workbook.Sheets[sheetName];
      this.wbAoa(ws, "TOTAL", "B" + row);

      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "honor_umk_jml"),
        "G" + row,
      );

      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "kenaikan_masa_kerja"),
        "H" + row,
      );
      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "tun_kesehatan"),
        "I" + row,
      );
      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "premi_jkk"),
        "J" + row,
      );
      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "premi_jkm"),
        "K" + row,
      );

      const totalTidakHadir = data.reduce(
        (total, item) => total + item.absen_bulan.tidak_hadir,
        0,
      );
      this.wbAoa(ws, totalTidakHadir, "L" + row);

      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "pot_5_persen"),
        "M" + row,
      );
      const jmlUmkMkTunKesehatanTidakhadir =
        this.prepare_data_hitung_total(data, "honor_umk_jml") +
        this.prepare_data_hitung_total(data, "kenaikan_masa_kerja") +
        this.prepare_data_hitung_total(data, "premi_jkk") +
        this.prepare_data_hitung_total(data, "premi_jkm") +
        this.prepare_data_hitung_total(data, "tun_kesehatan") -
        this.prepare_data_hitung_total(data, "pot_5_persen");

      this.wbAoa(ws, jmlUmkMkTunKesehatanTidakhadir, "N" + row);
      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(
          data,
          "tun_bpjs_tk_satu_sembilanbelas_persen",
        ),
        "O" + row,
      );
      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "jml_bruto"),
        "P" + row,
      );
      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "pot_kesehatan"),
        "Q" + row,
      );
      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(
          data,
          "pot_bpjs_tk_satu_sembilanbelas_persen",
        ),
        "R" + row,
      );
      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "ifg_mandiri"),
        "S" + row,
      );

      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "total_diterima"),
        "T" + row,
      );
      row += 1;
      this.wbAoa(
        ws,
        "Terbilang: ==== " +
          this.formatNumberTerbilang(jmlUmkMkTunKesehatanTidakhadir) +
          " ====",
        "A" + row,
      );
      row += 2;
      this.wbAoa(ws, "Perumda Air Minum", "B" + row);
      row += 1;
      this.wbAoa(ws, "Tirta Hita Buleleng", "B" + row);
      this.wbAoa(ws, "Singaraja, ", "R" + row);
      row += 1;
      this.wbAoa(ws, "Mengetahui:", "B" + row);
      this.wbAoa(ws, "Diperiksa", "J" + row);
      this.wbAoa(ws, "Dibuat Oleh:", "R" + row);
      row += 4;
      // this.wbAoa(ws, this.pejabatDirum, "B" + row);
      // this.wbAoa(ws, this.pejabatKabagUmum, "J" + row);
      // this.wbAoa(ws, this.pejabatKasubagPersonalia, "R" + row);
      // row += 4;
      // this.wbAoa(ws, "Direktur Umum", "B" + row);
      // this.wbAoa(ws, "Kepala Bagian Umum", "J" + row);
      // this.wbAoa(ws, "Ka. Sub Bag. Personalia", "R" + row);

      this.wbAoa(ws, this.pejabat.dirum.nama, "B" + row);
      this.wbAoa(ws, this.pejabat.pejabatMengetahui.nama, "J" + row);
      this.wbAoa(ws, this.pejabat.pejabatMembuat.nama, "R" + row);
      row += 1;
      this.wbAoa(ws, "Direktur Umum", "B" + row);
      // this.wbAoa(ws, "Kepala Bagian Umum", "J" + row);
      // this.wbAoa(ws, "Ka. Sub Bag. Personalia", "U" + row);

      this.wbAoa(ws, this.pejabat.pejabatMengetahui.jabatan, "J" + row);
      this.wbAoa(ws, this.pejabat.pejabatMembuat.jabatan, "R" + row);

      return row;
    },

    wbAddContentHonorFooter(workbook, sheetName, row, data) {
      const ws = workbook.Sheets[sheetName];
      this.wbAoa(ws, "JUMLAH", "B" + row);

      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "honor_umk_jml"),
        "G" + row,
      );

      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "kenaikan_masa_kerja"),
        "H" + row,
      );
      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "tun_kesehatan"),
        "I" + row,
      );

      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "premi_jkk"),
        "J" + row,
      );

      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "premi_jkm"),
        "K" + row,
      );

      const totalTidakHadir = data.reduce(
        (total, item) => total + item.absen_bulan.tidak_hadir,
        0,
      );
      this.wbAoa(ws, totalTidakHadir, "L" + row);

      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "pot_5_persen"),
        "M" + row,
      );
      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "jml_bruto"),
        "N" + row,
      );
      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "pot_kesehatan"),
        "O" + row,
      );
      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "pot_bpjs_tk_dua_persen"),
        "P" + row,
      );
      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "ifg_mandiri"),
        "Q" + row,
      );

      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "total_diterima"),
        "R" + row,
      );

      row += 1;

      return row;
    },

    wbAddContentKontrakFooter(workbook, sheetName, row, data) {
      const ws = workbook.Sheets[sheetName];
      this.wbAoa(ws, "JUMLAH", "B" + row);

      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "honor_umk_jml"),
        "G" + row,
      );

      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "kenaikan_masa_kerja"),
        "H" + row,
      );
      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "tun_kesehatan"),
        "I" + row,
      );
      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "premi_jkk"),
        "J" + row,
      );
      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "premi_jkm"),
        "K" + row,
      );

      const totalTidakHadir = data.reduce(
        (total, item) => total + item.absen_bulan.tidak_hadir,
        0,
      );
      this.wbAoa(ws, totalTidakHadir, "L" + row);

      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "pot_5_persen"),
        "M" + row,
      );
      const jmlUmkMkTunKesehatanTidakhadir =
        this.prepare_data_hitung_total(data, "honor_umk_jml") +
        this.prepare_data_hitung_total(data, "kenaikan_masa_kerja") +
        this.prepare_data_hitung_total(data, "tun_kesehatan") +
        this.prepare_data_hitung_total(data, "premi_jkk") +
        this.prepare_data_hitung_total(data, "premi_jkm") -
        this.prepare_data_hitung_total(data, "pot_5_persen");

      this.wbAoa(ws, jmlUmkMkTunKesehatanTidakhadir, "N" + row);
      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(
          data,
          "tun_bpjs_tk_satu_sembilanbelas_persen",
        ),
        "O" + row,
      );
      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "jml_bruto"),
        "P" + row,
      );
      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "pot_kesehatan"),
        "Q" + row,
      );
      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(
          data,
          "pot_bpjs_tk_satu_sembilanbelas_persen",
        ),
        "R" + row,
      );
      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "ifg_mandiri"),
        "S" + row,
      );
      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "total_diterima"),
        "T" + row,
      );

      row += 1;

      return row;
    },

    prepare_data_hitung_total(data, field) {
      return data.reduce((total, item) => total + item[field], 0);
    },

    wbAddContentTetap(workbook, sheetName, row, data) {
      const ws = workbook.Sheets[sheetName];
      const totalGajiPokok = data.reduce(
        (total, item) => total + item.gaji_pokok,
        0,
      );

      const totalTunPerusahaan = data.reduce(
        (total, item) => total + item.tun_perusahaan,
        0,
      );

      const totalTunJabatan = data.reduce(
        (total, item) => total + item.tun_jabatan,
        0,
      );

      const totalTunKemahalan = data.reduce(
        (total, item) => total + item.tun_kemahalan,
        0,
      );

      const totalTunAir = data.reduce((total, item) => total + item.tun_air, 0);

      const totalTunTransport = data.reduce(
        (total, item) => total + item.tun_transport,
        0,
      );

      const totalTunPangan = data.reduce(
        (total, item) => total + item.tun_pangan,
        0,
      );

      const totalTunKesehatan = data.reduce(
        (total, item) => total + item.tun_kesehatan,
        0,
      );
      const totalPremiJkk = data.reduce(
        (total, item) => total + item.premi_jkk,
        0,
      );
      const totalPremiJkm = data.reduce(
        (total, item) => total + item.premi_jkm,
        0,
      );

      const totalIfgMandiri = data.reduce(
        (total, item) => total + item.ifg_mandiri,
        0,
      );

      const totalTidakHadir = data.reduce(
        (total, item) => total + item.absen_bulan.tidak_hadir,
        0,
      );
      const totalPotTidakHadir = data.reduce(
        (total, item) => total + item.pot_5_persen,
        0,
      );

      const totalJmlBruto = data.reduce(
        (total, item) => total + item.jml_bruto,
        0,
      );
      const totalTunPph = data.reduce((total, item) => total + item.tun_pph, 0);

      const totalPotKesehatan = data.reduce(
        (total, item) => total + item.pot_kesehatan,
        0,
      );
      const totalPotBpjsTk3 = data.reduce(
        (total, item) => total + item.pot_bpjs_tk_tiga_program,
        0,
      );
      const totalPotBpjsTk4 = data.reduce(
        (total, item) => total + item.pot_bpjs_tk_empat_program,
        0,
      );
      const totalPotPensiun = data.reduce(
        (total, item) => total + item.pot_pensiun,
        0,
      );
      const totalPotPph = data.reduce((total, item) => total + item.pot_pph, 0);
      const totalTotalDiterima = data.reduce(
        (total, item) => total + item.total_diterima,
        0,
      );

      const totalJml1415 = totalJmlBruto + totalTunPph;

      data.forEach((e, index) => {
        this.wbAoa(ws, index + 1, "A" + row);
        this.wbAoa(ws, e.pegawai.nama, "B" + row);
        this.wbAoa(ws, e.golongan.nama, "C" + row);
        this.wbAoa(ws, e.pph ? e.pph.ptkp : null, "D" + row);
        this.wbAoa(ws, e.gaji_pokok, "E" + row);
        this.wbAoa(ws, e.tun_perusahaan, "F" + row);
        this.wbAoa(ws, e.tun_jabatan, "G" + row);
        this.wbAoa(ws, e.tun_kemahalan, "H" + row);
        this.wbAoa(ws, e.tun_air, "I" + row);
        this.wbAoa(ws, e.tun_transport, "J" + row);
        this.wbAoa(ws, e.tun_pangan, "K" + row);
        this.wbAoa(ws, e.tun_kesehatan, "L" + row);
        this.wbAoa(ws, e.premi_jkk, "M" + row);
        this.wbAoa(ws, e.premi_jkm, "N" + row);

        this.wbAoa(ws, e.absen_bulan.tidak_hadir, "O" + row);
        this.wbAoa(ws, e.pot_5_persen, "P" + row);
        this.wbAoa(ws, e.jml_bruto, "Q" + row);
        this.wbAoa(ws, e.tun_pph, "R" + row);
        this.wbAoa(ws, e.jml_bruto + e.tun_pph, "S" + row);
        this.wbAoa(ws, e.pot_kesehatan, "T" + row);
        this.wbAoa(ws, e.pot_bpjs_tk_tiga_program, "U" + row);
        this.wbAoa(ws, e.pot_bpjs_tk_empat_program, "V" + row);
        this.wbAoa(ws, e.pot_pensiun, "W" + row);
        this.wbAoa(ws, e.ifg_mandiri, "X" + row);
        this.wbAoa(ws, e.pot_pph, "Y" + row);
        this.wbAoa(ws, e.total_diterima, "Z" + row);
        this.wbAoa(ws, index + 1, "AA" + row);
        this.wbAoa(ws, "........................", "AB" + row);
        row += 1;
        this.wbAoa(ws, "NIK. " + e.pegawai.nik, "B" + row);
        row += 1;
      });
      row += 1;
      this.wbAoa(ws, "JUMLAH", "B" + row);
      this.wbAoa(ws, totalGajiPokok, "E" + row);
      this.wbAoa(ws, totalTunPerusahaan, "F" + row);
      this.wbAoa(ws, totalTunJabatan, "G" + row);
      this.wbAoa(ws, totalTunKemahalan, "H" + row);
      this.wbAoa(ws, totalTunAir, "I" + row);
      this.wbAoa(ws, totalTunTransport, "J" + row);
      this.wbAoa(ws, totalTunPangan, "K" + row);
      this.wbAoa(ws, totalTunKesehatan, "L" + row);
      this.wbAoa(ws, totalPremiJkk, "M" + row);
      this.wbAoa(ws, totalPremiJkm, "N" + row);

      this.wbAoa(ws, totalTidakHadir, "O" + row);
      this.wbAoa(ws, totalPotTidakHadir, "P" + row);
      this.wbAoa(ws, totalJmlBruto, "Q" + row);
      this.wbAoa(ws, totalTunPph, "R" + row);
      this.wbAoa(ws, totalJml1415, "S" + row);
      this.wbAoa(ws, totalPotKesehatan, "T" + row);
      this.wbAoa(ws, totalPotBpjsTk3, "U" + row);
      this.wbAoa(ws, totalPotBpjsTk4, "V" + row);
      this.wbAoa(ws, totalPotPensiun, "W" + row);
      this.wbAoa(ws, totalIfgMandiri, "X" + row);
      this.wbAoa(ws, totalPotPph, "Y" + row);
      this.wbAoa(ws, totalTotalDiterima, "Z" + row);

      row += 1;
      this.wbAoa(
        ws,
        "Terbilang: ==== " + this.formatNumberTerbilang(totalJml1415) + " ====",
        "A" + row,
      );
      row += 2;
      this.wbAoa(ws, "Perumda Air Minum", "B" + row);
      row += 1;
      this.wbAoa(ws, "Tirta Hita Buleleng", "B" + row);
      this.wbAoa(ws, "Singaraja, ", "U" + row);
      row += 1;
      this.wbAoa(ws, "Mengetahui:", "B" + row);
      this.wbAoa(ws, "Diperiksa", "J" + row);
      this.wbAoa(ws, "Dibuat Oleh:", "U" + row);
      row += 4;
      // this.wbAoa(ws, this.pejabatDirum, "B" + row);
      // this.wbAoa(ws, this.pejabatKabagUmum, "J" + row);
      // this.wbAoa(ws, this.pejabatKasubagPersonalia, "U" + row);
      // row += 4;
      // this.wbAoa(ws, "Direktur Umum", "B" + row);
      // this.wbAoa(ws, "Kepala Bagian Umum", "J" + row);
      // this.wbAoa(ws, "Ka. Sub Bag. Personalia", "U" + row);

      this.wbAoa(ws, this.pejabat.dirum.nama, "B" + row);
      this.wbAoa(ws, this.pejabat.pejabatMengetahui.nama, "J" + row);
      this.wbAoa(ws, this.pejabat.pejabatMembuat.nama, "U" + row);
      row += 1;
      this.wbAoa(ws, "Direktur Umum", "B" + row);
      // this.wbAoa(ws, "Kepala Bagian Umum", "J" + row);
      // this.wbAoa(ws, "Ka. Sub Bag. Personalia", "U" + row);

      this.wbAoa(ws, this.pejabat.pejabatMengetahui.jabatan, "J" + row);
      this.wbAoa(ws, this.pejabat.pejabatMembuat.jabatan, "U" + row);

      return row;
    },

    wbAddContentDewas(workbook, sheetName, row, data, isDewas = true) {
      const ws = workbook.Sheets[sheetName];
      let totalUangJasa = 0,
        totalHonor = 0;
      if (isDewas)
        totalUangJasa = data.reduce((total, item) => total + item.uang_jasa, 0);
      else totalHonor = data.reduce((total, item) => total + item.honor, 0);

      const totalPotPph = data.reduce((total, item) => total + item.pot_pph, 0);

      const totalTotalDiterima = data.reduce(
        (total, item) => total + item.total_diterima,
        0,
      );

      data.forEach((e, index) => {
        this.wbAoa(ws, index + 1, "A" + row);
        this.wbAoa(ws, e.dewas.nama, "B" + row);
        if (isDewas) this.wbAoa(ws, e.uang_jasa, "D" + row);
        else this.wbAoa(ws, e.honor, "D" + row);
        this.wbAoa(ws, e.pot_pph, "E" + row);
        this.wbAoa(ws, e.total_diterima, "F" + row);

        this.wbAoa(ws, index + 1, "G" + row);
        this.wbAoa(ws, "........................", "H" + row);
        row += 1;
      });
      row += 1;
      this.wbAoa(ws, "JUMLAH", "B" + row);
      if (isDewas) this.wbAoa(ws, totalUangJasa, "D" + row);
      else this.wbAoa(ws, totalHonor, "D" + row);
      this.wbAoa(ws, totalPotPph, "E" + row);
      this.wbAoa(ws, totalTotalDiterima, "F" + row);

      row += 1;
      this.wbAoa(
        ws,
        "Terbilang: ==== " +
          this.formatNumberTerbilang(totalTotalDiterima) +
          " ====",
        "A" + row,
      );
      row += 2;

      this.wbAoa(ws, "Singaraja, ", "F" + row);
      row += 1;
      this.wbAoa(ws, "Mengetahui:", "B" + row);
      this.wbAoa(ws, "Diperiksa", "D" + row);
      this.wbAoa(ws, "Dibuat Oleh:", "F" + row);
      row += 4;
      // this.wbAoa(ws, this.pejabatDirum, "B" + row);
      // this.wbAoa(ws, this.pejabatKabagUmum, "D" + row);
      // this.wbAoa(ws, this.pejabatKasubagPersonalia, "F" + row);
      // row += 4;
      // this.wbAoa(ws, "Direktur Umum", "B" + row);
      // this.wbAoa(ws, "Kepala Bagian Umum", "D" + row);
      // this.wbAoa(ws, "Ka. Sub Bag. Personalia", "F" + row);
      this.wbAoa(ws, this.pejabat.dirum.nama, "B" + row);
      this.wbAoa(ws, this.pejabat.pejabatMengetahui.nama, "D" + row);
      this.wbAoa(ws, this.pejabat.pejabatMembuat.nama, "F" + row);
      row += 1;
      this.wbAoa(ws, "Direktur Umum", "B" + row);
      // this.wbAoa(ws, "Kepala Bagian Umum", "J" + row);
      // this.wbAoa(ws, "Ka. Sub Bag. Personalia", "U" + row);

      this.wbAoa(ws, this.pejabat.pejabatMengetahui.jabatan, "D" + row);
      this.wbAoa(ws, this.pejabat.pejabatMembuat.jabatan, "F" + row);

      row += 2;

      this.wbAoa(ws, "PERUSAHAAN UMUM DAERAH AIR MINUM", "D" + row);
      row += 1;
      this.wbAoa(ws, "TIRTA HITA BULELENG", "D" + row);
      row += 1;
      this.wbAoa(ws, "Menyetujui", "D" + row);
      row += 4;
      this.wbAoa(ws, this.pejabat.dirut, "D" + row);
      row += 1;
      this.wbAoa(ws, "Direktur Utama", "D" + row);
      return row;
    },

    formatNumberTerbilang(value) {
      if (typeof value === "string") {
        value = value.replace(/\./g, "");
      }

      if (value !== null && value !== undefined) {
        // Convert the value to a string and remove the decimal part (".00")
        const stringValue = value.toString().split(".")[0];
        return _.startCase(angkaTerbilang(stringValue));
        // Add thousands separator
        // return stringValue.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }
    },

    wbAoa(worksheet, text, cell) {
      XLSX.utils.sheet_add_aoa(worksheet, [[text]], {
        origin: cell,
      });
    },
    addSpecificValues(workbook, sheetName) {
      // Get the specific worksheet
      const worksheet = workbook.Sheets[sheetName];

      // Add specific values to specific cells
      XLSX.utils.sheet_add_aoa(worksheet, [["Specific Value1"]], {
        origin: "A1",
      }); // A1 cell
      XLSX.utils.sheet_add_aoa(worksheet, [["Specific Value2"]], {
        origin: "B2",
      }); // B2 cell
      // Add more specific values as needed
    },
    formattedDate(tgl) {
      const jsDate = new Date(tgl);
      const dt = DateTime.fromJSDate(jsDate).setZone("Asia/Makassar");
      const convert = dt
        .setLocale("id")
        .toFormat("cccc dd MMMM yyyy HH:mm:ss 'WITA'");
      const originalDate = DateTime.fromFormat(
        convert,
        "cccc dd MMMM yyyy HH:mm:ss 'WITA'",
        { locale: "id" },
      );

      const newDate = originalDate.plus({ hours: 8 });
      const formattedNewDate = newDate.toFormat(
        "cccc dd MMMM yyyy HH:mm:ss 'WITA'",
      );
      return formattedNewDate;
    },
    templateUpdateByUser(data) {
      if (data.data.editedByUser) {
        return (
          data.data.editedByUser.name +
          ", " +
          this.formattedDate(data.data.updated_at)
        );
      }
      return;
    },
    allowReloadGajiGrid(e) {
      if (e.row.data.status_gaji) return false; //jik status gaji approved, tidak bisa diedit dan direload
      return this.buttonCan("gaji-update");
    },
    allowUpdating() {
      if (this.gajiPeriodeData.gaji_status_id == 3) {
        //approved
        return false;
      }
      if (this.can("gaji-approve") && this.gajiPeriodeData.gaji_status_id == 2)
        return true; //adalah admin dan masuk status request payroll
      if (
        this.can("gaji-update") &&
        (this.gajiPeriodeData.gaji_status_id == 1 ||
          this.gajiPeriodeData.gaji_status_id == 4)
      )
        return true; //adalah admin dan periode status is open/request revision
      return false;
    },
    async rowDblClick(e) {
      if (
        e.rowType === "data" &&
        e.data &&
        this.can("gaji-approve") &&
        !e.isEditing
      ) {
        if (e.rowElement.classList.contains("class-tandai-salah")) {
          e.rowElement.classList.remove("class-tandai-salah");
          e.cells.forEach((cell) => {
            cell.cellElement.classList.remove("class-tandai-salah");
          });

          this.tandaiSalah(e.data.id, false);
        } else {
          if (!e.data.status_gaji) {
            e.rowElement.classList.add("class-tandai-salah");
            e.cells.forEach((cell) => {
              cell.cellElement.classList.add("class-tandai-salah");
            });

            this.tandaiSalah(e.data.id, true);
          }
        }
      }
    },

    async tandaiSalah(gajiId, tandaiSalah, url = "gaji") {
      // var notifBaru = this.notif["salah"];
      // if (tandaiSalah) notifBaru += 1;
      // else notifBaru -= 1;

      if (tandaiSalah) this.notif["salah"] += 1;
      else this.notif["salah"] -= 1;

      const updatedData = {
        tandai_salah: tandaiSalah,
        updated_by_user_id: auth.getUser().id,
      };
      const config = {
        headers: {
          Authorization: api.defaults.headers.common["Authorization"],
          "content-type": "application/json",
        },
      };
      try {
        const response = await axios.put(
          `${API_BASE_URL}/${url}/${gajiId}`,
          updatedData,
          config,
        );
        if (response.data.status) {
          // this.notif = await this.fetchDataNotif();
          // this.notif["salah"] = notifBaru;
        } else {
          notify("Gagal update gaji", "error");
        }
      } catch (error) {
        console.log(error);
        notify("Gagal update gaji", "error");
      }
    },

    async refreshNotif() {
      this.notif = await this.fetchDataNotif();
    },

    test(e) {
      console.log("test", e);
    },

    async approveGaji(gajiId, gridRef) {
      var notifBaru = this.notif["approved"];
      notifBaru += 1;
      var notifBaruSalah = this.notif["salah"];
      notifBaruSalah -= 1;
      if (notifBaruSalah < 0) notifBaruSalah = 0;

      const updatedData = {
        status_gaji: true,
        tandai_salah: false,
        approved_by_user_id: auth.getUser().id,
        approved_at: DateTime.now().toFormat("yyyy-MM-dd HH:mm:ss"),
      };
      const config = {
        headers: {
          Authorization: api.defaults.headers.common["Authorization"],
          "content-type": "application/json",
        },
      };

      let model = "gaji";
      if (gridRef === "gridRefDewas" || gridRef === "gridRefDewasSekre")
        model = "dewasGaji";
      try {
        const response = await axios.put(
          `${API_BASE_URL}/${model}/${gajiId}`,
          updatedData,
          config,
        );
        if (response.data.status) {
          // this.notif = await this.fetchDataNotif();
          this.notif["approved"] = notifBaru;
          this.notif["salah"] = notifBaruSalah;
          return true;
        } else {
          notify("Gagal update gaji", "error");
          return false;
        }
      } catch (error) {
        console.log(error);
        notify("Gagal update gaji", "error");
        return false;
      }
    },
    buttonStatus(method) {
      // var type = this.gajiStatusSource.find(
      //   (g) => g.id === this.gajiPeriodeData.gaji_status_id
      // ).warna;

      var type = this.commonStore.penggajianStatusStore.find(
        (g) => g.id === this.gajiPeriodeData.gaji_status_id,
      ).warna;

      // var text = this.gajiStatusSource.find(
      //   (g) => g.id === this.gajiPeriodeData.gaji_status_id
      // ).nama;

      var text = this.commonStore.penggajianStatusStore.find(
        (g) => g.id === this.gajiPeriodeData.gaji_status_id,
      ).nama;

      if (method === "type") return type;
      else return text;
    },

    buttonCan(permiss) {
      if (this.can("superadmin")) return true;
      if (this.gajiPeriodeData.gaji_status_id == 3) {
        //approved
        return false;
      }
      if (
        this.gajiPeriodeData.gaji_status_id == 1 ||
        this.gajiPeriodeData.gaji_status_id == 4
      ) {
        //open/revision
        if (this.can("gaji-approve") && permiss === "gaji-approve")
          return false;
        if (this.can("gaji-create") && permiss === "gaji-create") return true;
        if (this.can("gaji-update") && permiss === "gaji-update") return true;
        else return false;
      }

      if (this.gajiPeriodeData.gaji_status_id == 2) {
        //request approve

        if (this.can("gaji-approve") && permiss === "gaji-approve") return true;
        else return false;
      }

      return true;
    },
    async sinkronAllGaji(updatedData) {
      const config = {
        headers: {
          Authorization: api.defaults.headers.common["Authorization"],
          "content-type": "application/json",
        },
      };
      await axios
        .post(`${API_BASE_URL}/sinkron_all_gaji`, updatedData, config)
        .then((response) => {
          if (response.data.status) {
            notify("Daftar gaji berhasil disinkron", "success");
            this.refreshAllGrid();
          } else {
            notify("Daftar gaji gagal disinkron", "error");
          }
        })
        .catch((error) => {
          console.log(error);
          notify("Daftar gaji gagal disinkron", "error");
        });
    },
    approveAllGajiAlert() {
      this.popupWarningVisible = true;
      this.popupWarningTitle = "Konfirmasi";
      this.popupWarningContent =
        "Anda yakin ingin melakukan Approve Semua Gaji? Gaji yang sudah di approve tidak dapat diubah.";
      //
      this.popupWarningStatusId = 3;
    },
    requestRevisionAlert() {
      this.popupWarningVisible = true;
      this.popupWarningTitle = "Konfirmasi";
      this.popupWarningContent =
        "Anda yakin ingin melakukan Request Revisi Gaji? Gaji akan dikembalikan kepada pegawai untuk direvisi.";
      this.popupWarningStatusId = 4;
    },
    requestApprovalAlert() {
      this.popupWarningVisible = true;
      this.popupWarningTitle = "Konfirmasi";
      this.popupWarningContent =
        "Anda yakin ingin melakukan Request Approval Gaji? Gaji akan diserahkan kepada Pejabat untuk diperiksa. Anda tidak dapat mengubah data selama proses pemeriksaan gaji berlangsung.";
      this.popupWarningStatusId = 2; //requestapprov
    },
    updateStatusGajiPeriode(statusBaru) {
      const updatedData = {
        gaji_status_id: statusBaru,
      };
      const config = {
        headers: {
          Authorization: api.defaults.headers.common["Authorization"],
          "content-type": "application/json",
        },
      };
      axios
        .put(
          `${API_BASE_URL}/gajiPeriode/${this.gajiPeriodeId}`,
          updatedData,
          config,
        )
        .then((response) => {
          if (response.data.status) {
            notify("Berhasil Update Status Penggajian", "success");
            const url = this.$router.resolve({
              name: "gaji-periode",
            }).href;

            window.location.href = url;
          } else {
            notify("Gagal Update Status Penggajian Gaji", "error");
          }
          // Handle success response
        })
        .catch((error) => {
          console.error("Error updating:", error);
          // Handle error
          notify("Gagal Update Status Penggajian Gaji", "error");
        });
    },
    async refreshAllGaji() {
      //1. ambil perubahan gajiPeriode terbaru OK
      //2. panggil axios refreshAllGaji
      //3. pass gajiPeriode terbaru ke axios
      // 4. update gajiPeriode berdasarkan data terbaru (lihat apakah update tgl berubah) OK
      //5. delete all gaji where gaji_periode_id = x ok
      //6. loading page ok
      //7. panggil lagi api untuk post gaji ok
      //8. return ke gajiperiode

      this.gajiPeriodeData.updated_by_user_id = auth.getUser().id;

      try {
        this.popupLoadingVisible = true;
        const response = await axios.post(
          `${API_BASE_URL}/refresh_all_gaji`,
          this.gajiPeriodeData,
          {
            headers: {
              Authorization: api.defaults.headers.common["Authorization"],
              "Content-Type": "application/json",
            },
          },
        );

        if (response.data.status) {
          this.popupLoadingVisible = false;
          this.popupRefreshAllGajiVisible = false;
          notify("Berhasil Hitung Ulang Gaji Seluruh Pegawai", "success");
          window.location.reload();
        } else {
          this.popupLoadingVisible = false;
          this.popupRefreshAllGajiVisible = false;
          notify("Gagal Hitung Ulang Gaji Seluruh Pegawai", "error");
        }
      } catch (error) {
        this.popupLoadingVisible = false;
        this.popupRefreshAllGajiVisible = false;
        notify("Gagal Hitung Ulang Gaji Seluruh Pegawai", "error");
        console.error("Error update data:", error);
      }
    },
    async refreshGajiPerPegawai(table = "gaji") {
      this.gajiPeriodeData.updated_by_user_id = auth.getUser().id;
      let data; // Declare `data` in the outer scope
      if (table === "dewas") {
        data = {
          gaji_periode_id: this.gajiPeriodeData.id,
          dewas_id: this.rowClickData.row.data.dewas_id,
          gaji_id: this.rowClickData.row.data.id,
          edited_by_user_id: auth.getUser().id,
          updated_by_user_id: auth.getUser().id,
        };
      } else {
        data = {
          gaji_periode_id: this.gajiPeriodeData.id,
          pegawai_id: this.rowClickData.row.data.pegawai_id,
          gaji_id: this.rowClickData.row.data.id,
          edited_by_user_id: auth.getUser().id,
          updated_by_user_id: auth.getUser().id,
        };
      }

      try {
        const response = await axios.post(
          `${API_BASE_URL}/generate_gaji_per_pegawai`,
          data,
          {
            headers: {
              Authorization: api.defaults.headers.common["Authorization"],
              "Content-Type": "application/json",
            },
          },
        );

        if (response.data.status) {
          notify(response.data.message, "success");
          // window.location.reload();
        } else {
          notify(response.data.message, "error");
        }
      } catch (error) {
        notify("Gagal Hitung Ulang Gaji  Pegawai", "error");
        console.error("Error update data:", error);
      }

      this.$refs[this.rowClickRef].instance.refresh();
    },
    refreshGajiPerPegawaiConfirm(e, ref = "gridRef") {
      // return;
      this.popupWarningVisible = true;
      let nama = "";
      this.popupWarningStatusId = "refreshGajiPerPegawaiConfirm";
      if (ref === "gridRefDewas" || ref === "gridRefDewasSekre") {
        nama = e.row.data.dewas_nama;
        this.popupWarningStatusId = "refreshGajiPerDewasConfirm";
      } else {
        nama = e.row.data.simpeg_pegawais_nama;
      }

      this.popupWarningTitle = "Konfirmasi Hitung Ulang Gaji " + nama;
      this.popupWarningContent =
        "Anda yakin ingin melakukan Hitung Ulang Gaji " +
        nama +
        "? Perubahan data yang Anda lakukan akan hilang.";

      this.rowClickData = e;
      this.rowClickRef = ref;
    },
    refreshAllGajiConfirm() {
      this.popupWarningVisible = true;
      this.popupWarningTitle = "Konfirmasi Hitung Ulang Seluruh Gaji";
      this.popupWarningContent =
        "Anda yakin ingin melakukan Hitung Ulang Seluruh Gaji? Perubahan data gaji yang Anda lakukan akan hilang.";
      this.popupWarningStatusId = "refreshAllGajiConfirm";
    },
    async refreshAllGrid() {
      // this.$refs["gridRefTetap"].instance.getDataSource().reload();
      // this.$refs["gridRefTetap"].instance.getDataSource().reload();
      // this.$refs["gridRefHonor"].instance.getDataSource().reload();
      // this.$refs["gridRefKontrak"].instance.getDataSource().reload();
    },
    handleClickNotif(e) {
      if (e === "approved") {
        this.opacitySalah = 1;
        this.opacityApproved = 0.6;
        this.opacityJmlPegawai = 1;
        this.filterValue = ["status_gaji", "=", true];
      } else if (e === "salah") {
        this.opacitySalah = 0.6;
        this.opacityApproved = 1;
        this.opacityJmlPegawai = 1;
        this.filterValue = ["tandai_salah", "=", true];
      } else {
        this.filterValue = [];
        this.opacitySalah = 1;
        this.opacityApproved = 1;
        this.opacityJmlPegawai = 0.6;
      }
      this.refreshAllGrid();
    },
    async fetchDataNotif() {
      try {
        const response = await axios.post(
          `${API_BASE_URL}/rangkuman_gaji_list`,
          this.gajiPeriodeId,
          {
            headers: {
              Authorization: api.defaults.headers.common["Authorization"],
              "Content-Type": "application/json",
            },
          },
        );
        return response.data;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },
    async fetchGaji(
      table,
      $gajiPeriodeId = null,
      $pegawaiStatusId = null,
      $pegawaiStatusIdAlt = null,
    ) {
      var data = {
        table: table,
        gaji_periode_id: $gajiPeriodeId,
        pegawai_status_id: $pegawaiStatusId,
        pegawai_status_id_alt: $pegawaiStatusIdAlt,
      };
      try {
        const response = await axios.post(`${API_BASE_URL}/fetch_gaji`, data, {
          headers: {
            Authorization: api.defaults.headers.common["Authorization"],
            "Content-Type": "application/json",
          },
        });
        return response.data;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },

    async fetchDataPeriode() {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/gajiPeriode/${this.gajiPeriodeId}`,
          {
            headers: {
              Authorization: api.defaults.headers.common["Authorization"],
              "Content-Type": "application/json",
            },
          },
        );
        return response.data;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },

    calculateCellMK(e) {
      //TODO nyari masa kerja bukan dari tgl sekarang, melainkan tgl pembuatan gaji
      const today = DateTime.fromISO(e.tgl_gaji);
      const tglMulaiKerja = DateTime.fromISO(e.pegawai.tgl_mulai_bekerja);

      const month = tglMulaiKerja.month + 1; // Months are zero-based, so add 1
      const year = tglMulaiKerja.year;

      var tglMk;
      if ((month >= 11 && month <= 12) || (month >= 1 && month <= 4)) {
        // If the month is between November and April (inclusive), set the date to April 1st
        tglMk = DateTime.fromObject({ year: year, month: 4, day: 1 });
      } else if (month >= 3 && month <= 10) {
        // If the month is between March and October (inclusive), set the date to October 1st
        tglMk = DateTime.fromObject({ year: year, month: 10, day: 1 });
      } else {
        // Handle other cases as needed
        tglMk = tglMulaiKerja;
      }
      return Math.floor(today.diff(tglMk, "years").years);
    },

    can,
    refreshDatagrid(gridRef) {
      // this.$refs[gridRef].instance.clearFilter();
      this.$refs[gridRef].instance.getDataSource().reload();
    },
    detailPegawai(e, url = null) {
      // const url = this.$router.resolve({
      //   name: "pegawai-detail-custom",
      //   query: { id: e.row.data.pegawai_id },
      // }).href;
      // window.open(url, "_blank");

      const routeConfig = url
        ? {
            name: url,
            query: { id: e.row.data.dewas_id },
          }
        : {
            name: "pegawai-detail-custom",
            query: { id: e.row.data.pegawai_id },
          };

      const resolvedUrl = this.$router.resolve(routeConfig).href;
      window.open(resolvedUrl, "_blank");
    },
    detailAbsen(e) {
      const url = this.$router.resolve({
        name: "absen-list-custom",
        query: {
          filter: ["absen_bulans_id", "=", e.row.data.absen_bulan_id],
        },
      }).href;
      window.open(url, "_blank");
    },
    async updateKetGaji(gajiId, data) {
      try {
        const updatedData = {
          ket: data,
        };
        const config = {
          headers: {
            Authorization: api.defaults.headers.common["Authorization"],
            "content-type": "application/json",
          },
        };
        const response = await axios.put(
          `${API_BASE_URL}/gaji/${gajiId}`,
          updatedData,
          config,
        );

        if (response.data.status) {
          notify("Berhasil Update Gaji", "success");
          return response.data;
        } else {
          notify("Gagal update gaji (ket: " + data + ")", "error");
          return response.data;
        }
      } catch (error) {
        // Handle the error appropriately
        console.error("Error:", error);
        notify("Gagal update gaji " + error, "error");
        return false; // If there was an error
      }
    },
    async onRowUpdating(e) {
      var length = Object.keys(e.newData).length;
      if (length == 1 && "ket" in e.newData) {
        //pakai odataa
        e.newData.updated_by_user_id = auth.getUser().id;
      } else {
        e.cancel = true;
        await this.hitungUlangFieldGaji(e.key, e.newData, e.oldData);

        e.component.cancelEditData();

        e.component.refresh();
      }
      if (!("ket" in e.newData)) {
        //field catatan/ket bisa diupdate melalui odata biasa tnapa harus hitung ulang gaji
        //selain itu, setelah update row harus calculate ulang field lain yang rumusnya berkaitan dengan currenteditingfield
        //call hitung_ulang_field_gaji
        //harus di cancel true dulu karena menunggu calculate ulang, setelah await sudah selesai
        //baru refresh component
      }

      return;
    },

    async hitungUlangFieldGaji(key, newData, oldData) {
      try {
        const config = {
          headers: {
            Authorization: api.defaults.headers.common["Authorization"],
            "content-type": "application/json",
          },
        };

        let data; // Declare `data` in the outer scope
        if ("pegawai_id" in oldData) {
          data = {
            id: key,
            pegawai_id: oldData.pegawai_id,
            tgl_gaji: oldData.tgl_gaji,
            absen_bulan_id: oldData.absen_bulan_id,
            changes: newData,
            proyeksi: false,
            edited_by_user_id: auth.getUser().id,
            updated_by_user_id: auth.getUser().id,
          };
        } else {
          data = {
            id: key,
            dewas_id: oldData.dewas_id,
            tgl_gaji: oldData.tgl_gaji,
            changes: newData,
            proyeksi: false,
            edited_by_user_id: auth.getUser().id,
            updated_by_user_id: auth.getUser().id,
          };
        }

        const response = await axios.post(
          `${API_BASE_URL}/refresh_gaji_per_pegawai`,
          data,
          config,
        );
        // You can access the response data using response.data
        if (response.data.status) {
          notify(response.data.message, "success");
          return response.data;
        } else {
          notify("Gagal update gaji pegawai", "error");
          return response.data;
        }
        // You can perform other operations here based on the response data
        // ...
      } catch (error) {
        // Handle the error appropriately
        console.error("Error:", error);
        notify("Gagal update gaji pegawai " + error, "error");
        return false; // If there was an error
      }
    },

    async saveEditedDataToOData(key, newData, oldData) {
      try {
        const config = {
          headers: {
            Authorization: api.defaults.headers.common["Authorization"],
            "content-type": "application/json",
          },
        };
        var data = {
          id: key,
          pegawai_id: oldData.pegawai_id,
          tgl_gaji: oldData.tgl_gaji,
          absen_bulan_id: oldData.absen_bulan_id,
          changes: newData,
          proyeksi: false,
        };
        const response = await axios.post(
          `${API_BASE_URL}/refresh_gaji_per_pegawai`,
          data,
          config,
        );
        // You can access the response data using response.data
        if (response.data.status) {
          notify(response.data.message, "success");
          return response.data;
        } else {
          notify("Gagal update gaji pegawai", "error");
          return response.data;
        }
        // You can perform other operations here based on the response data
        // ...
      } catch (error) {
        // Handle the error appropriately
        console.error("Error:", error);
        notify("Gagal update gaji pegawai " + error, "error");
        return false; // If there was an error
      }
    },

    async saveEditedDataToOData2(key, newData, oldData) {
      const config = {
        headers: {
          Authorization: api.defaults.headers.common["Authorization"],
          "content-type": "application/json",
        },
      };
      var data = {
        id: key,
        pegawai_id: oldData.pegawai_id,
        tgl_gaji: oldData.tgl_gaji,
        absen_bulan_id: oldData.absen_bulan_id,
        changes: newData,
      };
      return await axios
        .post(`${API_BASE_URL}/refresh_gaji_per_pegawai`, data, config)
        .then((response) => {
          notify(response.data.message, "success");
        })
        .catch((error) => {
          console.log(error);
          notify("gagal update gaji", "error");
        });
    },
    oneditorpreparing: function (e) {
      if (e.parentType === "dataRow") {
        if (e.row.data.status_gaji) e.editorOptions.disabled = true;
        else {
          if (e.class == "noteditable") e.editorOptions.disabled = true;
          else if (e.class == "noteditable-gaji" && this.can("gaji-update"))
            e.editorOptions.disabled = false;
          else if (e.class == "noteditable-gaji" && !this.can("gaji-update"))
            e.editorOptions.disabled = true;
          else if (e.class == "noteditable-ket" && this.can("gaji-approve"))
            e.editorOptions.disabled = false;
          else if (e.class == "noteditable-ket" && !this.can("gaji-approve"))
            e.editorOptions.disabled = true;
        }
      }

      if (e.dataField === "tgl_gaji") {
        e.editorOptions.calendarOptions = {
          minZoomLevel: "year",
          maxZoomLevel: "year",
          displayFormat: "MM/yyyy",
          type: "month",
        };
      }
    },

    async approveAll(tab) {
      const config = {
        headers: {
          Authorization: api.defaults.headers.common["Authorization"],
          "content-type": "application/json",
        },
      };
      var data = {};

      if (tab == "tDireksi") {
        data = {
          pegawai_status_id: 1,
          pegawai_status_nama: "Direksi",
        };
      } else if (tab == "tTetap") {
        data = {
          pegawai_status_id: 2,
          pegawai_status_nama: "Pegawai Tetap",
        };
      } else if (tab == "tCapeg") {
        data = {
          pegawai_status_id: 3,
          pegawai_status_nama: "Calon Pegawai",
        };
      } else if (tab == "tHonor") {
        data = {
          pegawai_status_id: 4,
          pegawai_status_nama: "Pekerja Honor",
        };
      } else if (tab == "tKontrak") {
        data = {
          pegawai_status_id: 5,
          pegawai_status_nama: "Pekerja Kontrak",
        };
      }

      await axios
        .post(`${API_BASE_URL}/gaji_approve_all`, data, config)
        .then((response) => {
          notify(response.data.message, "success");
        })
        .catch((error) => {
          console.log(error);
          notify("Gagal approve gaji", "error");
        });
    },

    async approveGaji2(gajiId) {
      const config = {
        headers: {
          Authorization: api.defaults.headers.common["Authorization"],
          "content-type": "multipart/form-data",
        },
      };
      var data = {
        id: gajiId,
      };

      axios
        .post(`${API_BASE_URL}/gaji_approve`, data, config)
        .then((response) => {
          notify(response.data.message, "success");
          return true;
        })
        .catch((error) => {
          notify("Gagal approve gaji", "error");
          console.log(error);
          return false;
        });
    },
    formatStatusGaji(method, value) {
      if (value.data.data.status_gaji) {
        if (method == "icon") return "lock";
        if (method == "type") return "success";
      } else {
        if (method == "icon") return "warning";
        if (method == "type") return "danger";
      }
      return;
    },

    calculateDisplayMK(e) {
      const today = DateTime.fromISO(e.tgl_gaji);
      const date2 = DateTime.fromISO(e.riwayatGolongan.tgl_mulai_bekerja);
      return Math.floor(today.diff(date2, "years").years) + " tahun";
    },

    formatMonthTitle(e) {
      const date = DateTime.fromISO(e).setLocale("id");
      return date.monthLong + " " + date.year;
    },

    onPageChanged(e, gridRef) {
      if (e.fullName == "paging.pageIndex") {
        this.numberingPageSize = this.$refs[gridRef].instance.pageSize();
        this.numberingPageNumber = e.value;
      }
    },
    onExporting(e) {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet("Gaji");

      exportDataGrid({
        component: e.component,
        worksheet,
        autoFilterEnabled: true,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(
            new Blob([buffer], { type: "application/octet-stream" }),
            "Gaji " + this.tabSource[this.tabPanelIndex].text + ".xlsx",
          );
        });
      });
      e.cancel = true;
    },
  },
};
</script>
